/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum WebhookParameterSource {
  Constant = 'Constant',
  Body = 'Body',
  BodyField = 'BodyField',
  Header = 'Header',
  Parameter = 'Parameter',
}

export enum WebServiceLoggingAction {
  Alwayssave = 'alwayssave',
  Savefailures = 'savefailures',
  Savesuccesses = 'savesuccesses',
  None = 'none',
}

export enum UiType {
  WindowsUi = 'WindowsUi',
  WindowsService = 'WindowsService',
  WcfService = 'WcfService',
  WebUi = 'WebUi',
  WebApi = 'WebApi',
  LocalService = 'LocalService',
  ExcelAddin = 'ExcelAddin',
}

export enum TextFileFormat {
  None = 'None',
  CsvDelimited = 'CsvDelimited',
  TabDelimited = 'TabDelimited',
  PipeDelimited = 'PipeDelimited',
  CustomDelimited = 'CustomDelimited',
  SpaceDelimited = 'SpaceDelimited',
  FixedLength = 'FixedLength',
}

export enum TextFileEncoding {
  None = 'None',
  ASCII = 'ASCII',
  Unicode = 'Unicode',
  UTF7 = 'UTF7',
  UTF8 = 'UTF8',
  UTF16 = 'UTF16',
  UTF32 = 'UTF32',
}

export enum TextFileDataType {
  Bit = 'Bit',
  Byte = 'Byte',
  Char = 'Char',
  Currency = 'Currency',
  Date = 'Date',
  Float = 'Float',
  Integer = 'Integer',
  LongChar = 'LongChar',
  Short = 'Short',
  Single = 'Single',
}

export enum TextFileCharacterSet {
  OEM = 'OEM',
  ANSI = 'ANSI',
  UTF8 = 'UTF8',
}

export enum TenantType {
  Crm = 'crm',
  Finops = 'finops',
  Ftp = 'ftp',
  Generic = 'generic',
  Gp = 'gp',
  Msgraph = 'msgraph',
  Mssql = 'mssql',
  Mysql = 'mysql',
  Navodata = 'navodata',
  Netsuite = 'netsuite',
  Popdock = 'popdock',
  Postgresql = 'postgresql',
  Rest = 'rest',
  Salesforce = 'salesforce',
}

export enum TeamRole {
  Reader = 'Reader',
  Contributor = 'Contributor',
  Administrator = 'Administrator',
}

export enum TaskTypes {
  MapDataCheck = 'MapDataCheck',
  MapPre = 'MapPre',
  DocumentPre = 'DocumentPre',
  DocumentPostSuccess = 'DocumentPostSuccess',
  DocumentPostFailure = 'DocumentPostFailure',
  MapPostSuccess = 'MapPostSuccess',
  MapPostFailure = 'MapPostFailure',
}

export enum TaskResult {
  Cancel = 'Cancel',
  Quit = 'Quit',
  Continue = 'Continue',
}

export enum SummaryMessageType {
  Create = 'create',
  Update = 'update',
  Complete = 'complete',
  Cancelled = 'cancelled',
}

export enum StatusCodeCheckType {
  AllInstances = 'AllInstances',
  HasContent = 'HasContent',
  NoContent = 'NoContent',
  ContainsString = 'ContainsString',
  DoesNotContainString = 'DoesNotContainString',
  DoesNotContainField = 'DoesNotContainField',
}

export enum SourceType {
  Change = 'change',
  File = 'file',
  Query = 'query',
  Realtime = 'realtime',
  Restapi = 'restapi',
  Restwebhook = 'restwebhook',
  Composite = 'composite',
}

export enum ScriptOptions {
  CSharp = 'CSharp',
  VisualBasic = 'VisualBasic',
  JavaScript = 'JavaScript',
}

export enum ScriptLanguage {
  CSharp = 'CSharp',
  Popdock = 'Popdock',
  Sql = 'Sql',
  JsonPath = 'JsonPath',
  XPath = 'XPath',
}

export enum SalesforceRealtimeCallbackType {
  CallbackContainsId = 'callbackContainsId',
  CallbackContainsData = 'callbackContainsData',
}

export enum SalesforceCredentialRole {
  Provisioning = 'provisioning',
  DataAccess = 'dataAccess',
}

export enum RestrictionType {
  DoesNotEqual = 'DoesNotEqual',
  Equals = 'Equals',
  GreaterThan = 'GreaterThan',
  LessThan = 'LessThan',
  GreaterThanOrEqualTo = 'GreaterThanOrEqualTo',
  LessThanOrEqualTo = 'LessThanOrEqualTo',
  Contains = 'Contains',
  StartsWith = 'StartsWith',
  EndsWith = 'EndsWith',
  DoesNotContain = 'DoesNotContain',
  DoesNotStartWith = 'DoesNotStartWith',
  DoesNotEndWith = 'DoesNotEndWith',
  Between = 'Between',
  NotBetween = 'NotBetween',
  OneOf = 'OneOf',
  NotOneOf = 'NotOneOf',
  ContainsOneOf = 'ContainsOneOf',
  DoesNotContainOneOf = 'DoesNotContainOneOf',
  StartsWithOneOf = 'StartsWithOneOf',
  DoesNotStartWithOneOf = 'DoesNotStartWithOneOf',
  EndsWithOneOf = 'EndsWithOneOf',
  DoesNotEndWithOneOf = 'DoesNotEndWithOneOf',
  Null = 'Null',
  NotNull = 'NotNull',
  Is = 'Is',
  AnyOf = 'AnyOf',
  Empty = 'Empty',
  On = 'On',
  RowEntirelyBlank = 'RowEntirelyBlank',
}

export enum RestrictionConjunctive {
  None = 'None',
  And = 'And',
  Or = 'Or',
}

export enum RestJoinBehavior {
  Left = 'Left',
  Inner = 'Inner',
}

export enum RequestMethod {
  Inherit = 'Inherit',
  Get = 'Get',
  Post = 'Post',
  Put = 'Put',
  Patch = 'Patch',
  Delete = 'Delete',
}

export enum RealtimeEntityEvents {
  ForCreate = 'ForCreate',
  ForUpdate = 'ForUpdate',
  ForDelete = 'ForDelete',
  All = 'All',
}

export enum ProcessMetaDataItemType {
  DateFormat = 'DateFormat',
  GlobalRolling = 'GlobalRolling',
  TranslationTable = 'TranslationTable',
}

export enum PlaceholderType {
  Calculation = 'calculation',
  Global = 'global',
  Date = 'date',
  Variable = 'variable',
}

export enum OdataApiDestinationType {
  Service = 'Service',
  Action = 'Action',
}

export enum NotificationScope {
  None = 'None',
  User = 'User',
  Admin = 'Admin',
  Global = 'Global',
}

export enum NodeReorder {
  All = 'All',
  None = 'None',
  ParentsOnly = 'ParentsOnly',
  ParentsAndChildren = 'ParentsAndChildren',
}

export enum NavigationTypes {
  Collection = 'Collection',
  OneToOne = 'OneToOne',
}

export enum NavOperator {
  Equals = 'Equals',
  NotEquals = 'NotEquals',
  Bigger = 'Bigger',
  Smaller = 'Smaller',
  Begin = 'Begin',
  End = 'End',
  Contains = 'Contains',
  GreaterEqual = 'GreaterEqual',
  LessEqual = 'LessEqual',
}

export enum MssqlAuthenticationType {
  SqlLogin = 'SqlLogin',
  EntraServicePrincipal = 'EntraServicePrincipal',
}

export enum MsGpAuthenticationType {
  Sql = 'Sql',
  GatewayBasic = 'GatewayBasic',
  GatewayToken = 'GatewayToken',
}

export enum MetadataRefreshMode {
  RefreshAll = 'RefreshAll',
  RefreshEntities = 'RefreshEntities',
  AddNew = 'AddNew',
}

export enum MapVariableValueType {
  String = 'String',
  Number = 'Number',
  Date = 'Date',
  DateTime = 'DateTime',
  Boolean = 'Boolean',
}

export enum MapRunType {
  ExcelAddin = 'ExcelAddin',
  App = 'App',
  Scheduled = 'Scheduled',
  WebApi = 'WebApi',
  Realtime = 'Realtime',
}

export enum MapRunStatus {
  Starting = 'starting',
  IntegrationLoading = 'integrationLoading',
  IntegrationLoaded = 'integrationLoaded',
  Setup = 'setup',
  PreTasks = 'preTasks',
  LoadingData = 'loadingData',
  ProcessingSetup = 'processingSetup',
  Processing = 'processing',
  PostTasks = 'postTasks',
  Cancelling = 'cancelling',
  Cancelled = 'cancelled',
  Complete = 'complete',
  Locked = 'locked',
  Error = 'error',
}

export enum MapLineGroupByOption {
  Enable = 'Enable',
  Disable = 'Disable',
  EnforceIfUpdate = 'EnforceIfUpdate',
  Enforce = 'Enforce',
}

export enum LookupColumnNoData {
  Continue = 'Continue',
  DefaultValue = 'DefaultValue',
  StopLine = 'StopLine',
  StopIntegration = 'StopIntegration',
  ReturnSource = 'ReturnSource',
  ReturnNull = 'ReturnNull',
  RestrictIfNoData = 'RestrictIfNoData',
  RestrictIfData = 'RestrictIfData',
  ClearLookup = 'ClearLookup',
}

export enum GenericRestLookupMappableObjectType {
  Header = 'Header',
  Parameter = 'Parameter',
  Variable = 'Variable',
}

export enum FileDataSourceSourceLocationType {
  None = 'none',
  Runtime = 'runtime',
  Ftp = 'ftp',
  Onedrive = 'onedrive',
  Outlook = 'outlook',
  Sharepoint = 'sharepoint',
  Teams = 'teams',
  Dropbox = 'dropbox',
  Googledrive = 'googledrive',
}

export enum FieldType {
  Unknown = 'Unknown',
  String = 'String',
  Date = 'Date',
  Currency = 'Currency',
  Integer = 'Integer',
  Phone = 'Phone',
  Enum = 'Enum',
  Percentage = 'Percentage',
  YesNo = 'YesNo',
  Time = 'Time',
  Quantity = 'Quantity',
  Email = 'Email',
  Url = 'Url',
  Image = 'Image',
  Skype = 'Skype',
  Twitter = 'Twitter',
  Color = 'Color',
  Address = 'Address',
  Text = 'Text',
  Guid = 'Guid',
  Icon = 'Icon',
  TimeSpan = 'TimeSpan',
  StringList = 'StringList',
  IntegerList = 'IntegerList',
  File = 'File',
  Dimension = 'Dimension',
  Array = 'Array',
  DateTime = 'DateTime',
  Lookup = 'Lookup',
  Boolean = 'Boolean',
  Float = 'Float',
  CustomFieldArray = 'CustomFieldArray',
  ValueArray = 'ValueArray',
}

export enum EventLogEntityType {
  ConnectorInstance = 'ConnectorInstance',
  DataSource = 'DataSource',
  Process = 'Process',
  RealtimeRenewal = 'RealtimeRenewal',
  RealtimeStaging = 'RealtimeStaging',
  Schedule = 'Schedule',
  RealtimeRejection = 'RealtimeRejection',
}

export enum DynAuthenticationType {
  DynNav = 'DynNav',
  Dyn365Fin = 'Dyn365Fin',
}

export enum DocumentationType {
  Markdown = 'Markdown',
  Html = 'Html',
}

export enum DestinationType {
  ExcelFile = 'ExcelFile',
  FinOps = 'FinOps',
  GenericRest = 'GenericRest',
  Gp = 'Gp',
  JsonFile = 'JsonFile',
  MssqlStoredProc = 'MssqlStoredProc',
  MssqlTable = 'MssqlTable',
  MySqlStoredProc = 'MySqlStoredProc',
  MySqlTable = 'MySqlTable',
  PostgreStoredProc = 'PostgreStoredProc',
  PostgreTable = 'PostgreTable',
  MsNavOdataApi = 'MsNavOdataApi',
  MsNavOdataDeepInsert = 'MsNavOdataDeepInsert',
  MsNavOdata = 'MsNavOdata',
  NetSuite = 'NetSuite',
  Salesforce = 'Salesforce',
  TextFile = 'TextFile',
  XmlFile = 'XmlFile',
  CeDestination = 'CeDestination',
  FabricTable = 'FabricTable',
}

export enum DataSourceType {
  FinOpsOdataQuery = 'FinOpsOdataQuery',
  ExcelDataSource = 'ExcelDataSource',
  JsonDataSource = 'JsonDataSource',
  TextFileDataSource = 'TextFileDataSource',
  WebXmlDataSource = 'WebXmlDataSource',
  ExcelFolder = 'ExcelFolder',
  TextFolder = 'TextFolder',
  XmlFolder = 'XmlFolder',
  JsonFolder = 'JsonFolder',
  MssqlQueryDataSource = 'MssqlQueryDataSource',
  MssqlChangeDataSource = 'MssqlChangeDataSource',
  MssqlRealTimeDataSource = 'MssqlRealTimeDataSource',
  MySqlQueryDataSource = 'MySqlQueryDataSource',
  MySqlChangeDataSource = 'MySqlChangeDataSource',
  MySqlRealTimeDataSource = 'MySqlRealTimeDataSource',
  PostgreSqlQueryDataSource = 'PostgreSqlQueryDataSource',
  PostgreSqlChangeDataSource = 'PostgreSqlChangeDataSource',
  PostgreSqlRealTimeDataSource = 'PostgreSqlRealTimeDataSource',
  OdbcDataSource = 'OdbcDataSource',
  OledbDataSource = 'OledbDataSource',
  MsNavOdataApi = 'MsNavOdataApi',
  MsNavOdataChange = 'MsNavOdataChange',
  MsNavOdataBulk = 'MsNavOdataBulk',
  MsNavOdataRealTime = 'MsNavOdataRealTime',
  NetSuiteChange = 'NetSuiteChange',
  NetSuiteRealTime = 'NetSuiteRealTime',
  NetSuiteRestRealTime = 'NetSuiteRestRealTime',
  NetSuiteQuery = 'NetSuiteQuery',
  NetSuiteSuiteQLQuery = 'NetSuiteSuiteQLQuery',
  NetSuiteRESTletQuery = 'NetSuiteRESTletQuery',
  NetSuiteRestChange = 'NetSuiteRestChange',
  NetSuiteRestQuery = 'NetSuiteRestQuery',
  NetSuiteRestRealtime = 'NetSuiteRestRealtime',
  PopDockQuery = 'PopDockQuery',
  SalesForceChangeDataSource = 'SalesForceChangeDataSource',
  SalesForceQueryDataSource = 'SalesForceQueryDataSource',
  SalesForceRealTimeDataSource = 'SalesForceRealTimeDataSource',
  GenericRestDataSource = 'GenericRestDataSource',
  GenericRestRealtimeDataSource = 'GenericRestRealtimeDataSource',
  GpQueryDataSource = 'GpQueryDataSource',
  ExtenderBulkDataSource = 'ExtenderBulkDataSource',
  CeQueryDataSource = 'CeQueryDataSource',
  CeRealTimeDataSource = 'CeRealTimeDataSource',
  CeRealtimeDataSourceWebhook = 'CeRealtimeDataSourceWebhook',
  CeChangeDataSource = 'CeChangeDataSource',
  FabricQueryDataSource = 'FabricQueryDataSource',
  FabricChangeDataSource = 'FabricChangeDataSource',
  FabricRealTimeDataSource = 'FabricRealTimeDataSource',
  CompositeDataSource = 'CompositeDataSource',
}

export enum ConnectorProductType {
  File = 'file',
  Genericrest = 'genericrest',
  Legacy = 'legacy',
  Mscrm = 'mscrm',
  Msgp = 'msgp',
  Msfinops = 'msfinops',
  Msgraphodata = 'msgraphodata',
  Msnavodata = 'msnavodata',
  Mssql = 'mssql',
  Mysql = 'mysql',
  Dropbox = 'dropbox',
  Googledrive = 'googledrive',
  Postgresql = 'postgresql',
  Nav = 'nav',
  Netsuite = 'netsuite',
  Odbc = 'odbc',
  Oledb = 'oledb',
  Popdock = 'popdock',
  Rest = 'rest',
  Salesforce = 'salesforce',
  Ftp = 'ftp',
  Slack = 'slack',
  Trello = 'trello',
  Webservice = 'webservice',
  General = 'general',
  Other = 'other',
  Oracle = 'oracle',
  Fabric = 'fabric',
  Ramp = 'ramp',
  Shopify = 'shopify',
}

export enum ColumnType {
  Calculation = 'calculation',
  Crmactivityparty = 'crmactivityparty',
  Crmcolumnset = 'crmcolumnset',
  Crmentitylookup = 'crmentitylookup',
  Crmentityreference = 'crmentityreference',
  Crmlabel = 'crmlabel',
  Crmlookup = 'crmlookup',
  Crmmappedcolumnset = 'crmmappedcolumnset',
  Crmlistoptionlookup = 'crmlistoptionlookup',
  Crmrelationship = 'crmrelationship',
  Crmrestmultilookup = 'crmrestmultilookup',
  Customrolling = 'customrolling',
  Datasource = 'datasource',
  Date = 'date',
  Fabriclookup = 'fabriclookup',
  Finopslookup = 'finopslookup',
  Genericrestlookup = 'genericrestlookup',
  Globalrolling = 'globalrolling',
  List = 'list',
  Localconstant = 'localconstant',
  Navodataapilookup = 'navodataapilookup',
  Navodatafieldlookup = 'navodatafieldlookup',
  Mssqllookup = 'mssqllookup',
  Navpagefieldlookup = 'navpagefieldlookup',
  Navpagekeylookup = 'navpagekeylookup',
  Netsuitecustomlist = 'netsuitecustomlist',
  Netsuitelookup = 'netsuitelookup',
  Netsuitemultilookup = 'netsuitemultilookup',
  Netsuiterestletlookup = 'netsuiterestletlookup',
  Netsuiterestlookup = 'netsuiterestlookup',
  Netsuiterestlistoption = 'netsuiterestlistoption',
  Netsuiterestrecordreference = 'netsuiterestrecordreference',
  Netsuitesuiteqllookup = 'netsuitesuiteqllookup',
  Parentdatasource = 'parentdatasource',
  Postgrelookup = 'postgrelookup',
  Salesforcelookup = 'salesforcelookup',
  Salesforcesoqllookup = 'salesforcesoqllookup',
  Translation = 'translation',
  Gprolling = 'gprolling',
  Mysqllookup = 'mysqllookup',
  Gplookup = 'gplookup',
  Shopifylookup = 'shopifylookup',
  Ramplookup = 'ramplookup',
}

export enum ColumnFunction {
  Sum = 'Sum',
  Min = 'Min',
  Max = 'Max',
  First = 'First',
  Last = 'Last',
  Concat = 'Concat',
}

export enum CeAuthenticationType {
  ActiveDirectory = 'ActiveDirectory',
  OnlineFederation = 'OnlineFederation',
  Federation = 'Federation',
  OAuth = 'OAuth',
}

export enum CancelTrigger {
  App = 'App',
  TimeoutShortRun = 'TimeoutShortRun',
  TimeoutLongRun = 'TimeoutLongRun',
  Script = 'Script',
  WebApi = 'WebApi',
}

export enum CalculatedFieldType {
  UserExpression = 'UserExpression',
  RowNumber = 'RowNumber',
  GroupNumber = 'GroupNumber',
}

export enum CacheLevel {
  Run = 'Run',
  Document = 'Document',
  Row = 'Row',
}

export enum BodyType {
  Inherit = 'Inherit',
  JSON = 'JSON',
  XML = 'XML',
  Text = 'Text',
  UrlEncodedForm = 'UrlEncodedForm',
}

export enum BcCredentialTypes {
  Windows = 'Windows',
  UserName = 'UserName',
  NavUserPassword = 'NavUserPassword',
}

export enum AuditLogEntityType {
  IntegrationProcess = 'IntegrationProcess',
  DataSource = 'DataSource',
  ConnectorInstance = 'ConnectorInstance',
  User = 'User',
  Team = 'Team',
  PasswordPolicy = 'PasswordPolicy',
  AppRegistration = 'AppRegistration',
  RestSetup = 'RestSetup',
  RestEntity = 'RestEntity',
  RestAction = 'RestAction',
  RestLookup = 'RestLookup',
  RestWebhook = 'RestWebhook',
}

export enum AuditLogActionType {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
  Reorder = 'Reorder',
}

export type ConnectorInstanceBaseModel = BaseConnectorInstanceBaseModel &
  (
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'Dropbox', DropboxInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'MsFabric', FabricInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'FTP', FtpInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'GoogleDrive', GoogleDriveInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'MsGraphOdata', MsGraphInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'MsSql', MssqlInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'MySql', MySqlInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'Odbc', OdbcInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'Oledb', OledbInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'PostgreSql', PostgreSqlInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'SlackOdata', SlackInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'TrelloOdata', TrelloInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'MsNavOdata', MsNavOdataInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'Crm', CustomerEngagementInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'NetSuite', NetSuiteInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'GenericRest', GenericRestInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'SalesForce', SalesforceInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'MsFinOps', FinOpsInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'PopDock', PopdockInstanceModel>
    | BaseConnectorInstanceBaseModelInstanceTypeMapping<'MsGp', GpInstanceModel>
  );

export interface Account {
  /** @format uuid */
  accountId?: string;
  name?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  currency?: string;
  phone?: string;
  website?: string;
  status?: string;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  modified?: string;
  gpCustomerId?: string;
  crmCustomerId?: string;
  /** @format uuid */
  customerId?: string;
  /** @format int32 */
  passwordExpiryDays?: number;
  passwordMustContainUppercase?: boolean;
  passwordMustContainLowercase?: boolean;
  passwordMustContainNumber?: boolean;
  passwordMustContainNonAlpha?: boolean;
  passwordCannotContainRepeats?: boolean;
  passwordCannotContainSequences?: boolean;
  /** @format int32 */
  minimumPasswordLength?: number;
  /** @format int32 */
  previousPasswordsDisallowed?: number;
}

export interface AccountApiModel {
  /** @format uuid */
  customerId?: string;
  schedulerUri?: string;
  restUri?: string;
  oAuthRedirects?: AccountOAuthRedirectModel[];
}

export interface AccountOAuthRedirectModel {
  name?: string;
  uri?: string;
}

export interface AccountSwitchModel {
  /** @format uuid */
  customerId?: string;
  /** @format uuid */
  userId?: string;
  /** @format uuid */
  uamUserId?: string;
  /** @format uuid */
  regionId?: string;
  switchRegion?: boolean;
  accountName?: string;
  /** @format uuid */
  accountId?: string;
  redirectUri?: string;
  mfaEnabled?: boolean;
}

export interface AccountSwitchModelListBaseResponse {
  data?: AccountSwitchModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface AccountSwitchRequest {
  /** @format uuid */
  customerId?: string;
  code?: string;
  password?: string;
}

export interface AddBotUserToChannelRequest {
  /** @format uuid */
  connectorInstanceId?: string;
  slackChannelId?: string;
}

export interface ApiSettings {
  notificationApiRootUrl?: string;
}

export interface ApiSettingsBaseResponse {
  data?: ApiSettings;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface AppRegistrationModel {
  id?: string;
  name?: string;
  status?: string;
  isActive?: boolean;
  redirectUris?: AppRegistrationRedirectModel[];
  /** @format date-time */
  modified?: string;
  secrets?: AppRegistrationSecretModel[];
  allowServiceAuth?: boolean;
  serviceUserId?: string;
  scope?: string;
  availableUsers?: UserListModel[];
}

export interface AppRegistrationModelBaseResponse {
  data?: AppRegistrationModel;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface AppRegistrationRedirectModel {
  uri?: string;
}

export interface AppRegistrationSecretModel {
  id?: string;
  name?: string;
  secret?: string;
  /** @format date-time */
  expires?: string;
  /** @format date-time */
  modified?: string;
  tokens?: AppRegistrationTokenModel[];
}

export interface AppRegistrationSecretStubRequest {
  /** @format uuid */
  appRegistrationId?: string;
  name?: string;
  /** @format int32 */
  expiryType?: number;
  /** @format date-time */
  endDate?: string;
}

export interface AppRegistrationStubRequest {
  name?: string;
}

export interface AppRegistrationTokenModel {
  id?: string;
  type?: string;
  /** @format date-time */
  expires?: string;
  /** @format date-time */
  lastTokenIssued?: string;
}

export interface AuditLogDto {
  /** @format int64 */
  id?: string;
  entityType?: string;
  entityId?: string;
  customerId?: string;
  userId?: string;
  userName?: string;
  /** @format date-time */
  operateTime?: string;
  actionType?: AuditLogActionType;
}

export interface AuditLogDtoListBaseResponse {
  data?: AuditLogDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface AuditSettingItem {
  /** @format int32 */
  auditObject?: number;
  description?: string;
  enabled?: boolean;
}

export interface AuditSettingModel {
  items?: AuditSettingItem[];
}

export interface AuthenticatedProductAccountResponse {
  /** @format uuid */
  accountId?: string;
  name?: string;
  status?: string;
  currency?: string;
  subscriptionType?: string;
  eqa?: boolean;
  apiUri?: string;
  region?: AuthenticatedProductRegionResponse;
}

export interface AuthenticatedProductRegionResponse {
  /** @format uuid */
  regionId?: string;
  name?: string;
}

export interface BannerDto {
  type?: string;
  message?: string;
}

export interface BannerDtoListBaseResponse {
  data?: BannerDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface BaseResponse {
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface BooleanBaseResponse {
  data?: boolean;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface CancelRunningActivityRequest {
  /** @format uuid */
  runId?: string;
  /** @format uuid */
  mapKey?: string;
  reason?: string;
}

export interface CeChangeDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  hasQueryBuilder?: boolean;
  organizationName?: string;
  returnOptionSetsAsStrings?: boolean;
  filterFields?: string;
  fetchXml?: string;
  entityTechnicalName?: string;
  entityDescription?: string;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface CeDestinationAction {
  name?: string;
  displayName?: string;
  isBound?: boolean;
  bindingEntityLogicalName?: string;
  isCollectionBound?: boolean;
  returnType?: string;
  /** @format int32 */
  sequence?: number;
}

export interface CeDestinationEntity {
  /** @format uuid */
  id?: string;
  entityLogicalName?: string;
  entitySetName?: string;
  displayName?: string;
  parentNavigationName?: string;
  /** @format int32 */
  sequence?: number;
  fields?: CeDestinationField[];
  resultFields?: CeDestinationResultField[];
  childEntities?: CeDestinationEntity[];
  actions?: CeDestinationAction[];
}

export interface CeDestinationField {
  fieldName?: string;
  fieldType?: string;
  displayName?: string;
}

export interface CeDestinationModel {
  destinationType?: DestinationType;
  organizationName?: string;
  suppressDuplicateDetection?: boolean;
  includeAdvanced?: boolean;
  selectedMetaData?: string;
  rollbackTransaction?: boolean;
  removeBlankProperties?: boolean;
  entities?: CeDestinationEntity[];
  actions?: CeDestinationAction[];
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  toFile?: boolean;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface CeDestinationResultField {
  columnName?: string;
  fieldName?: string;
  /** @format int32 */
  noData?: number;
  defaultValue?: string;
  includeInGrouping?: boolean;
}

export interface CeOrganizationDetailModel {
  /** @format uuid */
  id?: string;
  friendlyName?: string;
  organizationVersion?: string;
  urlName?: string;
  uniqueName?: string;
  apiUrl?: string;
  url?: string;
}

export interface CeOrganizationMetadataState {
  uniqueName?: string;
  friendlyName?: string;
  urlName?: string;
  fetch?: boolean;
  fetched?: boolean;
  /** @format date-time */
  lastFetchedUtc?: string;
  lastError?: string;
  refreshing?: boolean;
  /** @format date-time */
  refreshingSinceUtc?: string;
}

export interface CeQueryDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  hasQueryBuilder?: boolean;
  organizationName?: string;
  returnOptionSetsAsStrings?: boolean;
  fetchXml?: string;
  masterTableEndpoint?: string;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface CeRealTimeDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  hasQueryBuilder?: boolean;
  organizationName?: string;
  returnOptionSetsAsStrings?: boolean;
  fetchXml?: string;
  filterAttributes?: string;
  entityTechnicalName?: string;
  entityDescription?: string;
  schemaString?: string;
  friendlyName?: string;
  name?: string;
  isRegistered?: boolean;
  allowCreate?: boolean;
  allowUpdate?: boolean;
  allowDelete?: boolean;
  allowAll?: boolean;
  callbackUri?: string;
  realTimeMapLinks?: RealTimeDataSourceMapLink[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface CeRealtimeDataSourceWebhookModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  hasQueryBuilder?: boolean;
  organizationName?: string;
  returnOptionSetsAsStrings?: boolean;
  fetchXml?: string;
  filterAttributes?: string;
  pluginTypeName?: string;
  entityTechnicalName?: string;
  entityDescription?: string;
  schemaString?: string;
  masterTableEndpoint?: string;
  friendlyName?: string;
  name?: string;
  isRegistered?: boolean;
  allowCreate?: boolean;
  allowUpdate?: boolean;
  allowDelete?: boolean;
  allowAll?: boolean;
  callbackUri?: string;
  realTimeMapLinks?: RealTimeDataSourceMapLink[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface ChangeDataSourceMaintenanceModel {
  /** @format uuid */
  id?: string;
  changeDataSourceType?: string;
  changeDataSourceTypeDisplayName?: string;
  removeUnProcessed?: boolean;
  removeTables?: boolean;
  /** @format int32 */
  removeUnProcessedDays?: number;
  lastRunResult?: boolean;
  lastError?: string;
  isActive?: boolean;
  /** @format date-time */
  lastRunDate?: string;
  /** @format date-time */
  runTime?: string;
  /** @format uuid */
  customerId?: string;
  /** @format uuid */
  userId?: string;
}

export interface ChangeDataSourceMaintenanceStubRequest {
  changeDataSourceType?: string;
}

export interface CheckMapNameDuplicateRequest {
  id?: string;
  mapName?: string;
}

export interface CheckNameRequest {
  /** @format uuid */
  id?: string;
  name?: string;
}

/**
 * Body for checking a (possibly unsaved) pipeline config against a refreshed field
 * list — surfaces broken references after a data source re-validation.
 */
export interface CheckPipelineReferencesRequest {
  config?: DataSourcePipelineConfig;
  fieldNames?: string[];
}

/** Response returned by the check-runtime-values endpoint. */
export interface CheckRuntimeValuesResponse {
  hasConflicts?: boolean;
  /**
   * One entry per conflict type that found at least one conflict. UI section order
   * matches list order, so backend controls the display sequence.
   */
  groups?: RuntimeValueConflictGroup[];
}

export interface CheckRuntimeValuesResponseBaseResponse {
  /** Response returned by the check-runtime-values endpoint. */
  data?: CheckRuntimeValuesResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface CloneMapRequest {
  /**
   * Source map Id
   * @format uuid
   */
  mapId?: string;
  /** Target map name */
  mapName?: string;
  /** Target map description */
  description?: string;
  /** create new data source */
  createNewSource?: boolean;
  /** data source name */
  sourceName?: string;
}

export interface ColumnBaseDto {
  id?: string;
  name?: string;
  typeDisplayName?: string;
  mapId?: string;
  /** @format int32 */
  sequence?: number;
  errorInfo?: string;
}

export interface ColumnSettingDto {
  /** @format uuid */
  id?: string;
  column?: ColumnBaseDto;
  grouped?: boolean;
  aggregateFunction?: GenericListItem;
  /** @format int32 */
  sequence?: number;
  includeInScripting?: boolean;
  columnName?: string;
  columnType?: string;
  columnTypeName?: string;
}

export interface CompareProcessResponse {
  /**
   * JSON string of the diff (same format as audit log LogJson).
   * Null/empty when there are no changes.
   */
  diffJson?: string;
  /** True if this is a new process (no existing live version). */
  isNew?: boolean;
  /** True if there are differences between draft and live. */
  hasChanges?: boolean;
}

export interface CompareProcessResponseBaseResponse {
  data?: CompareProcessResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ConfirmRestImportRequest {
  fileToken?: string;
  name?: string;
}

export interface ConnectionModel {
  /** @format uuid */
  id?: string;
  description?: string;
  connectionType?: string;
  connectorType?: string;
  /** @format date-time */
  createdDate?: string;
  createdUser?: string;
  /** @format date-time */
  modifiedDate?: string;
  modifiedUser?: string;
  setupRequired?: boolean;
  dataSources?: DataSourceModel[];
  processes?: SimpleProcessModel[];
}

export interface ConnectionModelListBaseResponse {
  data?: ConnectionModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ConnectionRequest {
  productTypes?: ConnectorProductType[];
  /** @format date-time */
  createdAfter?: string;
  /** @format date-time */
  createdBefore?: string;
  /** @format date-time */
  modifiedAfter?: string;
  /** @format date-time */
  modifiedBefore?: string;
  searchString?: string;
  createdBy?: string;
  modifiedBy?: string;
  /** @format uuid */
  parentSetupId?: string;
}

export interface ConnectorDataSource {
  name?: string;
  imageName?: string;
  type?: DataSourceType;
  showInUi?: boolean;
  sourceType?: SourceType;
  productType?: ConnectorProductType;
  genericRestData?: string;
  /** @format uuid */
  imageId?: string;
}

export interface ConnectorDataSourceListBaseResponse {
  data?: ConnectorDataSource[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ConnectorDestination {
  displayName?: string;
  type?: DestinationType;
  showInUi?: boolean;
  allowTenantModify?: boolean;
  productType?: ConnectorProductType;
  webUiIcon?: string;
  genericRestData?: string;
  allowNodeReorder?: NodeReorder;
  implementsClearFields?: boolean;
}

export interface ConnectorDestinationListBaseResponse {
  data?: ConnectorDestination[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ConnectorInstanceBaseModelBaseResponse {
  data?:
    | ({
        InstanceType: 'Dropbox';
      } & DropboxInstanceModel)
    | ({
        InstanceType: 'MsFabric';
      } & FabricInstanceModel)
    | ({
        InstanceType: 'FTP';
      } & FtpInstanceModel)
    | ({
        InstanceType: 'GoogleDrive';
      } & GoogleDriveInstanceModel)
    | ({
        InstanceType: 'MsGraphOdata';
      } & MsGraphInstanceModel)
    | ({
        InstanceType: 'MsSql';
      } & MssqlInstanceModel)
    | ({
        InstanceType: 'MySql';
      } & MySqlInstanceModel)
    | ({
        InstanceType: 'Odbc';
      } & OdbcInstanceModel)
    | ({
        InstanceType: 'Oledb';
      } & OledbInstanceModel)
    | ({
        InstanceType: 'PostgreSql';
      } & PostgreSqlInstanceModel)
    | ({
        InstanceType: 'SlackOdata';
      } & SlackInstanceModel)
    | ({
        InstanceType: 'TrelloOdata';
      } & TrelloInstanceModel)
    | ({
        InstanceType: 'MsNavOdata';
      } & MsNavOdataInstanceModel)
    | ({
        InstanceType: 'Crm';
      } & CustomerEngagementInstanceModel)
    | ({
        InstanceType: 'NetSuite';
      } & NetSuiteInstanceModel)
    | ({
        InstanceType: 'GenericRest';
      } & GenericRestInstanceModel)
    | ({
        InstanceType: 'SalesForce';
      } & SalesforceInstanceModel)
    | ({
        InstanceType: 'MsFinOps';
      } & FinOpsInstanceModel)
    | ({
        InstanceType: 'PopDock';
      } & PopdockInstanceModel)
    | ({
        InstanceType: 'MsGp';
      } & GpInstanceModel);
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ConnectorInstanceCheckNameRequest {
  connector?: string;
  /** @format uuid */
  id?: string;
  name?: string;
}

export interface ConnectorInstanceExportBaseModel {
  /** @format uuid */
  id?: string;
  description?: string;
  instanceType?: string;
}

export interface ConnectorInstanceLink {
  linkType?: string;
  /** @format uuid */
  linkId?: string;
  linkUrl?: string;
}

export interface ConnectorInstanceListModel {
  /** @format uuid */
  id?: string;
  description?: string;
  instanceType?: string;
  authenticationType?: string;
  systemType?: string;
  premium?: boolean;
  setupRequired?: boolean;
  /** @format int32 */
  dataSourceCount?: number;
  /** @format int32 */
  integrationCount?: number;
  imageUrl?: string;
}

export interface ConnectorInstanceListModelBaseResponse {
  data?: ConnectorInstanceListModel;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ConnectorInstanceToDoModel {
  /** @format uuid */
  id?: string;
  description?: string;
  instanceType?: string;
  authenticationType?: string;
  systemType?: string;
  premium?: boolean;
  /** @format date-time */
  modifiedDate?: string;
  modifiedUser?: string;
}

export interface ConnectorInstanceToDoModelListBaseResponse {
  data?: ConnectorInstanceToDoModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ConnectorOption {
  /** @format uuid */
  instanceId?: string;
  instanceType?: string;
  description?: string;
}

export interface CreateConnectorInstanceListModel {
  description?: string;
  instanceType?: string;
}

export interface CreateTranslationTableModel {
  key?: string;
  description?: string;
}

export interface CurrentUsageCurrentMonthDto {
  monthKey?: string;
  label?: string;
  /** @format int64 */
  value?: string;
  /** @format int32 */
  included?: number;
  /** @format int32 */
  planUsedPercent?: number;
  /** @format int64 */
  deltaVsPreviousMonth?: string;
  deltaDirection?: string;
  resetLabel?: string;
}

export interface CurrentUsageErrorRateDto {
  /** @format double */
  percent?: number;
  driverLabel?: string;
}

export interface CurrentUsageMetricsDto {
  meter?: string;
  /** @format int32 */
  windowMonths?: number;
  /** @format int32 */
  includedMonthlyRuns?: number;
  selectedMonthKey?: string;
  currentMonth?: CurrentUsageCurrentMonthDto;
  windowSummary?: CurrentUsageWindowSummaryDto;
  errorRate?: CurrentUsageErrorRateDto;
  monthlyUsage?: CurrentUsageMonthlyDto[];
  runTypeBreakdown?: CurrentUsageRunTypeDto[];
}

export interface CurrentUsageMetricsDtoBaseResponse {
  data?: CurrentUsageMetricsDto;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface CurrentUsageMonthlyDto {
  monthKey?: string;
  label?: string;
  /** @format int32 */
  year?: number;
  /** @format int32 */
  month?: number;
  /** @format int64 */
  app?: string;
  /** @format int64 */
  schedule?: string;
  /** @format int64 */
  realtime?: string;
  /** @format int64 */
  api?: string;
  /** @format int64 */
  excel?: string;
  /** @format int64 */
  runs?: string;
  /** @format int64 */
  records?: string;
  /** @format int64 */
  errors?: string;
  /** @format int64 */
  value?: string;
}

export interface CurrentUsageRunTypeDto {
  runType?: string;
  description?: string;
  /** @format int64 */
  runs?: string;
  /** @format int64 */
  records?: string;
  /** @format int64 */
  errors?: string;
  /** @format int64 */
  value?: string;
  /** @format int32 */
  percent?: number;
}

export interface CurrentUsageWindowSummaryDto {
  label?: string;
  /** @format int64 */
  runs?: string;
  /** @format int64 */
  records?: string;
  /** @format int64 */
  errors?: string;
  /** @format int64 */
  value?: string;
}

export type CustomerEngagementInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  authenticationType?: CeAuthenticationType;
  serverAddress?: string;
  apiVersion?: string;
  authority?: string;
  directoryId?: string;
  /** @format date-time */
  tokenExpiry?: string;
  /** @format date-time */
  secretExpiry?: string;
  clientId?: string;
  clientSecret?: string;
  organization?: string;
  organizationNiceName?: string;
  usesOAuth?: boolean;
  useRegionalDiscoveryService?: boolean;
  userName?: string;
  password?: string;
  domain?: string;
  useSsl?: boolean;
  token?: string;
  refreshToken?: string;
  domainToken?: string;
  domainRefreshToken?: string;
  /** @format date-time */
  domainTokenExpiry?: string;
  fromMemoCache?: boolean;
  validateRegional?: boolean;
  organizations?: CeOrganizationDetailModel[];
  metadataOrganizations?: CeOrganizationMetadataState[];
};

export interface DashboardLoginModel {
  email?: string;
  name?: string;
  /** @format date-time */
  date?: string;
  loginType?: string;
  initials?: string;
}

export interface DashboardNewsLinkModel {
  label?: string;
  /** @format int32 */
  type?: number;
  href?: string;
  helpType?: string;
  helpId?: string;
}

export interface DashboardNewsModel {
  title?: string;
  text?: string;
  link?: DashboardNewsLinkModel;
}

export interface DataSourceBaseModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface DataSourceBaseModelBaseResponse {
  data?: DataSourceBaseModel;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface DataSourceCalculatedFieldDef {
  name?: string;
  type?: CalculatedFieldType;
  dataType?: FieldType;
  script?: string;
  language?: ScriptOptions;
  /** @format int32 */
  startValue?: number;
  groupByFields?: string[];
  /** @format int32 */
  sequence?: number;
}

export interface DataSourceCheckNameRequest {
  /** @format uuid */
  id?: string;
  name?: string;
  type?: string;
}

export interface DataSourceCreateFromImportRequest {
  originalDataSource?: DataSourceExportBaseModel;
  name?: string;
  dataSourceType?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  importFileHolderId?: string;
  /**
   * SC-1726: when creating one of a composite's data sources, its exported id (its template files in the zip).
   * @format uuid
   */
  importLegDataSourceId?: string;
  /** SC-1726: when creating a composite, the data source each exported data source maps to, by exported id. */
  legDataSourceIds?: Record<string, string>;
}

export interface DataSourceExportBaseModel {
  sourceType?: DataSourceType;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  currentInstance?: ConnectorInstanceExportBaseModel;
  pipeline?: DataSourcePipelineConfig;
}

export interface DataSourceLinkedFile {
  /** @format uuid */
  id?: string;
  fileType?: string;
  fileName?: string;
}

export interface DataSourceModel {
  /** @format uuid */
  id?: string;
  sourceName?: string;
  /** @format uuid */
  connectionId?: string;
  typeName?: string;
  sourceType?: string;
  type?: string;
  parentSetupId?: string;
  processes?: SimpleProcessModel[];
  settings?: DataSourceBaseModel;
  hasQueryBuilder?: boolean;
  hasPreview?: boolean;
  setupRequired?: boolean;
  /** @format int32 */
  draftCount?: number;
  /** @format int32 */
  integrationCount?: number;
  registered?: boolean;
}

export interface DataSourcePipelineConfig {
  /** @format int32 */
  schemaVersion?: number;
  preCalcRestrictions?: DataSourceRestrictionSection;
  calculatedFields?: DataSourceCalculatedFieldDef[];
  postCalcRestrictions?: DataSourceRestrictionSection;
}

export interface DataSourcePipelineConfigBaseResponse {
  data?: DataSourcePipelineConfig;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface DataSourcePipelineMetrics {
  /** @format int32 */
  sourceRecordCount?: number;
  /** @format int32 */
  preCalcRestrictedCount?: number;
  /** @format int32 */
  postCalcRestrictedCount?: number;
  /** @format int32 */
  removedCount?: number;
}

export interface DataSourcePreviewResponse {
  table?: string;
  columns?: StringStringKeyValuePair[];
  /**
   * SC-698: pipeline row counts when a data source pipeline ran for this preview
   * (null otherwise). The UI shows these in the preview footer so an all-filtered
   * result is clearly "restricted", not "no data".
   */
  pipeline?: DataSourcePipelineMetrics;
}

export interface DataSourcePreviewResponseBaseResponse {
  data?: DataSourcePreviewResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface DataSourceRestrictionGroup {
  ruleCombine?: RestrictionConjunctive;
  rules?: DataSourceRestrictionRule[];
}

export interface DataSourceRestrictionRule {
  fieldName?: string;
  operator?: RestrictionType;
  values?: string[];
}

export interface DataSourceRestrictionSection {
  groupCombine?: RestrictionConjunctive;
  groups?: DataSourceRestrictionGroup[];
}

export interface DataSourceSelectionResponse {
  columns?: GenericOptionSetListItem[];
  globalVariableNames?: string[];
}

export interface DataSourceSelectionResponseBaseResponse {
  data?: DataSourceSelectionResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface DataSourceStubRequest {
  name?: string;
  dataSourceType?: string;
  type?: string;
  genericRestData?: string;
}

export interface DataSourceTodoModel {
  /** @format uuid */
  id?: string;
  sourceName?: string;
  type?: string;
  typeName?: string;
  dataSourceType?: string;
  /** @format date-time */
  modifiedDate?: string;
  modifiedUser?: string;
}

export interface DataSourceTodoModelListBaseResponse {
  data?: DataSourceTodoModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface DateTimeFormat {
  /** @format uuid */
  dateTimeFormatId?: string;
  /** @format uuid */
  customerId?: string;
  name?: string;
  formatString?: string;
  isSystem?: boolean;
  dateCulture?: string;
}

export interface DateTimeFormatDto {
  name?: string;
  formatString?: string;
  dateCulture?: string;
}

export interface DbMap {
  /** @format uuid */
  mapId?: string;
  id?: string;
  /** @format uuid */
  customerId?: string;
  /** @format date-time */
  createdDate?: string;
  createdUser?: string;
  dataSourceType?: string;
  destinationDefinition?: string;
  destinationType?: string;
  errorPath?: string;
  /** @format date-time */
  lastRunDate?: string;
  lastRunSuccess?: boolean;
  lastRunType?: string;
  logEnabled?: boolean;
  logErrors?: boolean;
  logSourceData?: boolean;
  logSuccess?: boolean;
  logXml?: boolean;
  mapDescription?: string;
  /** @format int64 */
  runNumber?: string;
  scriptLanguage?: string;
  runMapAsUser?: string;
  isPublished?: boolean;
  /** @format date-time */
  publishedDate?: string;
  publishedUser?: string;
  /** @format date-time */
  modifiedDate?: string;
  modifiedUser?: string;
  dataSourceExclusion?: string;
  returnSuccessIfNoData?: boolean;
  returnFailIfNoData?: boolean;
  allowAnyRun?: boolean;
  owner?: string;
  /** @format uuid */
  integrationGroupId?: string;
  saveProcessErrorsAsCsv?: boolean;
  saveProcessErrorsAsXml?: boolean;
  usesDefinedDestination?: boolean;
  allowSourceUploads?: boolean;
  showRuntimeSelect?: boolean;
  /** @format uuid */
  destinationId?: string;
  /** @format uuid */
  dataSourceId?: string;
  logSystemEvents?: boolean;
  /** @format int32 */
  logSourceDataLimit?: number;
  concatenationSeparator?: string;
  /** @format int32 */
  fileOutputLimit?: number;
  disableParallelSend?: boolean;
  runTasksNoDataOption?: string;
  overview?: string;
  tenantJson?: string;
  keyJson?: string;
  taskJson?: string;
  noteJson?: string;
  debugNextRun?: boolean;
  longRunning?: boolean;
}

export interface DbUserWebFormOption {
  /** @format uuid */
  userWebFormOptionId?: string;
  formName?: string;
  /** @format uuid */
  userId?: string;
  /** @format uuid */
  id?: string;
}

export interface DbUserWebFormOptionDetail {
  /** @format uuid */
  userWebFormOptionDetailId?: string;
  identifier?: string;
  selectedValue?: string;
  defaultValue?: string;
  /** @format uuid */
  userWebFormOptionId?: string;
  /** @format uuid */
  id?: string;
}

export interface DeleteConnectorInstanceResponse {
  success?: boolean;
  sources?: string[];
  destinations?: string[];
  tasks?: string[];
  tenants?: string[];
  processes?: string[];
}

export interface DeleteConnectorInstanceResponseBaseResponse {
  data?: DeleteConnectorInstanceResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface DeleteDraftRequest {
  /**
   * required Id
   * @format uuid
   */
  id: string;
  /**
   * required Version
   * @format int32
   */
  version: number;
}

export interface DeleteProcessRequest {
  /** @format uuid */
  mapId?: string;
  deleteDataSource?: boolean;
}

export interface DeleteRunningActivityRequest {
  /** @format uuid */
  runId?: string;
  /** @format uuid */
  mapKey?: string;
}

export interface DestinationModelBase {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  destinationType?: DestinationType;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  toFile?: boolean;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface DetailMessage {
  /** @format uuid */
  runId?: string;
  /** @format uuid */
  customerId?: string;
  /** @format uuid */
  mapKey?: string;
  /** @format int64 */
  runNumber?: string;
  /** @format date-time */
  messageDateTime?: string;
  message?: string;
  messageDetail?: string;
  outputs?: StringStringValueTuple[];
}

export interface DraftBriefingDto {
  /** @format uuid */
  id?: string;
  draftKey?: string;
  mapName?: string;
  mapId?: string;
  longRunning?: boolean;
  /**
   * Draft Type
   * Options: Map
   */
  type?: string;
  /** @format date-time */
  lockedDate?: string;
  /** @format date-time */
  lockExpireDate?: string;
  lockedUser?: string;
  /** @format date-time */
  createdDate?: string;
  createdUser?: string;
  /** @format date-time */
  modifiedDate?: string;
  modifiedUser?: string;
  /** @format int32 */
  version?: number;
  isLocked?: boolean;
  hideDelete?: boolean;
  hideEdit?: boolean;
  hideView?: boolean;
}

export interface DraftBriefingDtoBaseResponse {
  data?: DraftBriefingDto;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface DraftBriefingDtoListBaseResponse {
  data?: DraftBriefingDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface DraftDto {
  /** @format uuid */
  id?: string;
  draftKey?: string;
  type?: string;
  json?: string;
  /** @format uuid */
  customerId?: string;
  /** @format int32 */
  version?: number;
  /** @format date-time */
  lockedDate?: string;
  /** @format date-time */
  lockExpireDate?: string;
  lockedUser?: string;
  /** @format date-time */
  createdDate?: string;
  createdUser?: string;
  /** @format date-time */
  modifiedDate?: string;
  modifiedUser?: string;
  entityId?: string;
}

export interface DraftDtoBaseResponse {
  data?: DraftDto;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface DraftListDto {
  /** @format uuid */
  draftId?: string;
  id?: string;
  description?: string;
  sourceType?: string;
  targetType?: string;
}

export interface DraftListDtoListBaseResponse {
  data?: DraftListDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export type DropboxInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  token?: string;
  refreshToken?: string;
  clientId?: string;
  clientSecret?: string;
  username?: string;
  serviceUrl?: string;
  fromMemoCache?: boolean;
  /** @format date-time */
  tokenExpiry?: string;
  /** @format date-time */
  secretExpiry?: string;
};

export interface EOneNews {
  title?: string;
  link?: string;
  message?: string;
}

export interface EOneNewsListBaseResponse {
  data?: EOneNews[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface EmailDiagnosticsModel {
  userAgent?: string;
  language?: string;
  path?: string;
  search?: string;
}

export interface EmailModel {
  subject?: string;
  message?: string;
  diagnostics?: EmailDiagnosticsModel;
}

export interface ExcelDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  excelSheet?: string;
  sourceLocationType?: FileDataSourceSourceLocationType;
  schemaHeader?: SchemaHeader;
  /** @format uuid */
  fileHolderId?: string;
  templateFile?: string;
  sourceFolder?: string;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

/** Refer to ExcelDataSourceSetupModel */
export interface ExcelDataSourceSetupDto {
  /** @format uuid */
  fileHolderId?: string;
  filesAtRuntime?: boolean;
  fileName?: string;
  sheetName?: string;
  sheets?: string[];
  friendlyName?: string;
  name?: string;
  viewName?: string;
  largeImage?: string;
  typeName?: string;
  queryText?: string;
  trimStrings?: boolean;
  /** @format uuid */
  registeredConnectorId?: string;
  providerName?: string;
  imageUrl?: string;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  fromQueryBuilder?: boolean;
  freeTextDatabaseName?: boolean;
}

export interface ExcelDataSourceSetupDtoListBaseResponse {
  data?: ExcelDataSourceSetupDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ExcelFileDestinationModel {
  destinationType?: DestinationType;
  fileDestinationPath?: string;
  fileName?: string;
  columnCharacterSet?: TextFileCharacterSet;
  separateFilePerKeyField?: boolean;
  appendKeyFieldToFilename?: boolean;
  overwriteFile?: boolean;
  appendDateTime?: boolean;
  includeColumnHeadings?: boolean;
  encloseInQuotes?: boolean;
  columnHeaders?: GenericFileColumnHeader[];
  /** @format uuid */
  sourceId?: string;
  msGpDestinationType?: string;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  toFile?: boolean;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface ExcelFolderDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  excelSheet?: string;
  filesAtRuntime?: boolean;
  successFolder?: string;
  failureFolder?: string;
  emptyFileAction?: string;
  overwriteFile?: boolean;
  appendDateTime?: boolean;
  instances?: ConnectorOption[];
  sourceLocationType?: FileDataSourceSourceLocationType;
  schemaHeader?: SchemaHeader;
  /** @format uuid */
  fileHolderId?: string;
  templateFile?: string;
  sourceFolder?: string;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface ExportDocumentationRequest {
  /** @format uuid */
  id?: string;
  fileName?: string;
  type?: DocumentationType;
  includeChildren?: boolean;
}

export interface ExportEntityAuditLogsRequest {
  entityType?: AuditLogEntityType;
  entityId?: string;
}

export interface ExportMapRunActivityDetailRequest {
  /** @format uuid */
  mapRunActivityId?: string;
}

export interface ExportMapRunActivityDetailResponse {
  fileName?: string;
  contentType?: string;
  fileContent?: string;
}

export interface ExportMapRunActivityDetailResponseBaseResponse {
  data?: ExportMapRunActivityDetailResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ExportProcessDocumentationResponse {
  /** text/markdown | zip */
  fileType?: string;
  /** file content in base64 */
  fileContent?: string;
  fileName?: string;
}

export interface ExportProcessDocumentationResponseBaseResponse {
  data?: ExportProcessDocumentationResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ExportProcessRequest {
  /** @format uuid */
  id?: string;
  fileName?: string;
  includeSource?: boolean;
  includeSourceConnection?: boolean;
  includeTargetConnection?: boolean;
  notes?: string;
}

export interface ExportProcessResponse {
  /** zip */
  contentType?: string;
  /** base64 encoded content */
  fileContent?: string;
  fileName?: string;
}

export interface ExportProcessResponseBaseResponse {
  data?: ExportProcessResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ExtenderQueryDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  hasQueryBuilder?: boolean;
  interCompanyId?: string;
  trimStrings?: boolean;
  extenderId?: string;
  /** @format int32 */
  extenderType?: number;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface FabricChangeDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  hasQueryBuilder?: boolean;
  mssqlDatabase?: string;
  mssqlTable?: string;
  genericTableField?: GenericTableField[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface FabricCommandValidationRequest {
  /** @format uuid */
  connectionId?: string;
  database?: string;
  code?: string;
}

export interface FabricCommandValidationResponse {
  isValid?: boolean;
  reason?: string;
}

export interface FabricCommandValidationResponseBaseResponse {
  data?: FabricCommandValidationResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export type FabricInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  directoryId?: string;
  mssqlServer?: string;
  useCredentials?: boolean;
  authType?: MssqlAuthenticationType;
  username?: string;
  password?: string;
  encrypt?: boolean;
  useTrustServerCertificate?: boolean;
  isServerless?: boolean;
  freeTextDatabaseName?: boolean;
  mssqlDatabase?: string;
  localQueueEnabled?: boolean;
  /** @format int32 */
  retryIntervalSec?: number;
  increaseIntervalWithEveryAttempt?: boolean;
  /** @format int32 */
  giveUpAfterMinutes?: number;
  recordSuccess?: boolean;
  /** @format int32 */
  purgeQueueHoursOld?: number;
  /** @format int32 */
  connectionTimeout?: number;
  /** @format int32 */
  commandTimeout?: number;
  /** @format int32 */
  packetSize?: number;
  databases?: string[];
  singleDatabase?: boolean;
  tenantCapabilities?: TenantCapability[];
  hasTenantCapabilities?: boolean;
};

export interface FabricInstanceModelListBaseResponse {
  data?: FabricInstanceModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface FabricQueryDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  database?: string;
  trimStrings?: boolean;
  hasQueryBuilder?: boolean;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface FabricRealTimeDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  allowCreate?: boolean;
  allowUpdate?: boolean;
  allowDelete?: boolean;
  allowAll?: boolean;
  trimStrings?: boolean;
  mssqlDatabase?: string;
  mssqlTable?: string;
  realTimeDataSourceFields?: GenericTableField[];
  logAction?: WebServiceLoggingAction;
  localQueueEnabled?: boolean;
  /** @format int32 */
  retryIntervalSec?: number;
  increaseIntervalWithEveryAttempt?: boolean;
  /** @format int32 */
  giveupAfterMinutes?: number;
  recordSuccess?: boolean;
  /** @format int32 */
  purgeQueueHoursOld?: number;
  /** @deprecated */
  linkedMaps?: RealTimeLinkedMapModel[];
  friendlyName?: string;
  name?: string;
  isRegistered?: boolean;
  callbackUri?: string;
  realTimeMapLinks?: RealTimeDataSourceMapLink[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface FabricTableDestinationModel {
  destinationType?: DestinationType;
  mssqlTable?: string;
  table?: string;
  mssqlDatabase?: string;
  useTransaction?: boolean;
  toFile?: boolean;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface FileHolderRef {
  /** @format uuid */
  id?: string;
  description?: string;
}

export interface FinOpsCompany {
  value?: string;
  name?: string;
  selected?: boolean;
}

export interface FinOpsDestinationFieldInfo {
  fieldName?: string;
  userDisplayName?: string;
  type?: string;
}

export type FinOpsInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  siteUri?: string;
  clientId?: string;
  clientSecret?: string;
  defaultCompany?: string;
  defaultCompanyName?: string;
  defaultCompanyId?: string;
  userEmail?: string;
  language?: string;
  token?: string;
  /** @format date-time */
  tokenExpiry?: string;
  /** @format date-time */
  secretExpiry?: string;
  refreshToken?: string;
  fromMemoCache?: boolean;
  companies?: FinOpsCompany[];
  hasMetadata?: boolean;
  /** @format date-time */
  metadataLastUpdatedUtc?: string;
};

/** Refer to FinOpsOdataDataSourceModel */
export interface FinOpsOdataDataSourceDto {
  companies?: string;
  allCompanies?: boolean;
  services?: FinOpsOdataDataSourceServiceDto[];
  friendlyName?: string;
  name?: string;
  viewName?: string;
  largeImage?: string;
  typeName?: string;
  queryText?: string;
  trimStrings?: boolean;
  /** @format uuid */
  registeredConnectorId?: string;
  providerName?: string;
  imageUrl?: string;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  fromQueryBuilder?: boolean;
  freeTextDatabaseName?: boolean;
}

export interface FinOpsOdataDataSourceDtoListBaseResponse {
  data?: FinOpsOdataDataSourceDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface FinOpsOdataDataSourceService {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  customerId?: string;
  name?: string;
  entityType?: string;
  filter?: string;
  parsedFilter?: string;
  children?: FinOpsOdataDataSourceService[];
  fields?: StringStringKeyValuePair[];
}

/** Refer to FinOpsOdataDataSourceServiceModel */
export interface FinOpsOdataDataSourceServiceDto {
  /** @format uuid */
  id?: string;
  name?: string;
  entityType?: string;
  displayName?: string;
  filter?: string;
  fields?: GenericDescriptionCheckBoxListItem[];
  children?: FinOpsOdataDataSourceServiceDto[];
  selected?: boolean;
}

export interface FinOpsOdataDestinationModel {
  organization?: string;
  removeBlankProperties?: boolean;
  services?: FinOpsOdataDestinationService[];
  destinationType?: DestinationType;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  toFile?: boolean;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface FinOpsOdataDestinationService {
  /** @format uuid */
  id?: string;
  name?: string;
  description?: string;
  entityType?: string;
  insertable?: boolean;
  updatable?: boolean;
  deletable?: boolean;
  fields?: FinOpsDestinationFieldInfo[];
  navigationServices?: GenericDescriptionListItem[];
  saveResult?: boolean;
  rollback?: boolean;
  resultFields?: MapLineResultField[];
  childServices?: FinOpsOdataDestinationService[];
}

export interface FinOpsQueryDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  allowPreviewLogging?: boolean;
  logPreview?: boolean;
  allCompanies?: boolean;
  companies?: string;
  services?: FinOpsOdataDataSourceService[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface FinOpsRefreshMetadataRequest {
  mode?: MetadataRefreshMode;
  targets?: string[];
}

export interface FirewallIpAddressModel {
  id?: string;
  name?: string;
  startAddress?: string;
  endAddress?: string;
  /** @format uuid */
  userId?: string;
}

export interface FirewallModel {
  /** @format uuid */
  id?: string;
  type?: string;
  status?: string;
  description?: string;
  addresses?: FirewallIpAddressModel[];
  virtualNetworks?: FirewallVpnModel[];
  availableNetworks?: VirtualNetworkListModel[];
  availableUsers?: UserListModel[];
}

export interface FirewallModelListBaseResponse {
  data?: FirewallModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface FirewallVpnModel {
  id?: string;
  /** @format uuid */
  virtualNetworkId?: string;
  name?: string;
  description?: string;
}

export type FtpInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  serverUrl?: string;
  ftpType?: string;
  /** @format int32 */
  port?: number;
  keepAlive?: boolean;
  useDefaultPort?: boolean;
  username?: string;
  password?: string;
  dataConnectionType?: string;
  ftpEncryptionMode?: string;
  rootDirectory?: string;
  connectionData?: string;
  sslProtocolList?: string[];
  /** @format uuid */
  fileHolderId?: string;
  fileName?: string;
  protocols?: string;
};

export interface GenericCheckBoxListItem {
  itemText?: string;
  itemValue?: string;
  selected?: boolean;
}

export interface GenericDescriptionCheckBoxListItem {
  itemText?: string;
  itemValue?: string;
  selected?: boolean;
  description?: string;
}

export interface GenericDescriptionListItem {
  description?: string;
  itemText?: string;
  itemValue?: string;
}

export interface GenericFieldListItem {
  entityName?: string;
  fieldName?: string;
  displayName?: string;
  jsonValue?: string;
  technicalValue?: string;
  selected?: boolean;
}

export interface GenericFileColumnHeader {
  /** @format int32 */
  sequenceNumber?: number;
  columnName?: string;
  /** @format int32 */
  startPosition?: number;
  /** @format int32 */
  dataTypeWidth?: number;
}

export interface GenericListItem {
  itemText?: string;
  itemValue?: string;
}

export interface GenericListItemListBaseResponse {
  data?: GenericListItem[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GenericMapListItem {
  /** @format uuid */
  mapKey?: string;
  itemDesc?: string;
  itemText?: string;
  itemValue?: string;
}

export interface GenericOptionSetListItem {
  itemText?: string;
  itemValue?: any;
  isDefault?: boolean;
}

export interface GenericRestActionDto {
  /** @format uuid */
  id?: string;
  name?: string;
  entityName?: string;
  groupName?: string;
}

export interface GenericRestActionItemModel {
  /** @format uuid */
  id?: string;
  name?: string;
  groupName?: string;
}

export interface GenericRestActionListModel {
  /** @format uuid */
  id?: string;
  name?: string;
  groupName?: string;
}

export interface GenericRestActionModel {
  /** @format uuid */
  id?: string;
  name?: string;
  response?: string;
  responseType?: string;
  /** @format int32 */
  retries?: number;
  bodyTemplate?: string;
  overrideConnectorParameters?: boolean;
  overrideConnectorHeaders?: boolean;
  restParameters?: GenericRestParameterModel[];
  restHeaders?: GenericRestParameterModel[];
  requestMethod?: string;
  endpoint?: string;
  bodyType?: string;
  entityName?: string;
  groupName?: string;
  message?: string;
  clearUnmappedValues?: boolean;
  usesValuePairs?: boolean;
  valuePairKey?: string;
  restVariables?: GenericRestVariableModel[];
  inheritRequestMethod?: boolean;
  includeBodyForDelete?: boolean;
  clearBlankValues?: boolean;
  checkErrorStatusCodes?: boolean;
  useDefaultIgnoreCodes?: boolean;
  ignoreCodes?: number[];
  ignoreCheckType?: string;
  ignoreCheckValue?: string;
}

/**
 * SC-1513: answers "can this entity or lookup be removed from the setup?" before the editor takes
 * the row out of the form, so the user is warned at delete time rather than losing every other
 * edit to a rejected save. Message is built by the same code that refuses the save.
 */
export interface GenericRestChildUsageResponse {
  inUse?: boolean;
  message?: string;
}

export interface GenericRestChildUsageResponseBaseResponse {
  /**
   * SC-1513: answers "can this entity or lookup be removed from the setup?" before the editor takes
   * the row out of the form, so the user is warned at delete time rather than losing every other
   * edit to a rejected save. Message is built by the same code that refuses the save.
   */
  data?: GenericRestChildUsageResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GenericRestDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  /** @format uuid */
  entityId?: string;
  /** @format uuid */
  genericRestSetupId?: string;
  message?: string;
  usedPlaceholders?: PlaceholderModel[];
  placeholders?: PlaceholderListItem[];
  headers?: GenericRestParameterModel[];
  parameters?: GenericRestParameterModel[];
  fields?: GenericRestFieldSelectModel[];
  body?: string;
  linkedChildren?: GenericRestLinkedChildModel[];
  allowPreviewLogging?: boolean;
  logPreview?: boolean;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface GenericRestDataSourceSetupDto {
  /** @format uuid */
  entityId?: string;
  entityName?: string;
  groupName?: string;
  providerData?: string;
  fields?: GenericRestFieldSelectDto[];
  sourceType?: string;
  sourceName?: string;
  usedPlaceholders?: GenericRestPlaceholderDto[];
  headers?: GenericRestParameterWrapper[];
  parameters?: GenericRestParameterWrapper[];
  body?: string;
  friendlyName?: string;
  name?: string;
  viewName?: string;
  largeImage?: string;
  typeName?: string;
  queryText?: string;
  trimStrings?: boolean;
  /** @format uuid */
  registeredConnectorId?: string;
  providerName?: string;
  imageUrl?: string;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  fromQueryBuilder?: boolean;
  freeTextDatabaseName?: boolean;
}

export interface GenericRestDestinationModel {
  /** @format uuid */
  setupId?: string;
  groupName?: string;
  endpoints?: GenericRestActionItemModel[];
  destinationType?: DestinationType;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  toFile?: boolean;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface GenericRestDetailsModel {
  groupList?: string[];
  endpointList?: GenericRestActionItemModel[];
  instanceList?: Record<string, string>;
}

export interface GenericRestDetailsModelBaseResponse {
  data?: GenericRestDetailsModel;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GenericRestEntityFieldModel {
  /** @format uuid */
  id?: string;
  name?: string;
  path?: string;
  /** @format int32 */
  type?: number;
  script?: string;
  /** @format int32 */
  language?: number;
  enumItems?: Record<string, string>;
  ignoreParsingErrors?: boolean;
}

export interface GenericRestEntityListModel {
  /** @format uuid */
  id?: string;
  name?: string;
  groupName?: string;
  /** @format int32 */
  requestMethod?: number;
}

export interface GenericRestEntityModel {
  /** @format uuid */
  setupId?: string;
  setupName?: string;
  /** @format uuid */
  id?: string;
  name?: string;
  groupName?: string;
  useDefaultParameters?: boolean;
  useDefaultHeaders?: boolean;
  parameters?: GenericRestParameterModel[];
  headers?: GenericRestParameterModel[];
  body?: string;
  bodyType?: BodyType;
  bodyIncludesPaging?: boolean;
  requestMethod?: RequestMethod;
  endpoint?: string;
  /** @format int32 */
  requestTimeoutSeconds?: number;
  usesPaging?: boolean;
  pagingName?: string;
  pages?: StringBooleanValueTuple[];
  fields?: GenericRestEntityFieldModel[];
  returnType?: string;
  returnsTabularJson?: boolean;
  tabularRowsPath?: string;
  tabularColumnsPath?: string;
  tabularColumnNameProperty?: string;
  checkNoDataErrorCodes?: boolean;
  useDefaultNoDataErrorCodes?: boolean;
  ignoreParsingErrors?: boolean;
  noDataCodes?: number[];
  noDataCheckType?: StatusCodeCheckType;
  noDataCheckValue?: string;
  message?: string;
  placeholderVariables?: string[];
  placeholderAuth?: string[];
  placeholderPaging?: string[];
}

export interface GenericRestErrorHandlingModel {
  retryOnError?: boolean;
  retryErrorCodes?: number[];
  /** @format int32 */
  maxRetries?: number;
  /** @format int32 */
  retrySleepTime?: number;
  ignoreErrorCodes?: number[];
  ignoreCheckType?: StatusCodeCheckType;
  ignoreCheckValue?: string;
  noDataErrorCodes?: number[];
  noDataCheckType?: StatusCodeCheckType;
  noDataCheckValue?: string;
}

export interface GenericRestField {
  /** @format uuid */
  id?: string;
  name?: string;
  path?: string;
  type?: FieldType;
  language?: ScriptLanguage;
  enumItems?: Record<string, string>;
  requiredField?: boolean;
  script?: string;
  ignoreParsingErrors?: boolean;
  isCalculation?: boolean;
}

export interface GenericRestFieldSelectDto {
  name?: string;
  type?: string;
  path?: string;
  selected?: boolean;
  isCalc?: boolean;
  script?: string;
  enumItems?: GenericListItem[];
}

export interface GenericRestFieldSelectModel {
  id?: string;
  name?: string;
  path?: string;
  /** @format int32 */
  type?: number;
  /** @format int32 */
  language?: number;
  requiredField?: boolean;
  script?: string;
  selected?: boolean;
}

export interface GenericRestGroupModel {
  /** @format int32 */
  index?: number;
  name?: string;
  originalValue?: string;
}

export interface GenericRestInstanceDto {
  instanceType?: string;
  id?: string;
  instanceName?: string;
  description?: string;
  isDefault?: boolean;
  isLocal?: boolean;
  /** @format uuid */
  localServerName?: string;
  imageUrl?: string;
  sourceUrl?: string;
  targetUrl?: string;
  customError?: string;
  connectionLinks?: ConnectorInstanceLink[];
  connectorInstanceImageUri?: string;
}

export type GenericRestInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  installNotes?: string;
  /** @format uuid */
  restSetupId?: string;
  serviceName?: string;
  authType?: string;
  username?: string;
  password?: string;
  clientId?: string;
  clientSecret?: string;
  token?: string;
  /** @format date-time */
  tokenExpiry?: string;
  refreshToken?: string;
  scope?: string;
  state?: string;
  variables?: RestVariableModel[];
  parameters?: RestParameterModel[];
  headers?: RestParameterModel[];
  /** @format date-time */
  secretExpiry?: string;
  message?: string;
  mode?: string;
  fromMemoCache?: boolean;
};

export interface GenericRestLinkedChildModel {
  id?: string;
  name?: string;
  /** @format uuid */
  entityId?: string;
  groupName?: string;
  join?: RestJoinBehavior;
  prefix?: string;
  message?: string;
  body?: string;
  /** @format int32 */
  order?: number;
  headers?: GenericRestParameterModel[];
  parameters?: GenericRestParameterModel[];
  fields?: GenericRestFieldSelectModel[];
  usedPlaceholders?: PlaceholderModel[];
}

export interface GenericRestLookupDetailsModel {
  returnFields?: Record<string, string>;
  mappableObjects?: GenericRestLookupMappableOptionModel[];
}

export interface GenericRestLookupDetailsModelBaseResponse {
  data?: GenericRestLookupDetailsModel;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GenericRestLookupListModel {
  /** @format uuid */
  id?: string;
  name?: string;
}

export interface GenericRestLookupMappableObjectModel {
  type?: GenericRestLookupMappableObjectType;
  key?: string;
  description?: string;
  removeIfEmpty?: boolean;
  selected?: boolean;
  isConnector?: boolean;
}

export interface GenericRestLookupMappableOptionModel {
  optionType?: string;
  key?: string;
  description?: string;
  mappedColumn?: string;
  id?: string;
}

export interface GenericRestLookupModel {
  /** @format uuid */
  id?: string;
  name?: string;
  endpoint?: string;
  /** @format uuid */
  entityId?: string;
  body?: string;
  bodyType?: BodyType;
  headers?: GenericRestParameterModel[];
  parameters?: GenericRestParameterModel[];
  variables?: GenericRestVariableModel[];
  fields?: GenericRestField[];
  mappableFields?: GenericRestLookupMappableObjectModel[];
  noDataErrorCode?: number[];
  overrideConnectorHeaders?: boolean;
  overrideConnectorParameters?: boolean;
  requestMethod?: string;
  inheritRequestMethod?: boolean;
  checkErrorCodesForNoData?: boolean;
  useDefaultNoDataErrorCodes?: boolean;
  noDataCheckType?: StatusCodeCheckType;
  noDataCheckValue?: string;
  /** @format int32 */
  requestTimeoutSeconds?: number;
}

export interface GenericRestLookupOptionsModel {
  instanceList?: Record<string, string>;
  lookupList?: Record<string, string>;
}

export interface GenericRestLookupOptionsModelBaseResponse {
  data?: GenericRestLookupOptionsModel;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GenericRestPagingModel {
  /** @format int32 */
  index?: number;
  name?: string;
  originalName?: string;
  isDefault?: boolean;
  /** @format int32 */
  method?: number;
  /** @format int32 */
  size?: number;
  /** @format int32 */
  initialPage?: number;
  pageCountPath?: string;
  offsetPath?: string;
  urlPath?: string;
  pageParameter?: string;
  sizeParameter?: string;
  offsetParameter?: string;
  hasMorePagesPath?: string;
  /** @format int32 */
  pageCountPathType?: number;
  /** @format int32 */
  pageOffsetPathType?: number;
  /** @format int32 */
  hasMorePagesPathType?: number;
  /** @format int32 */
  pageParameterType?: number;
  /** @format int32 */
  pageOffsetParameterType?: number;
  /** @format int32 */
  pageSizeParameterType?: number;
}

export interface GenericRestParameterModel {
  /** @format uuid */
  id?: string;
  name?: string;
  value?: string;
  description?: string;
  removeEmptyValue?: boolean;
  excludeInPaging?: boolean;
  isSystem?: boolean;
  originalValue?: string;
  showReset?: boolean;
  dontUrlEncode?: boolean;
}

export interface GenericRestParameterWrapper {
  /** @format uuid */
  id?: string;
  name?: string;
  value?: string;
  description?: string;
  removeEmpty?: boolean;
  excludeInPaging?: boolean;
  isSystem?: boolean;
  originalValue?: string;
  showReset?: boolean;
}

export interface GenericRestPlaceholderDto {
  type?: PlaceholderType;
  key?: string;
  value?: string;
  originalValue?: string;
  showRefresh?: boolean;
  /** @format int32 */
  count?: number;
  keyValue?: string;
}

export interface GenericRestSetupAuth {
  /** @format int32 */
  authenticationType?: number;
  authorizationUrl?: string;
  accessUrl?: string;
  refreshTokenUrl?: string;
  scope?: string;
  state?: string;
  apiParameterKey?: string;
  /** @format int32 */
  apiParameterType?: number;
  /** @format int32 */
  requestMethod?: number;
  /** @format int32 */
  bodyType?: number;
  body?: string;
  responsePath?: string;
  /** @format int32 */
  expiryMethod?: number;
  /** @format int32 */
  expiryLength?: number;
  /** @format int32 */
  expiryUnits?: number;
  expiryPath?: string;
  parameters?: QueryParameter[];
  headers?: QueryParameter[];
}

export interface GenericRestSetupConnector {
  baseUrl?: string;
  /** @format int32 */
  requestMethod?: number;
  /** @format int32 */
  responseType?: number;
  bodyType?: BodyType;
  /** @format int32 */
  dateFormat?: number;
  customDateFormat?: string;
  timezone?: string;
  /** @format uuid */
  imageId?: string;
  userAgent?: string;
  /** @format uuid */
  connectionTestEntityId?: string;
}

export interface GenericRestSetupListModel {
  /** @format uuid */
  id?: string;
  name?: string;
  isSystem?: boolean;
  imageUrl?: string;
}

export interface GenericRestSetupModel {
  /** @format uuid */
  id?: string;
  name?: string;
  connector?: GenericRestSetupConnector;
  authentication?: GenericRestSetupAuth;
  variables?: GenericRestVariableModel[];
  parameters?: GenericRestParameterModel[];
  headers?: GenericRestParameterModel[];
  groups?: GenericRestGroupModel[];
  pages?: GenericRestPagingModel[];
  webhooks?: GenericRestWebhookListModel[];
  actions?: GenericRestActionListModel[];
  entities?: GenericRestEntityListModel[];
  lookups?: GenericRestLookupListModel[];
  errorHandling?: GenericRestErrorHandlingModel;
  message?: string;
}

export interface GenericRestVariableModel {
  /** @format uuid */
  id?: string;
  placeholder?: string;
  value?: string;
  description?: string;
  /** @format int32 */
  type?: number;
  required?: boolean;
  overridden?: boolean;
}

export interface GenericRestWebhookDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  /** @format uuid */
  webhookId?: string;
  /** @format uuid */
  genericRestSetupId?: string;
  runAsUser?: string;
  fields?: GenericRestField[];
  providerName?: string;
  webhookName?: string;
  groupName?: string;
  friendlyName?: string;
  name?: string;
  isRegistered?: boolean;
  allowCreate?: boolean;
  allowUpdate?: boolean;
  allowDelete?: boolean;
  allowAll?: boolean;
  callbackUri?: string;
  realTimeMapLinks?: RealTimeDataSourceMapLink[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface GenericRestWebhookEventSetup {
  allowCreate?: boolean;
  allowUpdate?: boolean;
  allowDelete?: boolean;
  parameterSource?: WebhookParameterSource;
  value?: string;
  createValue?: string;
  updateValue?: string;
  deleteValue?: string;
}

export interface GenericRestWebhookLinkModel {
  /** @format uuid */
  id?: string;
  name?: string;
  value?: string;
  path?: string;
  parameterSource?: WebhookParameterSource;
  parsedValue?: string;
}

export interface GenericRestWebhookListModel {
  /** @format uuid */
  id?: string;
  name?: string;
  groupName?: string;
}

export interface GenericRestWebhookModel {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  entityId?: string;
  name?: string;
  groupName?: string;
  allowRegister?: boolean;
  /** @format int32 */
  failureHttpResponseCode?: number;
  /** @format int32 */
  successHttpResponseCode?: number;
  webhookType?: string;
  bodyType?: BodyType;
  body?: string;
  eventType?: string;
  headers?: GenericRestParameterModel[];
  variables?: GenericDescriptionListItem[];
  fields?: GenericRestField[];
  eventSetup?: GenericRestWebhookEventSetup;
  links?: GenericRestWebhookLinkModel[];
}

export interface GenericTableField {
  fieldName?: string;
  fieldType?: string;
  fieldParam?: string;
  isKey?: boolean;
  isRequired?: boolean;
  isMapped?: boolean;
  isRestricted?: boolean;
  isSelected?: boolean;
  /** @format int32 */
  sequence?: number;
}

export interface GetAdditionalColumnAllowGroupByRequest {
  additionalColumnType?: string;
}

export interface GetConnectInstanceResponse {
  connectors?: ConnectorInstanceListModel[];
  providers?: Record<string, string>;
  /** @format int32 */
  standardUsed?: number;
  /** @format int32 */
  standardLimit?: number;
  /** @format int32 */
  premiumUsed?: number;
  /** @format int32 */
  premiumLimit?: number;
  /** @format int32 */
  filesUsed?: number;
  /** @format int32 */
  filesLimit?: number;
  /** @format int32 */
  ftpCloudUsed?: number;
}

export interface GetConnectInstanceResponseBaseResponse {
  data?: GetConnectInstanceResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GetCurrentUsageMetricsRequest {
  meter?: string;
  /** @format int32 */
  windowMonths?: number;
  selectedMonthKey?: string;
}

export interface GetDataSourceRequest {
  typeName?: string;
}

export interface GetDraftRequest {
  /**
   * required Id
   * @format uuid
   */
  id: string;
  /** required isReadOnly */
  isReadOnly: boolean;
}

export interface GetEntityAuditLogDetailRequest {
  /** @format int64 */
  auditLogId?: string;
}

export interface GetEntityAuditLogRequest {
  entityType?: AuditLogEntityType;
  entityId?: string;
}

export interface GetGroupHealthMetricsRequest {
  timeWindow?: string;
}

export interface GetIntegrationHealthMetricsRequest {
  timeWindow?: string;
  /**
   * Optional integration-group filter (set by the Group Health tile via the dashboard
   * interaction context). When provided, metrics cover only maps currently in this group.
   * Empty/null = no filter (whole customer).
   * @format uuid
   */
  groupId?: string;
}

export interface GetIntegrationLiveActivityRequest {
  /** @format int32 */
  recentCount?: number;
  /**
   * Optional integration-group filter (set by the Group Health tile via the dashboard
   * interaction context). When provided, only runs belonging to maps currently in this
   * group are returned. Empty/null = no filter (all runs).
   * @format uuid
   */
  groupId?: string;
}

export interface GetLatestHistoryRunActivityRequest {
  /** @format int32 */
  topCount?: number;
}

export interface GetMapForTaskRequest {
  id?: string;
  useDataSourceFromParent?: boolean;
}

export interface GetMapRunActivityDetailCountRequest {
  /** @format uuid */
  mapRunActivityId?: string;
}

export interface GetMapRunActivityDetailRequest {
  /** @format uuid */
  mapRunActivityId?: string;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
}

export interface GetMapRunActivityRequest {
  /** @format uuid */
  mapKey?: string;
  /** @format int64 */
  runNumber?: string;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
}

export interface GetMappingColumnsDataNewRequest {
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  targetConnectorInstanceId?: string;
  targetType?: DestinationType;
}

export interface GetMappingColumnsDataResponse {
  targetColumns?: MapLineParameterDto[];
  sourceColumns?: ColumnSettingDto[];
}

export interface GetMappingColumnsDataResponseBaseResponse {
  data?: GetMappingColumnsDataResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GetNextScheduleRunsRequest {
  /** @format int32 */
  topCount?: number;
}

export interface GetRealtimeActivityDetailRequest {
  /** @format uuid */
  mapRunActivityId?: string;
}

export interface GetRestDataSourceListRequest {
  /** @format uuid */
  restProvider?: string;
}

export interface GetRestDestinationDetailsRequest {
  /**
   * provider name
   * @format uuid
   */
  id?: string;
}

export interface GetRestDestinationDetailsResponse {
  instances?: GenericRestInstanceDto[];
  groups?: string[];
  actions?: GenericRestActionDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GetSourceAdditionalColumnTypeRequest {
  targetType?: DestinationType;
}

export interface GetSourceColumnsRequest {
  /** @format uuid */
  dataSourceId?: string;
}

export interface GetTargetColumnsDataRequest {
  /** @format uuid */
  targetConnectorInstanceId?: string;
  targetType?: DestinationType;
  currentTenant?: string;
  mapLineTechnicalName?: string;
  mapLineTechnicalValue?: string;
}

export interface GetTargetColumnsDataResponse {
  targetColumns?: MapLineParameterDto[];
  targetColumnTypes?: GenericListItem[];
}

export interface GetTargetColumnsDataResponseBaseResponse {
  data?: GetTargetColumnsDataResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GetTargetTenantDetailsRequest {
  target?: GenericListItem;
}

export interface GetTargetTenantDetailsResponse {
  tabTargetTenantsLabel?: string;
  tabTargetTenantsLabelSingular?: string;
  tabTargetTenantsShow?: boolean;
}

export interface GetTargetTenantDetailsResponseBaseResponse {
  data?: GetTargetTenantDetailsResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GetXmlSchemaRequest {
  /** @format uuid */
  fileHolderId?: string;
  includeTransform?: boolean;
}

/** Refer to GlobalRollingColumnsSetupModel */
export interface GlobalRollingColumnsSetupModel {
  /** @format uuid */
  id?: string;
  name?: string;
  description?: string;
  nextNumber?: string;
  mapDescription?: string;
  allowDelete?: boolean;
}

export interface GlobalRollingColumnsSetupModelListBaseResponse {
  data?: GlobalRollingColumnsSetupModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GlobalVariable {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  customerId?: string;
  name?: string;
  isSystem?: boolean;
  isUser?: boolean;
  isSecure?: boolean;
  value?: string;
  encryptedValue?: string;
}

export interface GlobalVariableDto {
  id?: string;
  /** @format uuid */
  globalVariableId?: string;
  name?: string;
  isSystem?: boolean;
  isUser?: boolean;
  isSecure?: boolean;
  value?: string;
  encryptedValue?: string;
  mapDescription?: string;
  allowDelete?: boolean;
}

export interface GlobalVariableDtoListBaseResponse {
  data?: GlobalVariableDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GlobalVariableExportDto {
  /** @format uuid */
  id?: string;
  name?: string;
  value?: string;
  isSecure?: boolean;
  isSystem?: boolean;
}

export type GoogleDriveInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  isCallback?: boolean;
  service?: string;
  clientId?: string;
  clientSecret?: string;
  userName?: string;
  scope?: string;
  state?: string;
  token?: string;
  refreshToken?: string;
  /** @format date-time */
  tokenExpiry?: string;
  /** @format date-time */
  secretExpiry?: string;
  fromMemoCache?: boolean;
};

export type GpInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  authenticationType?: MsGpAuthenticationType;
  serverName?: string;
  /** @format int32 */
  port?: number;
  dynamicsDbName?: string;
  defaultCompany?: string;
  defaultCompanyName?: string;
  useWindowsAuthentication?: boolean;
  username?: string;
  password?: string;
  encrypt?: boolean;
  useTrustServerCertificate?: boolean;
  requireProxyService?: boolean;
  gatewayUrl?: string;
  companies?: GenericListItem[];
};

export interface GpQueryDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  hasQueryBuilder?: boolean;
  interCompanyId?: string;
  trimStrings?: boolean;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface GroupHealthGroupDto {
  /** @format uuid */
  groupId?: string;
  name?: string;
  color?: string;
  textColor?: string;
  /** @format int32 */
  success?: number;
  /** @format int32 */
  stopped?: number;
  /** @format int32 */
  error?: number;
  /** @format int32 */
  total?: number;
  /** @format double */
  successRate?: number;
}

export interface GroupHealthMetricsDto {
  timeWindow?: string;
  all?: GroupHealthGroupDto;
  groups?: GroupHealthGroupDto[];
}

export interface GroupHealthMetricsDtoBaseResponse {
  data?: GroupHealthMetricsDto;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GuidBaseResponse {
  /** @format uuid */
  data?: string;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GuidStringDictionaryBaseResponse {
  data?: Record<string, string>;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface GuidStringKeyValuePair {
  /** @format uuid */
  key?: string;
  value?: string;
}

export interface GuidStringKeyValuePairListBaseResponse {
  data?: GuidStringKeyValuePair[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface HistoryOutputQueryRequest {
  mapId?: string;
  runNumber?: string;
}

export interface HomeLayoutDto {
  /** @format uuid */
  homeLayoutId?: string;
  /** @format uuid */
  customerId?: string;
  /** @format uuid */
  userId?: string;
  items?: HomeLayoutItemDto[];
  /** @format date-time */
  createDate?: string;
}

export interface HomeLayoutDtoBaseResponse {
  data?: HomeLayoutDto;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface HomeLayoutItemDto {
  /** @format uuid */
  homeLayoutItemId?: string;
  /** @format int32 */
  tileLeft?: number;
  /** @format int32 */
  tileTop?: number;
  /** @format int32 */
  tileWidth?: number;
  /** @format int32 */
  tileHeight?: number;
  /** @format int32 */
  type?: number;
  title?: string;
  /** @format int32 */
  addType?: number;
  backgroundColor?: string;
  textColor?: string;
  borderColor?: string;
  url?: string;
  extraConfig?: string;
}

export interface Int32BaseResponse {
  /** @format int32 */
  data?: number;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface IntegrationErrorDeleteMto {
  /** @format uuid */
  mapId?: string;
  tenantDescription?: string;
  /** @format int32 */
  runNumber?: number;
}

export interface IntegrationGroupModel {
  /** @format uuid */
  integrationGroupId?: string;
  integrationGroupName?: string;
  groupColor?: string;
  textColor?: string;
}

export interface IntegrationGroupModelListBaseResponse {
  data?: IntegrationGroupModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface IntegrationHealthDailyRunVolumeDto {
  date?: string;
  /** @format int32 */
  success?: number;
  /** @format int32 */
  stopped?: number;
  /** @format int32 */
  error?: number;
  /** @format int32 */
  total?: number;
  /** @format int64 */
  records?: string;
}

export interface IntegrationHealthKpiDto {
  key?: string;
  label?: string;
  /** @format double */
  value?: number;
  /** @format double */
  delta?: number;
  unit?: string;
  polarity?: string;
  sparkline?: number[];
}

export interface IntegrationHealthMetricsDto {
  timeWindow?: string;
  /** @format int32 */
  windowDays?: number;
  /** @format date-time */
  startDateUtc?: string;
  /** @format date-time */
  endDateUtc?: string;
  /** @format int32 */
  totalRuns?: number;
  /** @format double */
  successRate?: number;
  /** @format int32 */
  failedRuns?: number;
  /** @format int64 */
  recordsProcessed?: string;
  kpis?: IntegrationHealthKpiDto[];
  dailyRunVolume?: IntegrationHealthDailyRunVolumeDto[];
}

export interface IntegrationHealthMetricsDtoBaseResponse {
  data?: IntegrationHealthMetricsDto;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface IntegrationLiveActivityDto {
  /** @format int32 */
  activeRunCount?: number;
  /** @format int32 */
  completedLastHourCount?: number;
  /** @format int32 */
  recentCompletionCount?: number;
  /** @format double */
  averageThroughputRecordsPerSecond?: number;
  activeRuns?: IntegrationLiveRunDto[];
  recentCompletions?: IntegrationLiveTimelineItemDto[];
}

export interface IntegrationLiveActivityDtoBaseResponse {
  data?: IntegrationLiveActivityDto;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface IntegrationLiveRunDto {
  /** @format uuid */
  runId?: string;
  /** @format uuid */
  mapKey?: string;
  /** @format int64 */
  runNumber?: string;
  processId?: string;
  processName?: string;
  stage?: string;
  status?: string;
  statusTone?: string;
  /** @format int32 */
  percent?: number;
  /** @format int64 */
  processedRecords?: string;
  /** @format int64 */
  totalRecords?: string;
  /** @format date-time */
  startedAt?: string;
  /** @format date-time */
  lastUpdatedAt?: string;
  /** @format int32 */
  durationSeconds?: number;
  pipelineStage?: string;
  runType?: string;
}

export interface IntegrationLiveTimelineItemDto {
  /** @format uuid */
  runId?: string;
  /** @format uuid */
  mapKey?: string;
  /** @format int64 */
  runNumber?: string;
  processId?: string;
  processName?: string;
  status?: string;
  statusLabel?: string;
  statusTone?: string;
  /** @format int32 */
  percent?: number;
  /** @format int64 */
  successCount?: string;
  /** @format int64 */
  recordCount?: string;
  /** @format int64 */
  errorCount?: string;
  /** @format date-time */
  startedAt?: string;
  /** @format date-time */
  completedAt?: string;
  /** @format int32 */
  durationSeconds?: number;
  runType?: string;
}

export interface IntegrationProcessBcOdataApiLookupColumnDto {
  /** @format uuid */
  apiRoute?: string;
  serviceName?: string;
  returnField?: string;
  noDataOptions?: LookupColumnNoData;
  selectedFields?: StringStringKeyValuePair[];
  defaultValue?: string;
  /** Lookup criteria (ServiceField/ColumnName). Serialized as "filterFields" to match frontend. */
  filterFields?: IntegrationProcessBcOdataApiLookupColumnRestrictionDto[];
  cacheLevel?: CacheLevel;
  /**
   * See IntegrationProcessBcOdataFieldLookupColumnDto.IsLateBound - same meaning and the same
   *             true default, for the same back-compatibility reason.
   */
  isLateBound?: boolean;
}

export interface IntegrationProcessBcOdataApiLookupColumnRestrictionDto {
  /** @format uuid */
  id?: string;
  serviceField?: string;
  columnName?: string;
  /** SC-685: comparison operator token (eq/neq/lt/gt/lte/gte). Blank ⇒ equality. */
  operator?: string;
}

export interface IntegrationProcessColumnConnectionReferenceDto {
  columnType?: ColumnType;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  newConnectionId?: string;
  connectionName?: string;
  referenceNames?: string[];
  productType?: ConnectorProductType;
}

export interface IntegrationProcessConnectionReferenceDto {
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  newConnectionId?: string;
  connectionName?: string;
  referenceNames?: string[];
  productType?: ConnectorProductType;
}

export interface IntegrationProcessDto {
  createNew?: boolean;
  /** @format uuid */
  mapId?: string;
  /** @format uuid */
  draftId?: string;
  /** @format int32 */
  draftVersion?: number;
  /** @format date-time */
  lockExpireDate?: string;
  lockedUser?: string;
  /** @format uuid */
  customerId?: string;
  /** @minLength 1 */
  mapName: string;
  /** @minLength 1 */
  description: string;
  longRunning: boolean;
  overview?: string;
  /** @format date-time */
  createdDate?: string;
  createdUser?: string;
  scriptLanguage?: ScriptOptions;
  notes?: IntegrationProcessNoteDto[];
  source: IntegrationProcessSourceDto;
  target: DestinationModelBase;
  mapLines: IntegrationProcessMapLineDto[];
  sourceColumns: IntegrationProcessSourceColumnDto[];
  option: IntegrationProcessOptionDto;
  tasks?: IntegrationProcessTaskDto[];
  variables?: IntegrationProcessVariableDto[];
  /**
   * Per-item resolution for runtime-value conflicts. Maps a conflict group type (see
   * SmartConnect.Services.Dtos.RuntimeValueConflictTypes) to the list of item IDs whose live values
   * should be preserved instead of being overwritten by the draft. Items not listed use
   * the draft value (default behaviour).
   */
  keepCurrentItems?: Record<string, string[]>;
  entityType?: string;
  entityId?: string;
}

export interface IntegrationProcessDtoBaseResponse {
  data?: IntegrationProcessDto;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface IntegrationProcessExportDto {
  /** @format uuid */
  mapId?: string;
  mapName?: string;
  description?: string;
  overview?: string;
  /** @format date-time */
  createdDate?: string;
  createdUser?: string;
  longRunning?: boolean;
  notes?: IntegrationProcessNoteExportDto[];
  dataSource?: IntegrationProcessSourceExportDto;
  target?: IntegrationProcessTargetExportDto;
  mapLines?: IntegrationProcessMapLineExportDto[];
  sourceColumns?: IntegrationProcessSourceColumnExportDto[];
  option?: IntegrationProcessOptionExportDto;
  tasks?: IntegrationProcessTaskExportDto[];
  variables?: IntegrationProcessVariableExportDto[];
}

export interface IntegrationProcessIntegrationExportDto {
  /** @format uuid */
  integrationGroupId?: string;
  integrationGroupName?: string;
  groupColor?: string;
  textColor?: string;
}

export interface IntegrationProcessMapLineDto {
  /** @format int32 */
  sequence?: number;
  /** @format uuid */
  mapId?: string;
  /** @format uuid */
  mapLineId?: string;
  description?: string;
  technicalName?: string;
  technicalValue?: string;
  forDelete?: boolean;
  updateIfExists?: boolean;
  updateBlanks?: boolean;
  /** @format int64 */
  lineNumber?: string;
  grouped?: boolean;
  restrictions?: string;
  allowed?: boolean;
  isChild?: boolean;
  isParent?: boolean;
  parentDescription?: string;
  parentTechnicalName?: string;
  parentTechnicalValue?: string;
  parentGroup?: string;
  saveSendResult?: boolean;
  fieldJson?: string;
  parameters?: IntegrationProcessMapLineParameterDto[];
  columnSettings?: IntegrationProcessSourceColumnSettingDto[];
}

export interface IntegrationProcessMapLineExportDto {
  /** @format int32 */
  sequence?: number;
  description?: string;
  technicalName?: string;
  technicalValue?: string;
  forDelete?: boolean;
  updateIfExists?: boolean;
  updateBlanks?: boolean;
  /** @format int64 */
  lineNumber?: string;
  grouped?: boolean;
  restrictions?: string;
  allowed?: boolean;
  isChild?: boolean;
  isParent?: boolean;
  parentDescription?: string;
  parentTechnicalName?: string;
  parentTechnicalValue?: string;
  parentGroup?: string;
  saveSendResult?: boolean;
  fieldJson?: string;
  parameters?: IntegrationProcessMapLineParameterExportDto[];
  columnSettings?: IntegrationProcessSourceColumnSettingExportDto[];
}

export interface IntegrationProcessMapLineParameterDto {
  /** @format int32 */
  sequence?: number;
  /** @format uuid */
  mapLineParameterId?: string;
  name?: string;
  technicalName?: string;
  technicalValue?: string;
  typeString?: string;
  /** @format int64 */
  lineNumber?: string;
  isRequired?: boolean;
  requiredOrder?: boolean;
  /** @format uuid */
  mapLineId?: string;
  /** @format uuid */
  columnSettingId?: string;
  /** Refer to IntegrationProcessSourceColumnDto.Name */
  sourceColumnName?: string;
  allowEdit?: boolean;
  allowCreate?: boolean;
  isKey?: boolean;
  isExternalKey?: boolean;
}

export interface IntegrationProcessMapLineParameterExportDto {
  /** @format int32 */
  sequence?: number;
  name?: string;
  technicalName?: string;
  technicalValue?: string;
  typeString?: string;
  /** @format int64 */
  lineNumber?: string;
  isRequired?: boolean;
  requiredOrder?: boolean;
  /** Refer to IntegrationProcessSourceColumnDto.Name */
  sourceColumnName?: string;
  allowEdit?: boolean;
  allowCreate?: boolean;
}

export interface IntegrationProcessNoteDto {
  /** @format uuid */
  mapId?: string;
  /** @format uuid */
  noteId?: string;
  note?: string;
  /** @format date-time */
  createdDate?: string;
  user?: string;
}

export interface IntegrationProcessNoteExportDto {
  note?: string;
  /** @format date-time */
  createdDate?: string;
  user?: string;
}

export interface IntegrationProcessOptionDto {
  /** @format uuid */
  integrationGroupId?: string;
  integrationGroupName?: string;
  noDataOption?: string;
  runTasksNoDataOption?: string;
  blankDataOption?: string;
  concatenationSeparator?: string;
  errorProcessingFormat?: string;
  saveProcessErrors?: boolean;
  /** @format int32 */
  processErrorsLimit?: number;
  /** @format int32 */
  fileOutputLimit?: number;
  saveSystemEventErrors?: boolean;
  debugNextRun?: boolean;
  disableParallelSend?: boolean;
}

export interface IntegrationProcessOptionExportDto {
  integrationGroup?: IntegrationProcessIntegrationExportDto;
  noDataOption?: string;
  runTasksNoDataOption?: string;
  blankDataOption?: string;
  concatenationSeparator?: string;
  errorProcessingFormat?: string;
  saveProcessErrors?: boolean;
  /** @format int32 */
  processErrorsLimit?: number;
  /** @format int32 */
  fileOutputLimit?: number;
  saveSystemEventErrors?: boolean;
  disableParallelSend?: boolean;
  scriptLanguage?: string;
  logEnabled?: boolean;
  logErrors?: boolean;
  logXml?: boolean;
  logSuccess?: boolean;
  owner?: string;
  createdUser?: string;
  allowAnyRun?: boolean;
  returnSuccessIfNoData?: boolean;
  returnFailIfNoData?: boolean;
}

export interface IntegrationProcessParentColumnColumnDto {
  entityColumn?: string;
  noDataOptions?: LookupColumnNoData;
  defaultValue?: string;
}

export interface IntegrationProcessSourceColumnDto {
  /** @format uuid */
  mapId?: string;
  /** @format uuid */
  columnId?: string;
  /** @minLength 1 */
  name: string;
  baseColumnName?: string;
  columnType?: ColumnType;
  /** @format int32 */
  sequence?: number;
  allowGroupBy?: boolean;
  type?: string;
  additionalColumnsJson?: string;
  entityColumn?: string;
  noData?: LookupColumnNoData;
  defaultValue?: string;
  parentSourceColumn?: IntegrationProcessParentColumnColumnDto;
  bcOdataApiLookupColumn?: IntegrationProcessBcOdataApiLookupColumnDto;
}

export interface IntegrationProcessSourceColumnExportDto {
  name?: string;
  columnType?: ColumnType;
  columnTypeDisplayName?: string;
  /** @format int32 */
  sequence?: number;
  /** @format uuid */
  rollingColumnId?: string;
  /** Used for translation column */
  sourceColumnName?: string;
  /** @format uuid */
  translationTableId?: string;
  /** value to return if no data matched */
  noDataOption?: LookupColumnNoData;
  defaultValue?: string;
  /** Used For LocalConstantColumn */
  returnValue?: string;
  useAsGlobal?: boolean;
  /** Used for calculationcolumn */
  scriptCode?: string;
  /** Used For CustomRollingColumn */
  nextNumber?: string;
  updateGlobalVariable?: boolean;
  /** Used For DateCalculationColumn */
  sourceFormatId?: string;
  /** Used For DateCalculationColumn */
  targetFormatId?: string;
  allowGroupBy?: boolean;
  /**
   * Used for mssql column
   * @format uuid
   */
  connectionId?: string;
  /** Used for mssql column */
  database?: string;
  /** Used for mssql column */
  table?: string;
  /** used for nav odata field lookup */
  returnField?: string;
  /** used for nav odata field lookup */
  serviceName?: string;
  /** Used for mssql column | nav odata field lookup */
  fieldsJson?: string;
  /** Used for nav odata api lookup column */
  filterJson?: string;
  /**
   * salesforcesoqllookup: the raw SOQL (DbColumnBase.Query). Nullable/optional so older export
   * files without it deserialize cleanly.
   */
  query?: string;
  /** @format uuid */
  apiRoute?: string;
  apiRouteName?: string;
  cacheLevel?: CacheLevel;
  /**
   * genericrestlookup: the lookup's NAME (resolved on import against the target REST connection's
   * setup, since the GenericRestLookupId/EntityId differ across systems).
   */
  genericRestLookupName?: string;
  /** genericrestlookup: comma-separated return field names. */
  selectedFields?: string;
  /** genericrestlookup. */
  isLateBound?: boolean;
  includeResultInScripting?: boolean;
  /**
   * CE destination column fields (crmentitylookup / crmlookup / crmactivityparty /
   * crmlistoptionlookup). These are otherwise-unused DbColumnBase columns reused per CE column type;
   * see ProcessCrudService save/read switches for the mapping.
   */
  entity?: string;
  entityName?: string;
  reference?: string;
  entityColumn?: string;
  methodName?: string;
  attribute?: string;
  columnName?: string;
  delimiter?: string;
  /**
   * NetSuite REST additional/lookup column fields (SC-873) — otherwise-unused DbColumnBase columns
   * reused per column type; see ProcessCrudService save/read switches for the mapping. ServiceJson
   * carries SuiteQL/RESTlet return fields; RoleType/RoleCategory the List Option record type/field;
   * IsList/RollingColumnUsed/Today the Record Lookup flags; Attributes the Record Reference model JSON.
   */
  isList?: boolean;
  rollingColumnUsed?: boolean;
  today?: boolean;
  serviceJson?: string;
  roleType?: string;
  roleCategory?: string;
  attributes?: string;
  /** Record Lookup "Expand JSON Columns" flag — reuses DbColumnBase.AllCompanies (SC-873). */
  allCompanies?: boolean;
}

export interface IntegrationProcessSourceColumnSettingDto {
  /** @format uuid */
  mapLineId?: string;
  /** @format uuid */
  columnSettingId?: string;
  /** @format uuid */
  columnId?: string;
  sourceColumnName?: string;
  grouped?: boolean;
  aggregationFunction?: ColumnFunction;
}

export interface IntegrationProcessSourceColumnSettingExportDto {
  /** @format uuid */
  columnSettingId?: string;
  /** Refer to IntegrationProcessSourceColumnDto.Name */
  sourceColumnName?: string;
  grouped?: boolean;
  aggregationFunction?: ColumnFunction;
}

export interface IntegrationProcessSourceDto {
  /** @format uuid */
  mapId?: string;
  /** @format uuid */
  dataSourceAssociationBaseId?: string;
  type?: SourceType;
  dataSourceTypeName?: string;
  dataSourceName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  dataSourceConnectionId?: string;
  /** change type source */
  trackChangesForCreate?: boolean;
  trackChangesForUpdate?: boolean;
  trackChangesForDelete?: boolean;
  /**
   * For change sources implementing `IChangeSourceLastModified`: the persisted
   * last-run watermark (`LastRunSuccessDate`) from the data source association, as a
   * literal string (format `yyyy-MM-dd HH:mm:ss`). Null/empty when there is no watermark.
   *
   * Deliberately typed as System.String, not System.DateTime: the WebApp's
   * Newtonsoft pipeline runs with `DateTimeZoneHandling.Utc`, which would rewrite a
   * DateTime's zone on the wire (forced Z on serialize, convert-to-UTC on deserialize). A
   * string is read/written verbatim, so the value displays and round-trips exactly as stored
   * with no timezone conversion — the connector owns the zone (see
   * SmartConnect.Services.Dtos.IntegrationProcessSourceDto.LastProcessedTimezone).
   */
  lastProcessedRecordDate?: string;
  /**
   * Connector-declared timezone of SmartConnect.Services.Dtos.IntegrationProcessSourceDto.LastProcessedRecordDate. The engine
   * does NOT assume UTC — the connector owns this value. Surfaced so the UI can label
   * the date without converting it to local time.
   */
  lastProcessedTimezone?: string;
  sourceGroupings?: IntegrationProcessSourceGroupingDto[];
}

export interface IntegrationProcessSourceExportDto {
  /** @format uuid */
  dataSourceId?: string;
  type?: SourceType;
  dataSourceType?: string;
  sourceGroupings?: string[];
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  dataSourceJson?: string;
  /**
   * SC-697/698 data source pipeline (restrictions + calculated fields). When import
   * creates a new data source, this is re-applied to the created source.
   */
  pipeline?: DataSourcePipelineConfig;
  /** change type source */
  trackChangesForCreate?: boolean;
  trackChangesForUpdate?: boolean;
  trackChangesForDelete?: boolean;
}

export interface IntegrationProcessSourceGroupingDto {
  /** @format uuid */
  mapId?: string;
  /** @format int32 */
  sequence?: number;
  columnName?: string;
}

export interface IntegrationProcessTargetExportDto {
  targetType?: DestinationType;
  productTypes?: ConnectorProductType[];
  destinationName?: string;
  /** @format uuid */
  connectorInstanceId?: string;
  destinationJson?: string;
  destination?: string;
  /**
   * Target Organizations (tenants) selected on the source integration. Round-tripped so a
   * duplicate/import preserves the org selection (SC-907). Only descriptive/selection fields
   * are carried — the connection binding is re-derived from the chosen target connection on
   * import (see `ProcessImportService.FillTargetAsync`), and per-tenant DB credentials
   * are intentionally not exported (secrets stay in the connection instance).
   */
  tenants?: IntegrationProcessTargetTenantExportDto[];
}

export interface IntegrationProcessTargetTenantExportDto {
  /** @format int32 */
  sequence?: number;
  name?: string;
  serverName?: string;
  technicalName?: string;
  technicalValue?: string;
  isUserAdded?: boolean;
  selected?: boolean;
  includeInScripting?: boolean;
}

export interface IntegrationProcessTaskConnectionReferenceDto {
  taskName?: string;
  taskTypeName?: string;
  taskStage?: string;
  onSuccess?: string;
  onFailure?: string;
  enabled?: boolean;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  newConnectionId?: string;
  connectionName?: string;
  referenceNames?: string[];
  productType?: ConnectorProductType;
}

export interface IntegrationProcessTaskDto {
  /** @format int32 */
  sequence?: number;
  /** @format uuid */
  mapId?: string;
  /** @format uuid */
  taskId?: string;
  taskName?: string;
  taskTypeName?: string;
  taskStage?: TaskTypes;
  onSuccess?: TaskResult;
  onFailure?: TaskResult;
  enabled?: boolean;
  usesSourceFields?: boolean;
  usesGlobalVariables?: boolean;
  detailsJson?: string;
}

export interface IntegrationProcessTaskExportDto {
  /** @format int32 */
  sequence?: number;
  taskName?: string;
  taskTypeName?: string;
  taskStage?: TaskTypes;
  onSuccess?: TaskResult;
  onFailure?: TaskResult;
  enabled?: boolean;
  usesSourceFields?: boolean;
  usesGlobalVariables?: boolean;
  detailsJson?: string;
}

export interface IntegrationProcessVariableDto {
  /** @format int32 */
  sequence?: number;
  /** @format uuid */
  mapId?: string;
  /** @format uuid */
  mapVariableId?: string;
  /** @format uuid */
  globalVariableId?: string;
  name?: string;
  isSecure?: boolean;
  isValueOverriden?: boolean;
  persistValueFromRun?: boolean;
  selectAtRuntime?: boolean;
  runtimeValueType?: MapVariableValueType;
  runtimePrompt?: string;
  persistValueFromErrorsRun?: boolean;
  requireValue?: boolean;
  value?: string;
}

export interface IntegrationProcessVariableExportDto {
  /** @format int32 */
  sequence?: number;
  persistValueFromRun?: boolean;
  selectAtRuntime?: boolean;
  runtimeValueType?: MapVariableValueType;
  runtimePrompt?: string;
  persistValueFromErrorsRun?: boolean;
  requireValue?: boolean;
  value?: string;
  globalVariable?: GlobalVariableExportDto;
}

export interface IntegrationStructureModel {
  /** @format uuid */
  mapId?: string;
  tasks?: ProcessTaskModel[];
  lines?: ProcessMapLineModel[];
  lookups?: LookupColumnModel[];
  notes?: string[];
  variables?: string[];
}

export interface JsonDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  sourceLocationType?: FileDataSourceSourceLocationType;
  schemaHeader?: SchemaHeader;
  /** @format uuid */
  fileHolderId?: string;
  templateFile?: string;
  sourceFolder?: string;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface JsonFileDestinationModel {
  destinationType?: DestinationType;
  jsonFormat?: JsonFormatModel;
  fileDestinationPath?: string;
  fileName?: string;
  columnCharacterSet?: TextFileCharacterSet;
  separateFilePerKeyField?: boolean;
  appendKeyFieldToFilename?: boolean;
  overwriteFile?: boolean;
  appendDateTime?: boolean;
  includeColumnHeadings?: boolean;
  encloseInQuotes?: boolean;
  columnHeaders?: GenericFileColumnHeader[];
  /** @format uuid */
  sourceId?: string;
  msGpDestinationType?: string;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  toFile?: boolean;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface JsonFolderDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  filesAtRuntime?: boolean;
  successFolder?: string;
  failureFolder?: string;
  emptyFileAction?: string;
  overwriteFile?: boolean;
  appendDateTime?: boolean;
  instances?: ConnectorOption[];
  sourceLocationType?: FileDataSourceSourceLocationType;
  schemaHeader?: SchemaHeader;
  /** @format uuid */
  fileHolderId?: string;
  templateFile?: string;
  sourceFolder?: string;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface JsonFormatChildEntityModel {
  bodyTemplate?: string;
  name?: string;
  description?: string;
  fields?: JsonFormatFieldModel[];
}

export interface JsonFormatFieldModel {
  checked?: boolean;
  eOneJsonNodeText?: string;
  eOneJsonNodeType?: string;
  eOneJsonNodePath?: string;
  eOneRequired?: boolean;
  eOneJsonNodeItems?: JsonFormatFieldModel[];
  eOneJsonNodeId?: string;
}

export interface JsonFormatModel {
  bodyTemplate?: string;
  fields?: JsonFormatFieldModel[];
  childEntities?: JsonFormatChildEntityModel[];
  nodes?: JsonFormatNodeModel[];
  rootIsArray?: boolean;
}

export interface JsonFormatNodeModel {
  eOneJsonNodeId?: string;
  name?: string;
  type?: string;
  '@checked'?: boolean;
  required?: boolean;
  staticValue?: string;
  eOneJsonNodeItems?: JsonFormatNodeModel[];
}

export interface JsonValidateTemplateRequest {
  template?: string;
  fields?: JsonFormatFieldModel[];
  children?: JsonFormatChildEntityModel[];
}

export interface LoadRestContentRequest {
  /** @format uuid */
  setupId?: string;
  /** @format uuid */
  connectorInstanceId?: string;
  /** For metadata mode — an explicit URL to query */
  targetUrl?: string;
  /**
   * For sample mode — resolve URL from entity/action/lookup endpoint
   * @format uuid
   */
  entityId?: string;
  /** @format uuid */
  actionId?: string;
  /** @format uuid */
  lookupId?: string;
  /** Manual headers when no connector instance is selected */
  manualHeaders?: NameValuePair[];
  /** Manual query parameters when no connector instance is selected */
  manualParameters?: NameValuePair[];
}

export interface LoadRestContentResponse {
  content?: string;
  /** Detected format: "json" or "xml" */
  contentType?: string;
}

export interface LoadRestContentResponseBaseResponse {
  data?: LoadRestContentResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface LoadRestFieldsRequest {
  /** @format uuid */
  entityId?: string;
  /** @format uuid */
  connectorInstanceId?: string;
  /** "sample" = query entity endpoint, "metadata" = query a user-supplied metadata URL */
  mode?: string;
  /** Only used when Mode = "metadata" */
  metadataEndpoint?: string;
}

export interface LogStoreLatestRunModel {
  /** @format int32 */
  logNumber?: number;
  /** @format date-time */
  logTime?: string;
  formattedLogTime?: string;
  records?: LogStoreRecordModel[];
}

export interface LogStoreLatestRunModelBaseResponse {
  data?: LogStoreLatestRunModel;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface LogStoreRecordModel {
  /** @format int64 */
  id?: string;
  /** @format int32 */
  logNumber?: number;
  /** @format date-time */
  logTime?: string;
  requestMethod?: string;
  requestEndpoint?: string;
  requestHeaders?: string;
  requestBody?: string;
  /** @format int32 */
  responseStatus?: number;
  responseHeaders?: string;
  responseBody?: string;
  errorMessage?: string;
  logContext?: string;
  processingMessage?: string;
}

export interface LogStoreRecordModelListBaseResponse {
  data?: LogStoreRecordModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface LogStoreSummaryModel {
  /** @format int32 */
  logNumber?: number;
  /** @format int32 */
  logType?: number;
  logTypeLabel?: string;
  /** @format uuid */
  dataSourceId?: string;
  dataSourceName?: string;
  /** @format uuid */
  mapId?: string;
  mapName?: string;
  formattedLogTime?: string;
  /** @format date-time */
  logTime?: string;
  /** @format int32 */
  recordCount?: number;
  userEmail?: string;
}

export interface LogStoreSummaryModelListBaseResponse {
  data?: LogStoreSummaryModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface LookupColumnModel {
  /** @format uuid */
  mapLineId?: string;
  name?: string;
  columnName?: string;
  lookupType?: string;
  target?: string;
}

/** Refer to MapDataColumnModel */
export interface MapDataColumnDto {
  /** @format uuid */
  id?: string;
  columnName?: string;
  columnType?: string;
  columnTypeName?: string;
  grouped?: boolean;
  allowGroupBy?: boolean;
  aggregateFunction?: GenericListItem;
  imageClass?: string;
  /** @format int32 */
  sequence?: number;
  includeInScripting?: boolean;
}

export interface MapLineDto {
  id?: string;
  description?: string;
  mapId?: string;
  mapDescription?: string;
  technicalName?: string;
  technicalValue?: string;
  forDelete?: boolean;
  forDeleteEnabled?: boolean;
  forDeleteVisible?: boolean;
  updateIfExists?: boolean;
  updateIfExistsEnabled?: boolean;
  updateIfExistsVisible?: boolean;
  updateBlanks?: boolean;
  updateBlanksEnabled?: boolean;
  updateBlanksVisible?: boolean;
  groupByOption?: MapLineGroupByOption;
  /** @format int32 */
  sequence?: number;
  /** @format int64 */
  lineNumber?: string;
  mapped?: boolean;
  grouped?: boolean;
  restrictions?: string;
  allowed?: boolean;
  sourceColumns?: MapDataColumnDto[];
  targetColumns?: MapLineParameterDto[];
  parentColumns?: MapParentColumnDto[];
  modelErrors?: string[];
  isChild?: boolean;
  isParent?: boolean;
  /** @format int32 */
  level?: number;
  levelDescription?: string;
  parentDescription?: string;
  parentTechnicalName?: string;
  parentTechnicalValue?: string;
  parentGroup?: string;
  saveSendResult?: boolean;
  sendResultFields?: MapLineResultFieldDto[];
}

export interface MapLineDtoListBaseResponse {
  data?: MapLineDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

/** Refer to MapLineParameterModel */
export interface MapLineParameterDto {
  id?: string;
  typeString?: string;
  /** @format int64 */
  number?: string;
  technicalName?: string;
  technicalValue?: string;
  name?: string;
  columnType?: GenericListItem;
  requiredOrder?: boolean;
  columnSetting?: ColumnSettingDto;
  columnSettingColumnName?: string;
  columnSettingColumnType?: GenericListItem;
  error?: string;
  isRequired?: boolean;
  allowEdit?: boolean;
  allowCreate?: boolean;
  isKey?: boolean;
  isExternalKey?: boolean;
  required?: string;
  options?: GenericListItem[];
}

export interface MapLineParameterDtoListBaseResponse {
  data?: MapLineParameterDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface MapLineResultField {
  id?: string;
  columnName?: string;
  fieldName?: string;
  noData?: LookupColumnNoData;
  defaultValue?: string;
  includeInGrouping?: boolean;
}

export interface MapLineResultFieldDto {
  columnName?: string;
  fieldName?: string;
  noData?: GenericListItem;
  defaultValue?: string;
  includeInGrouping?: boolean;
}

/** Refer to MapParentColumnModel */
export interface MapParentColumnDto {
  columnName?: string;
  fieldName?: string;
  noData?: GenericListItem;
  defaultValue?: string;
}

export interface MapRunActivityDetailModel {
  /** @format int64 */
  id?: string;
  /** @format uuid */
  mapRunActivityId?: string;
  /** @format uuid */
  customerId?: string;
  /** @format uuid */
  mapKey?: string;
  /** @format int64 */
  runNumber?: string;
  message?: string;
  /** @format date-time */
  messageDateTime?: string;
}

export interface MapRunActivityDetailModelListBaseResponse {
  data?: MapRunActivityDetailModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface MapRunActivityModel {
  /** @format uuid */
  runId?: string;
  /** @format uuid */
  parentRunId?: string;
  /** @format uuid */
  customerId?: string;
  /** @format uuid */
  userId?: string;
  email?: string;
  /** @format uuid */
  mapKey?: string;
  mapId?: string;
  mapDescription?: string;
  /** @format int64 */
  runNumber?: string;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  /** @format int64 */
  recordCount?: string;
  /** @format int64 */
  successCount?: string;
  /** @format int64 */
  errorCount?: string;
  /** @format int64 */
  restrictCount?: string;
  /** @format int64 */
  sourceRecordCount?: string;
  /** @format int64 */
  dataSourceRestrictCount?: string;
  status?: MapRunStatus;
  statusStr?: string;
  cancelledBy?: string;
  /** @format date-time */
  cancelledAt?: string;
  /** @format int64 */
  cancelledRecordCount?: string;
  cancelTrigger?: CancelTrigger;
  cancelReason?: string;
  message?: string;
  downloads?: boolean;
  fileHolders?: FileHolderRef[];
  /** @format date-time */
  messageDateTime?: string;
  messageType?: SummaryMessageType;
  mapSource?: string;
  mapTarget?: string;
  runType?: string;
  hideEdit?: boolean;
  hideDelete?: boolean;
  /** @format int32 */
  percent?: number;
}

export interface MapRunActivityModelListBaseResponse {
  data?: MapRunActivityModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface MapRunActivityModelPage {
  items?: MapRunActivityModel[];
  /** @format int64 */
  totalCount?: string;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  totalPages?: number;
}

export interface MapRunActivityModelPageBaseResponse {
  data?: MapRunActivityModelPage;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface MapRunActivitySummaryModel {
  /** @format uuid */
  mapKey?: string;
  mapId?: string;
  mapDescription?: string;
  /** @format int64 */
  runNumber?: string;
  /** @format date-time */
  startTime?: string;
  /** @format int32 */
  successCount?: number;
  /** @format int32 */
  runCount?: number;
  mapSource?: string;
  mapTarget?: string;
  successful?: boolean;
  /** @format int32 */
  percent?: number;
}

export interface MapRunActivitySummaryModelListBaseResponse {
  data?: MapRunActivitySummaryModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export type MsGraphInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  serviceUrl?: string;
  odataServiceUrl?: string;
  tenantId?: string;
  clientId?: string;
  clientSecret?: string;
  platforms?: string[];
  defaultCompany?: string;
  defaultCompanyName?: string;
  userName?: string;
  token?: string;
  state?: string;
  scope?: string;
  /** @format date-time */
  tokenExpiry?: string;
  refreshToken?: string;
  companies?: GenericListItem[];
  fromMemoCache?: boolean;
};

export interface MsNavOdataAction {
  id?: string;
  name?: string;
  parameterType?: string;
  typeScriptType?: string;
  /** @format int32 */
  sequence?: number;
  fields?: MapLineResultField[];
}

export interface MsNavOdataActionListBaseResponse {
  data?: MsNavOdataAction[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface MsNavOdataApiDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  company?: string;
  /** @format uuid */
  companyId?: string;
  /** @format uuid */
  apiRoute?: string;
  endpointOverride?: string;
  apiService?: MsNavOdataService;
  entityType?: string;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface MsNavOdataApiDataSourceSetupDto {
  /** @format uuid */
  id?: string;
  company?: string;
  description?: string;
  baseEntity?: string;
}

export interface MsNavOdataApiDataSourceSetupDtoListBaseResponse {
  data?: MsNavOdataApiDataSourceSetupDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface MsNavOdataApiDestinationModel {
  /** @format uuid */
  route?: string;
  apiServices?: MsNavOdataService[];
  rollbackTransaction?: boolean;
  destinationType?: DestinationType;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  toFile?: boolean;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface MsNavOdataApiRouteModel {
  /** @format uuid */
  id?: string;
  route?: string;
  selected?: boolean;
  unavailable?: string;
  originalSelected?: boolean;
}

export interface MsNavOdataApiRouteModelListBaseResponse {
  data?: MsNavOdataApiRouteModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface MsNavOdataBulkDataSourceDto {
  company?: string;
  services?: GenericListItem[];
  fields?: GenericFieldListItem[];
  friendlyName?: string;
  name?: string;
  viewName?: string;
  largeImage?: string;
  typeName?: string;
  queryText?: string;
  trimStrings?: boolean;
  /** @format uuid */
  registeredConnectorId?: string;
  providerName?: string;
  imageUrl?: string;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  fromQueryBuilder?: boolean;
  freeTextDatabaseName?: boolean;
}

export interface MsNavOdataBulkDataSourceDtoListBaseResponse {
  data?: MsNavOdataBulkDataSourceDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface MsNavOdataBulkDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  company?: string;
  serviceName?: string;
  serviceType?: string;
  displayUrl?: string;
  apiService?: MsNavOdataService[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface MsNavOdataChangeDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  company?: string;
  /** @format uuid */
  companyId?: string;
  table?: string;
  services?: MsNavOdataService[];
  restrictions?: MsNavOdataChangeRestriction[];
  selectedFields?: GenericCheckBoxListItem[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface MsNavOdataChangeDataSourceServiceDto {
  /** @format uuid */
  id?: string;
  name?: string;
  entityType?: string;
  /** @format int32 */
  sequence?: number;
  linkedEntity?: string;
  linkedEntityType?: string;
  serviceFields?: MsNavOdataChangeDataSourceServiceFieldDto[];
}

export interface MsNavOdataChangeDataSourceServiceField {
  serviceFieldName?: string;
  sourceFieldName?: string;
  sourceFieldOverwrite?: string;
}

export interface MsNavOdataChangeDataSourceServiceFieldDto {
  /** @format uuid */
  id?: string;
  serviceFieldName?: string;
  sourceFieldName?: string;
  sourceFieldOverwrite?: string;
}

/** Refer to MsNavOdataChangeDataSourceSetupModel */
export interface MsNavOdataChangeDataSourceSetupDto {
  company?: string;
  table?: string;
  restrictions?: MsNavOdataChangeRestrictionDto[];
  services?: MsNavOdataChangeDataSourceServiceDto[];
  friendlyName?: string;
  name?: string;
  viewName?: string;
  largeImage?: string;
  typeName?: string;
  /** @format uuid */
  registeredConnectorId?: string;
  forCreate?: boolean;
  forUpdate?: boolean;
  forDelete?: boolean;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  queryText?: string;
  trimStrings?: boolean;
  fromQueryBuilder?: boolean;
  freeTextDatabaseName?: boolean;
}

export interface MsNavOdataChangeDataSourceSetupDtoListBaseResponse {
  data?: MsNavOdataChangeDataSourceSetupDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface MsNavOdataChangeFilter {
  /** @format int32 */
  id?: number;
  serviceFieldName?: string;
  sourceFieldName?: string;
  sourceFieldsOverwrite?: string;
}

export interface MsNavOdataChangeRestriction {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  fieldNo?: number;
  tableField?: string;
  tableValue?: string;
  operator?: NavOperator;
}

export interface MsNavOdataChangeRestrictionDto {
  /** @format uuid */
  id?: string;
  /** @format int32 */
  fieldNo?: number;
  tableField?: string;
  tableValue?: string;
}

export interface MsNavOdataDestinationModel {
  services?: string[];
  includeLinks?: boolean;
  removeBlankProperties?: boolean;
  ignoreUpdateConflicts?: boolean;
  destinationType?: DestinationType;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  toFile?: boolean;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface MsNavOdataGetCompaniesAndRoutes {
  companies?: GenericListItem[];
  apiRoutes?: MsNavOdataApiRouteModel[];
}

export interface MsNavOdataGetCompaniesAndRoutesBaseResponse {
  data?: MsNavOdataGetCompaniesAndRoutes;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export type MsNavOdataInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  serviceUrl?: string;
  usesOAuth?: boolean;
  usesServiceToService?: boolean;
  directoryId?: string;
  clientId?: string;
  clientSecret?: string;
  authenticationType?: DynAuthenticationType;
  bcCredentialType?: BcCredentialTypes;
  domain?: string;
  userName?: string;
  password?: string;
  defaultCompany?: string;
  /** @format uuid */
  defaultCompanyId?: string;
  allowLongTimeOut?: boolean;
  retryFailedRequests?: boolean;
  /** @format int32 */
  retryCount?: number;
  /** @format int32 */
  timeOutMinutes?: number;
  additionalApis?: MsNavOdataApiRouteModel[];
  scope?: string;
  state?: string;
  token?: string;
  refreshToken?: string;
  /** @format date-time */
  tokenExpiry?: string;
  /** @format date-time */
  secretExpiry?: string;
  extensionVersion?: string;
  companies?: GenericListItem[];
  fromMemoCache?: boolean;
};

export interface MsNavOdataRealtimeDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  allowCreate?: boolean;
  allowUpdate?: boolean;
  allowDelete?: boolean;
  allowAll?: boolean;
  /** @format uuid */
  companyId?: string;
  company?: string;
  /** @format uuid */
  apiRoute?: string;
  /** @format date-time */
  expirationDateTime?: string;
  /** @format uuid */
  registerUser?: string;
  entityTechnicalName?: string;
  entityDescription?: string;
  logAction?: string;
  linkedServices?: MsNavOdataService[];
  serviceFields?: MsNavOdataServiceField[];
  mainEntityFields?: MsNavOdataServiceField[];
  friendlyName?: string;
  name?: string;
  isRegistered?: boolean;
  callbackUri?: string;
  realTimeMapLinks?: RealTimeDataSourceMapLink[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface MsNavOdataService {
  /** @format uuid */
  id?: string;
  /** @format int32 */
  rowId?: number;
  service?: string;
  serviceType?: string;
  type?: OdataApiDestinationType;
  navigationType?: NavigationTypes;
  jsonValue?: string;
  selected?: boolean;
  fields?: MsNavOdataServiceField[];
  changeFields?: MsNavOdataChangeDataSourceServiceField[];
  childServices?: MsNavOdataService[];
  changeFilters?: MsNavOdataChangeFilter[];
  actions?: MsNavOdataAction[];
  resultFields?: MapLineResultField[];
  navigationServices?: GenericCheckBoxListItem[];
  linkedEntity?: string;
  /** @format uuid */
  parentId?: string;
  filterString?: string;
  endpointOverride?: string;
  rollback?: boolean;
  /** @format int32 */
  sequence?: number;
}

export interface MsNavOdataServiceField {
  /** @format int32 */
  id?: number;
  /** @format uuid */
  serviceId?: string;
  fieldName?: string;
  userDisplayName?: string;
  technicalValue?: string;
  jsonValue?: string;
  selected?: boolean;
  entityName?: string;
  entityType?: string;
}

/** Refer to MsSqlQueryDataSourceSetupModel */
export interface MsSqlQueryDataSourceSetupDto {
  mssqlDatabase?: string;
  friendlyName?: string;
  name?: string;
  viewName?: string;
  largeImage?: string;
  typeName?: string;
  queryText?: string;
  trimStrings?: boolean;
  /** @format uuid */
  registeredConnectorId?: string;
  providerName?: string;
  imageUrl?: string;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  fromQueryBuilder?: boolean;
  freeTextDatabaseName?: boolean;
}

export interface MsSqlQueryDataSourceSetupDtoListBaseResponse {
  data?: MsSqlQueryDataSourceSetupDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface MssqlChangeDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  hasQueryBuilder?: boolean;
  mssqlDatabase?: string;
  mssqlTable?: string;
  genericTableField?: GenericTableField[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

/**
 * Result of enumerating the databases available to a MsSql connection.
 * When the credentials can reach master we return the full database list and
 * SmartConnect.Services.Dtos.Response.MssqlDatabaseListResponse.SingleDatabase is false; when they cannot (no master access) the list is
 * empty and SmartConnect.Services.Dtos.Response.MssqlDatabaseListResponse.SingleDatabase is true so the user enters the database manually.
 * The flag is persisted with the connection (see MssqlService.SaveConnectionImpl).
 */
export interface MssqlDatabaseListResponse {
  databases?: string[];
  singleDatabase?: boolean;
}

export interface MssqlDatabaseListResponseBaseResponse {
  /**
   * Result of enumerating the databases available to a MsSql connection.
   * When the credentials can reach master we return the full database list and
   * SmartConnect.Services.Dtos.Response.MssqlDatabaseListResponse.SingleDatabase is false; when they cannot (no master access) the list is
   * empty and SmartConnect.Services.Dtos.Response.MssqlDatabaseListResponse.SingleDatabase is true so the user enters the database manually.
   * The flag is persisted with the connection (see MssqlService.SaveConnectionImpl).
   */
  data?: MssqlDatabaseListResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface MssqlDestinationModelBase {
  mssqlDatabase?: string;
  useTransaction?: boolean;
  toFile?: boolean;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  destinationType?: DestinationType;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export type MssqlInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  mssqlServer?: string;
  useCredentials?: boolean;
  authType?: MssqlAuthenticationType;
  username?: string;
  password?: string;
  encrypt?: boolean;
  useTrustServerCertificate?: boolean;
  isServerless?: boolean;
  freeTextDatabaseName?: boolean;
  mssqlDatabase?: string;
  localQueueEnabled?: boolean;
  /** @format int32 */
  retryIntervalSec?: number;
  increaseIntervalWithEveryAttempt?: boolean;
  /** @format int32 */
  giveUpAfterMinutes?: number;
  recordSuccess?: boolean;
  /** @format int32 */
  purgeQueueHoursOld?: number;
  /** @format int32 */
  connectionTimeout?: number;
  /** @format int32 */
  commandTimeout?: number;
  /** @format int32 */
  packetSize?: number;
  databases?: string[];
  singleDatabase?: boolean;
  tenantCapabilities?: TenantCapability[];
  hasTenantCapabilities?: boolean;
};

export interface MssqlInstanceModelListBaseResponse {
  data?: MssqlInstanceModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

/**
 * A lookup Test run from the MSSQL or Fabric additional-column editor: the lookup as it stands in
 * the form, with a value supplied for each criterion, so the tester sees what the configuration
 * returns before the integration is saved.
 */
export interface MssqlLookupPreviewModel {
  /** @format uuid */
  connectionId?: string;
  database?: string;
  table?: string;
  /** The lookup's return fields. Empty falls back to a single-field lookup's return column. */
  returnFields?: string[];
  returnValue?: string;
  restrictions?: MssqlLookupPreviewRestriction[];
  /** @format int32 */
  previewCount?: number;
  /**
   * When true, capture the request/response of the test query and persist it as
   *             integration log records (keyed by SmartConnect.Services.Dtos.Request.MssqlLookupPreviewModel.MapId), viewable in the System Request Log.
   */
  logRequests?: boolean;
  /**
   * The integration the lookup column belongs to — the key the saved logs are stored under.
   * @format uuid
   */
  mapId?: string;
}

/**
 * One criterion with its value already supplied by the tester. There is no value source here: the
 * editor resolves source column, local constant or global variable to a literal before asking, the
 * way the run resolves them per row.
 */
export interface MssqlLookupPreviewRestriction {
  targetColumn?: string;
  /**
   * The operator as the form holds it — a SmartConnect.Engine.Shared.Enums.NavOperator name, which is what
   *             the saved restriction JSON carries too.
   */
  operator?: NavOperator;
  value?: string;
}

export interface MssqlQueryDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  database?: string;
  trimStrings?: boolean;
  hasQueryBuilder?: boolean;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface MssqlRealTimeDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  allowCreate?: boolean;
  allowUpdate?: boolean;
  allowDelete?: boolean;
  allowAll?: boolean;
  trimStrings?: boolean;
  mssqlDatabase?: string;
  mssqlTable?: string;
  realTimeDataSourceFields?: GenericTableField[];
  logAction?: WebServiceLoggingAction;
  localQueueEnabled?: boolean;
  /** @format int32 */
  retryIntervalSec?: number;
  increaseIntervalWithEveryAttempt?: boolean;
  /** @format int32 */
  giveupAfterMinutes?: number;
  recordSuccess?: boolean;
  /** @format int32 */
  purgeQueueHoursOld?: number;
  /** @deprecated */
  linkedMaps?: RealTimeLinkedMapModel[];
  friendlyName?: string;
  name?: string;
  isRegistered?: boolean;
  callbackUri?: string;
  realTimeMapLinks?: RealTimeDataSourceMapLink[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface MssqlStoredProcDestinationModel {
  procedure?: string;
  isEConnectProcedure?: boolean;
  destinationType?: DestinationType;
  mssqlDatabase?: string;
  useTransaction?: boolean;
  toFile?: boolean;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface MssqlTableDestinationModel {
  destinationType?: DestinationType;
  mssqlTable?: string;
  table?: string;
  mssqlDatabase?: string;
  useTransaction?: boolean;
  toFile?: boolean;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface MySqlChangeDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  hasQueryBuilder?: boolean;
  database?: string;
  table?: string;
  changeTableFields?: GenericTableField[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export type MySqlInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  server?: string;
  userName?: string;
  password?: string;
  /** @format int32 */
  port?: number;
  encrypt?: boolean;
  freeTextDatabaseName?: boolean;
  database?: string;
  localQueueEnabled?: boolean;
  /** @format int32 */
  retryIntervalSec?: number;
  increaseIntervalWithEveryAttempt?: boolean;
  /** @format int32 */
  giveUpAfterMinutes?: number;
  recordSuccess?: boolean;
  /** @format int32 */
  purgeQueueHoursOld?: number;
  /** @format int32 */
  connectionTimeout?: number;
  /** @format int32 */
  commandTimeout?: number;
  /** @format int32 */
  packetSize?: number;
};

export interface MySqlInstanceModelListBaseResponse {
  data?: MySqlInstanceModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface MySqlQueryDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  hasQueryBuilder?: boolean;
  database?: string;
  trimStrings?: boolean;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface MySqlStoredProcDestinationModel {
  database?: string;
  useTransaction?: boolean;
  toFile?: boolean;
  procedure?: string;
  destinationType?: DestinationType;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface MySqlTableDestinationModel {
  database?: string;
  useTransaction?: boolean;
  toFile?: boolean;
  table?: string;
  destinationType?: DestinationType;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface NameValuePair {
  name?: string;
  value?: string;
}

export interface NavOdataApiServiceErrorInfo {
  /** @format uuid */
  id?: string;
  errorMessage?: string;
}

export interface NavOdataApiServiceValidateRequest {
  /**
   * Required. Connector instance id.
   * @format uuid
   */
  connectorInstanceId?: string;
  /**
   * Required. Route id.
   * @format uuid
   */
  routeId?: string;
  services?: MsNavOdataService[];
}

export interface NavOdataApiServiceValidateResponse {
  isValid?: boolean;
  errors?: NavOdataApiServiceErrorInfo[];
}

export interface NavOdataApiServiceValidateResponseBaseResponse {
  data?: NavOdataApiServiceValidateResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface NetSuiteChangeDataSourceModel {
  displayName?: boolean;
  includeChildren?: boolean;
  roleCategory?: string;
  roleType?: string;
  roleSubType?: string;
  runOn?: string;
  dateTrackingField?: string;
  runOnDateFormat?: string;
  accountTimeZone?: string;
  logPreview?: boolean;
  expandJsonColumns?: boolean;
  sourceType?: DataSourceType;
  allowPreviewLogging?: boolean;
  schemaShowParent?: boolean;
  allowAddSchemaColumn?: boolean;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface NetSuiteChildActionRequest {
  roleType?: string;
  filter?: string;
}

export interface NetSuiteDataSourceFilterModel {
  /** @format uuid */
  id?: string;
  roleCategory?: string;
  roleType?: string;
  roleSubType?: string;
  columns?: GenericListItem[];
  filterModel?: NetSuiteFilterModel[];
  joinModel?: NetSuiteJoinModel[];
}

export interface NetSuiteDestinationModel {
  roleTypes?: string[];
  roleSubType?: string;
  includeLinked?: boolean;
  includeActions?: boolean;
  duplicateLines?: NetSuiteDuplicateLineModel[];
  ignoreDuplicateDetection?: boolean;
  replaceSublist?: string[];
  deleteSublist?: string[];
  toFile?: boolean;
  destinationType?: DestinationType;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface NetSuiteDuplicateLineModel {
  columnName?: string;
  baseColumnName?: string;
  technicalName?: string;
  technicalValue?: string;
  /** @format int32 */
  duplicate?: number;
  parentDescription?: string;
  parentTechnicalValue?: string;
  parentTechnicalName?: string;
  parentGroup?: string;
}

export interface NetSuiteFilterDetail {
  /** @format uuid */
  id?: string;
  fieldName?: string;
  operator?: string;
  columnType?: string;
  valueFrom?: string;
  valueTo?: string;
  isLookupFrom?: boolean;
  isLookupTo?: boolean;
}

export interface NetSuiteFilterModel {
  /** @format uuid */
  id?: string;
  fieldName?: GenericListItem;
  operator?: string;
  columnType?: GenericListItem;
  valueFrom?: string;
  valueTo?: string;
  valueFromDate?: string;
  valueToDate?: string;
}

export type NetSuiteInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  description?: string;
  applicationId?: string;
  authenticationType?: string;
  account?: string;
  useDataCentreUrls?: boolean;
  /** @format int32 */
  sendThreadsLimit?: number;
  clientId?: string;
  clientSecret?: string;
  token?: string;
  refreshToken?: string;
  /** @format date-time */
  tokenExpiry?: string;
  /** @format date-time */
  secretExpiry?: string;
  scope?: string;
  publicClient?: boolean;
  certificatePrivateKey?: string;
  hasCertificatePrivateKey?: boolean;
  /** @format date-time */
  certificateExpiry?: string;
  certificateId?: string;
  restSuiteQLSchema?: NetSuiteRestSchemaModel[];
};

export interface NetSuiteJoinModel {
  /** @format uuid */
  id?: string;
  itemText?: string;
  itemValue?: string;
  filterJoinModel?: NetSuiteFilterDetail[];
}

export interface NetSuiteLineParameterRequest {
  technicalValue?: string;
  parentGroup?: string;
}

export interface NetSuiteParameterModel {
  type?: string;
  name?: string;
  valueType?: string;
  value?: string;
}

export interface NetSuiteQueryDataSourceModel {
  savedSearchId?: string;
  savedSearchDescription?: string;
  searchRecordType?: string;
  serviceType?: string;
  savedSearchModel?: string;
  displayName?: boolean;
  includeChildren?: boolean;
  searchRecordSubTypes?: string[];
  dataSourceModel?: NetSuiteDataSourceFilterModel;
  roleType?: string;
  filterConditions?: NetSuiteRestFilterCondition[];
  expandJsonColumns?: boolean;
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  logPreview?: boolean;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface NetSuiteRESTletQueryDataSourceModel {
  /** @format int32 */
  previewCount?: number;
  schema?: NetSuiteSchemaModel[];
  parameters?: NetSuiteParameterModel[];
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  logPreview?: boolean;
  /** @format uuid */
  mapId?: string;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface NetSuiteRestFilterCondition {
  id?: string;
  logical?: string;
  fieldName?: string;
  operator?: string;
  value?: string;
}

export interface NetSuiteRestLookupPreviewFilter {
  fieldName?: string;
  operator?: string;
  valueFrom?: string;
  valueTo?: string;
}

/**
 * Request for the NetSuite REST Record Lookup "Test" preview: runs the lookup with sample
 * (already-resolved literal) filter values and returns the matching records.
 */
export interface NetSuiteRestLookupPreviewModel {
  /** @format uuid */
  connectionId?: string;
  roleType?: string;
  returnFields?: string[];
  filters?: NetSuiteRestLookupPreviewFilter[];
  includeChildren?: boolean;
  expandJsonColumns?: boolean;
  /** @format int32 */
  previewCount?: number;
  /**
   * When true, capture the request/response of the test call and persist it as
   *             integration log records (keyed by SmartConnect.Services.Dtos.Request.NetSuiteRestLookupPreviewModel.MapId), viewable in the System Request Log.
   */
  logRequests?: boolean;
  /**
   * The integration/map the lookup column belongs to — the key the saved logs are stored under.
   * @format uuid
   */
  mapId?: string;
}

export interface NetSuiteRestRealTimeDataSourceModel {
  roleType?: string;
  logAction?: string;
  expandJsonColumns?: boolean;
  includeChildren?: boolean;
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  allowAddSchemaColumn?: boolean;
  allowCreate?: boolean;
  allowUpdate?: boolean;
  allowDelete?: boolean;
  allowAll?: boolean;
  friendlyName?: string;
  name?: string;
  isRegistered?: boolean;
  callbackUri?: string;
  realTimeMapLinks?: RealTimeDataSourceMapLink[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface NetSuiteRestSchemaModel {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  customerId?: string;
  entity?: string;
  table?: string;
  restriction?: string;
}

export interface NetSuiteSchemaModel {
  columnName?: string;
  dataType?: string;
  included?: boolean;
}

export interface NetSuiteSuiteQLQueryDataSourceModel {
  /** @format int32 */
  previewCount?: number;
  schema?: NetSuiteSchemaModel[];
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  logPreview?: boolean;
  /** @format uuid */
  mapId?: string;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface NextScheduleDto {
  /** @format uuid */
  scheduleMasterId?: string;
  /** @format uuid */
  mapKey?: string;
  processId?: string;
  processDescription?: string;
  /** @format date-time */
  nextRun?: string;
}

export interface NextScheduleDtoListBaseResponse {
  data?: NextScheduleDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface NotificationModel {
  title?: string;
  message?: string;
  /** @format date-time */
  timestamp?: string;
  linkUrl?: string;
  linkText?: string;
  isHtml?: boolean;
  /** @format int32 */
  entityType?: number;
  /** @format int32 */
  eventEntryType?: number;
}

export interface OAuthClientSettingModel {
  /** @format uuid */
  oAuthClientSettingId?: string;
  /** @format uuid */
  oAuthClientId?: string;
  /** @format uuid */
  customerId?: string;
  name?: string;
  secret?: string;
  active?: boolean;
}

export interface ObjectBaseResponse {
  data?: any;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export type OdbcInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  connectionString?: string;
  currentConnectionString?: string;
};

export interface OdbcQueryDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  hasQueryBuilder?: boolean;
  trimStrings?: boolean;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export type OledbInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  connectionString?: string;
  currentConnectionString?: string;
};

export interface OledbQueryDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  hasQueryBuilder?: boolean;
  trimStrings?: boolean;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface PasswordPolicyModel {
  /** @format int32 */
  minimumPasswordLength?: number;
  passwordExpires?: boolean;
  /** @format int32 */
  passwordExpiryDays?: number;
  preventPasswordReuse?: boolean;
  /** @format int32 */
  passwordsToRemember?: number;
  passwordContainsUpper?: boolean;
  passwordContainsLower?: boolean;
  passwordContainsNumeric?: boolean;
  passwordContainsAlphaNumeric?: boolean;
  passwordCannotContainRepeats?: boolean;
  passwordCannotContainSequence?: boolean;
  /** @format int32 */
  mfaEnabledFor?: number;
}

export interface PlaceholderListItem {
  key?: string;
  value?: string;
  type?: PlaceholderType;
}

export interface PlaceholderModel {
  type?: PlaceholderType;
  key?: string;
  value?: string;
  originalValue?: string;
  showRefresh?: boolean;
  /** @format int32 */
  count?: number;
  keyValue?: string;
}

export type PopdockInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  serviceUrl?: string;
  token?: string;
  /** @format uuid */
  apiId?: string;
  useCredentials?: boolean;
  userName?: string;
  password?: string;
  accountId?: string;
  /** @format int32 */
  timeoutMinutes?: number;
  accounts?: AuthenticatedProductAccountResponse[];
};

export interface PopdockQueryInstanceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  popdockConnectionId?: string;
  popCompanyId?: string;
  groupId?: string;
  listId?: string;
  favouriteId?: string;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface PostgreSqlChangeDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  hasQueryBuilder?: boolean;
  database?: string;
  table?: string;
  changeTableFields?: GenericTableField[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export type PostgreSqlInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  server?: string;
  userName?: string;
  password?: string;
  port?: string;
  encrypt?: boolean;
  freeTextDatabaseName?: boolean;
  database?: string;
  localQueueEnabled?: boolean;
  /** @format int32 */
  retryIntervalSec?: number;
  increaseIntervalWithEveryAttempt?: boolean;
  /** @format int32 */
  giveUpAfterMinutes?: number;
  recordSuccess?: boolean;
  /** @format int32 */
  purgeQueueHoursOld?: number;
  /** @format int32 */
  connectionTimeout?: number;
  /** @format int32 */
  commandTimeout?: number;
  /** @format int32 */
  packetSize?: number;
};

export interface PostgreSqlInstanceModelListBaseResponse {
  data?: PostgreSqlInstanceModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface PostgreSqlQueryDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  hasQueryBuilder?: boolean;
  database?: string;
  trimStrings?: boolean;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface PostgreStoredProcDestinationModel {
  database?: string;
  useTransaction?: boolean;
  toFile?: boolean;
  procedure?: string;
  destinationType?: DestinationType;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface PostgreTableDestinationModel {
  database?: string;
  useTransaction?: boolean;
  toFile?: boolean;
  table?: string;
  destinationType?: DestinationType;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

/**
 * Request to prepare an integration for duplication through the Import Wizard.
 * The source map is exported into an import file-holder and the resulting
 * SmartConnect.Services.Dtos.ProcessImportFileDto seeds the wizard (no download/upload roundtrip).
 */
export interface PrepareDuplicateRequest {
  /**
   * Source map Id to duplicate.
   * @format uuid
   */
  mapId?: string;
}

export interface PreviewSourceRequest {
  /** @format uuid */
  dataSourceId?: string;
  sourceType?: SourceType;
  variables?: IntegrationProcessVariableDto[];
  /** @format uuid */
  mapKey?: string;
  mapId?: string;
}

export interface PreviewSourceResponse {
  cols?: GenericListItem[];
  rows?: Record<string, any>[];
}

export interface PreviewSourceResponseBaseResponse {
  data?: PreviewSourceResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ProcessAddress {
  /** @format int32 */
  sequence?: number;
  address?: string;
}

export interface ProcessBizModel {
  /** @format uuid */
  mapId?: string;
  id?: string;
  dataSourceType?: string;
  destinationDefinition?: string;
  destinationType?: string;
  errorPath?: string;
  /** @format date-time */
  lastRunDate?: string;
  lastRunSuccess?: boolean;
  lastRunType?: string;
  logEnabled?: boolean;
  logErrors?: boolean;
  logSourceData?: boolean;
  logSuccess?: boolean;
  logXml?: boolean;
  logDebugDocDetails?: boolean;
  logDebugDocItems?: boolean;
  logDebugDocTasks?: boolean;
  logDebugMapDetails?: boolean;
  logDebugMapTasks?: boolean;
  logDebugSchedule?: boolean;
  logDebugWebservice?: boolean;
  validateDataTypes?: boolean;
  mapDescription?: string;
  /** @format int64 */
  runNumber?: string;
  scriptLanguage?: string;
  runMapAsUser?: string;
  isPublished?: boolean;
  dataSourceExclusion?: string;
  returnSuccessIfNoData?: boolean;
  returnFailIfNoData?: boolean;
  allowAnyRun?: boolean;
  owner?: string;
  /** @format uuid */
  integrationGroupId?: string;
  saveProcessErrorsAsCsv?: boolean;
  saveProcessErrorsAsXml?: boolean;
  usesDefinedDestination?: boolean;
  allowSourceUploads?: boolean;
  /** @format uuid */
  destinationId?: string;
  /** @format uuid */
  dataSourceId?: string;
  logSystemEvents?: boolean;
  /** @format int32 */
  logSourceDataLimit?: number;
  concatenationSeparator?: string;
  /** @format int32 */
  fileOutputLimit?: number;
  disableParallelSend?: boolean;
  runTasksNoDataOption?: string;
  overview?: string;
  tasks?: ProcessTask[];
}

export interface ProcessBizModelListBaseResponse {
  data?: ProcessBizModel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ProcessDto {
  /** @format uuid */
  id?: string;
  draftKey?: string;
  draftId?: string;
  mapName?: string;
  mapDescription?: string;
  dataSource?: string;
  dataSourceIcon?: string;
  dataSourceType?: string;
  dataSourceBaseType?: string;
  dataSourceId?: string;
  dataSourceName?: string;
  /** @format uuid */
  dataSourceConnectionId?: string;
  destination?: string;
  destinationIcon?: string;
  destinationBaseType?: string;
  /** @format int64 */
  runNumber?: string;
  isScheduled?: boolean;
  lastStatus?: boolean;
  /** @format date-time */
  lastRunDate?: string;
  lastRunDateString?: string;
  owner?: string;
  /** @format int32 */
  sequence?: number;
  integrationGroup?: string;
  /** @format date-time */
  createdDate?: string;
  createdDateString?: string;
  createdUser?: string;
  /** @format date-time */
  modifiedDate?: string;
  modifiedDateString?: string;
  modifiedUser?: string;
  logEnabled?: boolean;
  integrationGroupColor?: string;
  integrationTextColor?: string;
  /** @format uuid */
  currentRunActivityId?: string;
  currentRunStatus?: MapRunStatus;
  currentRunStatusStr?: string;
  showRuntimeSelect?: boolean;
  hideEdit?: boolean;
  hideDelete?: boolean;
  style?: any;
  longRunning?: boolean;
  getDescription?: string;
  getGroupColor?: string;
  getTextColor?: string;
  getId?: string;
  getEditUrl?: string;
  getRunUrl?: string;
  allowRun?: boolean;
  allowModify?: boolean;
  isRealTimeDataSource?: boolean;
  getCloneUrl?: string;
}

export interface ProcessExportResultDto {
  /** @format uuid */
  integrationId?: string;
  integrationName?: string;
  integrationDescription?: string;
  integration?: IntegrationProcessExportDto;
  sourceType?: string;
  sourceTypeName?: string;
  sourceQueryText?: string;
  targetType?: string;
  productTypes?: string[];
  targetTypeName?: string;
  metadata?: ProcessMetadataItem[];
  requiredFiles?: string[];
  dataSourceRequiredFiles?: DataSourceLinkedFile[];
  notes?: string;
  version?: string;
  additionalColumnConnections?: IntegrationProcessColumnConnectionReferenceDto[];
  taskConnections?: IntegrationProcessTaskConnectionReferenceDto[];
}

export interface ProcessImportDto {
  /** @format uuid */
  fileId?: string;
  /**
   * The selected datasource or created datasource
   * @format uuid
   */
  dataSourceId?: string;
  /**
   * The selected destination or created connector
   * @format uuid
   */
  connectionId?: string;
  /** additional columns connection mappings */
  additionalColumnConnections?: IntegrationProcessConnectionReferenceDto[];
  /** task connection mappings */
  taskConnections?: IntegrationProcessConnectionReferenceDto[];
}

export interface ProcessImportFileDto {
  originalExportedMap?: ProcessExportResultDto;
  fileName?: string;
  /** @format uuid */
  holderId?: string;
  /** @format uuid */
  fileId?: string;
  linkedFileName?: string;
  linkedTransformFileName?: string;
}

export interface ProcessImportFileDtoBaseResponse {
  data?: ProcessImportFileDto;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ProcessImportFileDtoListBaseResponse {
  data?: ProcessImportFileDto[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface ProcessMapLineModel {
  /** @format uuid */
  mapLineId?: string;
  /** @format int64 */
  lineNumber?: string;
  description?: string;
  /** @format int32 */
  sequence?: number;
  allowed?: boolean;
  restrictionString?: string;
  technicalValue?: string;
  parentTechnicalValue?: string;
  /** @format int32 */
  mappedColumnCount?: number;
}

export interface ProcessMetadataItem {
  metaType?: ProcessMetaDataItemType;
  /** @format uuid */
  metadataKey?: string;
  metadataName?: string;
  metadataModel?: string;
}

export interface ProcessModel {
  /** @format uuid */
  mapId?: string;
  id?: string;
  dataSourceType?: string;
  destinationDefinition?: string;
  destinationType?: string;
  errorPath?: string;
  /** @format date-time */
  lastRunDate?: string;
  lastRunSuccess?: boolean;
  lastRunType?: string;
  logEnabled?: boolean;
  logErrors?: boolean;
  logSourceData?: boolean;
  logSuccess?: boolean;
  logXml?: boolean;
  logDebugDocDetails?: boolean;
  logDebugDocItems?: boolean;
  logDebugDocTasks?: boolean;
  logDebugMapDetails?: boolean;
  logDebugMapTasks?: boolean;
  logDebugSchedule?: boolean;
  logDebugWebservice?: boolean;
  validateDataTypes?: boolean;
  mapDescription?: string;
  /** @format int64 */
  runNumber?: string;
  scriptLanguage?: string;
  runMapAsUser?: string;
  isPublished?: boolean;
  dataSourceExclusion?: string;
  returnSuccessIfNoData?: boolean;
  returnFailIfNoData?: boolean;
  allowAnyRun?: boolean;
  owner?: string;
  /** @format uuid */
  integrationGroupId?: string;
  saveProcessErrorsAsCsv?: boolean;
  saveProcessErrorsAsXml?: boolean;
  usesDefinedDestination?: boolean;
  allowSourceUploads?: boolean;
  /** @format uuid */
  destinationId?: string;
  /** @format uuid */
  dataSourceId?: string;
  logSystemEvents?: boolean;
  /** @format int32 */
  logSourceDataLimit?: number;
  concatenationSeparator?: string;
  /** @format int32 */
  fileOutputLimit?: number;
  disableParallelSend?: boolean;
  runTasksNoDataOption?: string;
  overview?: string;
}

export interface ProcessTask {
  profile?: ProcessTaskProfile;
  /** @format uuid */
  taskBaseId?: string;
  taskTypeName?: string;
  /** @format uuid */
  customerId?: string;
  taskType?: string;
  taskName?: string;
  /** @format int32 */
  sequence?: number;
  /** @format int32 */
  onFailure?: number;
  /** @format int32 */
  onSuccess?: number;
  success?: boolean;
  usesSourceFields?: boolean;
  usesGlobalVariables?: boolean;
  enable?: boolean;
  server?: string;
  useWindowsAuthentication?: boolean;
  login?: string;
  password?: string;
  sqlDatabase?: string;
  sqlVersion?: string;
  defaultConnection?: string;
  code?: string;
  returnVariable?: string;
  useTenantConnection?: boolean;
  isValid?: boolean;
  sqlTable?: string;
  baseQuery?: string;
  allowRuntimeTenant?: boolean;
  requireDataExists?: boolean;
  saveValidationErrors?: boolean;
  operation?: string;
  fromPath?: string;
  toPath?: string;
  overwrite?: boolean;
  appendDateTime?: boolean;
  filePath?: string;
  exitCode?: string;
  runMapID?: string;
  useDataSourceFromParent?: boolean;
  useGlobalsFromParent?: boolean;
  showInNewProcessTab?: boolean;
  toAddress?: string;
  ccAddress?: string;
  bccAddress?: string;
  fromAddress?: string;
  message?: string;
  subject?: string;
  includeProcessErrors?: boolean;
  includeValidationErrors?: boolean;
  details?: string[];
}

export interface ProcessTaskModel {
  /** @format uuid */
  mapId?: string;
  mapName?: string;
  /** @format uuid */
  taskBaseId?: string;
  taskTypeName?: string;
  taskType?: string;
  taskName?: string;
  /** @format int32 */
  sequence?: number;
  /** @format int32 */
  onFailure?: number;
  /** @format int32 */
  onSuccess?: number;
  success?: boolean;
  usesSourceFields?: boolean;
  usesGlobalVariables?: boolean;
  enable?: boolean;
  server?: string;
  useWindowsAuthentication?: boolean;
  login?: string;
  password?: string;
  sqlDatabase?: string;
  sqlVersion?: string;
  defaultConnection?: string;
  code?: string;
  returnVariable?: string;
  useTenantConnection?: boolean;
  isValid?: boolean;
  sqlTable?: string;
  baseQuery?: string;
  allowRuntimeTenant?: boolean;
  requireDataExists?: boolean;
  saveValidationErrors?: boolean;
  operation?: string;
  fromPath?: string;
  toPath?: string;
  overwrite?: boolean;
  appendDateTime?: boolean;
  filePath?: string;
  exitCode?: string;
  runMapID?: string;
  useDataSourceFromParent?: boolean;
  useGlobalsFromParent?: boolean;
  showInNewProcessTab?: boolean;
  toAddress?: string;
  ccAddress?: string;
  bccAddress?: string;
  fromAddress?: string;
  message?: string;
  subject?: string;
  includeProcessErrors?: boolean;
  includeValidationErrors?: boolean;
  detailsJson?: string;
}

export interface ProcessTaskProfile {
  profileName?: string;
  abn?: string;
  accountNumber?: string;
  addresses?: ProcessAddress[];
  email?: string;
  phoneNumbers?: string[];
}

export interface QueryParameter {
  name?: string;
  value?: string;
  removeWhenEmptyValue?: boolean;
  excludeInPaging?: boolean;
  doNotUrlEncode?: boolean;
}

export interface RealTimeDataSourceMapLink {
  /** @format uuid */
  mapId?: string;
  /** @format int32 */
  sequence?: number;
  triggerEvent?: RealtimeEntityEvents;
}

export interface RealTimeLinkedMapModel {
  /** @format uuid */
  mapKey?: string;
  mapId?: string;
  mapDescription?: string;
  forCreate?: boolean;
  forUpdate?: boolean;
  forDelete?: boolean;
  forAll?: boolean;
  /** @format int32 */
  sequence?: number;
}

export interface ResetDraftLockRequest {
  /**
   * Required Id
   * @format uuid
   */
  id?: string;
  /**
   * required Version
   * @format int32
   */
  version: number;
}

export interface ResetDraftLockResponse {
  /** @format date-time */
  lockedDate?: string;
  /** @format date-time */
  lockExpireDate?: string;
}

export interface ResetDraftLockResponseBaseResponse {
  data?: ResetDraftLockResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface RestActionValidateStructureRequest {
  /** Raw structure JSON document (see SmartConnect.GenericRest.Setup.Structure.StructureDocument). */
  structure?: string;
}

export interface RestFieldDefinition {
  name?: string;
  path?: string;
  /**
   * Maps to RestEnums.FieldType: 0 = String, 1 = Number, 2 = Boolean
   * @format int32
   */
  type?: number;
}

export interface RestFieldDefinitionListBaseResponse {
  data?: RestFieldDefinition[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface RestParameterModel {
  /** @format uuid */
  id?: string;
  name?: string;
  value?: string;
  description?: string;
  removeEmpty?: boolean;
  excludeInPaging?: boolean;
  dontUrlEncode?: boolean;
  originalValue?: string;
  overridden?: boolean;
}

export interface RestVariableModel {
  /** @format uuid */
  id?: string;
  name?: string;
  value?: string;
  description?: string;
  /** @format int32 */
  type?: number;
  required?: boolean;
  originalValue?: string;
  overridden?: boolean;
}

export interface RunMapEdgeModel {
  /** @format uuid */
  parentMapId?: string;
  runMapId?: string;
  detailsJson?: string;
}

export interface RunProcessVariableModel {
  /** @format uuid */
  id?: string;
  name?: string;
  prompt?: string;
  type?: string;
  value?: string;
  required?: boolean;
}

export interface RunRequest {
  id?: string;
  description?: string;
  /** @format uuid */
  fileHolderId?: string;
  variables?: RunProcessVariableModel[];
  processErrors?: string[];
  longRunning?: boolean;
}

/** A group of conflicts of the same type (e.g. all rolling column conflicts). */
export interface RuntimeValueConflictGroup {
  /** Stable type identifier — see SmartConnect.Services.Dtos.RuntimeValueConflictTypes. */
  type?: string;
  /** Human-readable section heading for the UI. */
  title?: string;
  items?: RuntimeValueConflictItem[];
}

/** Describes a single runtime-value conflict between a draft and the live integration. */
export interface RuntimeValueConflictItem {
  id?: string;
  name?: string;
  draftValue?: string;
  currentValue?: string;
}

export interface SalesForceChangeDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  sObject?: string;
  parsedSfQuery?: string;
  organisationType?: string;
  logPreview?: boolean;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface SalesForceQueryDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  allowAddSchemaColumn?: boolean;
  baseObject?: string;
  organisationType?: string;
  queryMode?: string;
  listViewId?: string;
  allowPreviewLogging?: boolean;
  logPreview?: boolean;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface SalesForceRealTimeDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  allowAddSchemaColumn?: boolean;
  sObject?: string;
  callbackType?: SalesforceRealtimeCallbackType;
  triggerFields?: string[];
  sendFields?: string[];
  allowCreate?: boolean;
  allowUpdate?: boolean;
  allowDelete?: boolean;
  allowAll?: boolean;
  friendlyName?: string;
  name?: string;
  isRegistered?: boolean;
  callbackUri?: string;
  realTimeMapLinks?: RealTimeDataSourceMapLink[];
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface SalesforceApiVersion {
  label?: string;
  version?: string;
}

export interface SalesforceApiVersionListBaseResponse {
  data?: SalesforceApiVersion[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface SalesforceBuildSoqlRequest {
  baseObject?: string;
  fields?: string[];
  subqueries?: SalesforceSubqueryRequest[];
  where?: SalesforceFilterNode;
  orderBy?: SalesforceOrderByRequest[];
  /** @format int32 */
  limit?: number;
}

export interface SalesforceDescribeSoqlRequest {
  soql?: string;
}

export interface SalesforceDestinationModel {
  selectedSObjects?: SalesforceDestinationSObject[];
  useTransaction?: boolean;
  destinationType?: DestinationType;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  toFile?: boolean;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface SalesforceDestinationSObject {
  apiName?: string;
  label?: string;
  creatable?: boolean;
  updateable?: boolean;
  deletable?: boolean;
}

export interface SalesforceFieldDto {
  apiName?: string;
  label?: string;
  type?: string;
  filterable?: boolean;
  sortable?: boolean;
  writable?: boolean;
  calculated?: boolean;
  relationshipName?: string;
  referenceTo?: string[];
  picklistValues?: SalesforcePicklistValueDto[];
}

export interface SalesforceFilterNode {
  type?: string;
  combinator?: string;
  children?: SalesforceFilterNode[];
  field?: string;
  operator?: string;
  quote?: boolean;
  valueMode?: string;
  value?: string;
  values?: string[];
}

export interface SalesforceGeneratedCertificateResponse {
  certificate?: string;
  /** @format date-time */
  expiryUtc?: string;
}

export interface SalesforceGeneratedCertificateResponseBaseResponse {
  data?: SalesforceGeneratedCertificateResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export type SalesforceInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  fromMemoCache?: boolean;
  environmentType?: string;
  linkedProductionInstanceId?: string;
  organizationName?: string;
  organizationType?: string;
  organizationId?: string;
  serviceUrl?: string;
  apiVersion?: string;
  authenticationUrl?: string;
  provisioningClientId?: string;
  provisioningUser?: string;
  provisioningCertificate?: string;
  provisioningPendingCertificate?: string;
  /** @format date-time */
  provisioningCertificateExpiryUtc?: string;
  /** @format date-time */
  provisioningPendingCertificateExpiryUtc?: string;
  provisioningRotationState?: string;
  dataAccessClientId?: string;
  dataAccessUser?: string;
  dataAccessCertificate?: string;
  dataAccessPendingCertificate?: string;
  /** @format date-time */
  dataAccessCertificateExpiryUtc?: string;
  /** @format date-time */
  dataAccessPendingCertificateExpiryUtc?: string;
  dataAccessRotationState?: string;
};

export interface SalesforceObjectMetadataDto {
  apiName?: string;
  label?: string;
  isCustom?: boolean;
  fields?: SalesforceFieldDto[];
  parentReferences?: SalesforceRelationshipDto[];
  childRelationships?: SalesforceRelationshipDto[];
}

export interface SalesforceObjectMetadataDtoBaseResponse {
  data?: SalesforceObjectMetadataDto;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface SalesforceOrderByRequest {
  field?: string;
  direction?: string;
  nulls?: string;
}

export interface SalesforcePicklistValueDto {
  value?: string;
  label?: string;
}

export interface SalesforcePreviewDto {
  soql?: string;
  columns?: string[];
  rows?: Record<string, string>[];
}

export interface SalesforcePreviewDtoBaseResponse {
  data?: SalesforcePreviewDto;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface SalesforceProductionInstanceItem {
  /** @format uuid */
  id?: string;
  description?: string;
}

export interface SalesforceProductionInstanceItemListBaseResponse {
  data?: SalesforceProductionInstanceItem[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface SalesforceRelationshipDto {
  name?: string;
  targetObject?: string;
  viaField?: string;
  isParent?: boolean;
}

export interface SalesforceSubqueryRequest {
  relationshipName?: string;
  fields?: string[];
}

export interface SaveActionModel {
  definition?: GenericRestSetupModel;
  action?: GenericRestActionListModel;
}

export interface SaveDraftRequest {
  /** @format uuid */
  id?: string;
  /** required DraftKey */
  draftKey: string;
  /**
   * required Draft Type
   * Options: Map
   */
  type: string;
  /** required Json */
  json: string;
  /**
   * required Version:
   * Default Value: 0
   * @format int32
   */
  version: number;
  /**
   * required NeedLock
   * Default Value: false
   */
  needLock: boolean;
}

export interface SaveEntityModel {
  entity?: GenericRestEntityListModel;
  definition?: GenericRestSetupModel;
}

export interface SaveLookupModel {
  definition?: GenericRestSetupModel;
  lookup?: GenericRestLookupListModel;
}

export interface SaveOAuthClientModel {
  name?: string;
  active?: boolean;
  applicationType?: UiType;
}

export interface SaveWebhookModel {
  definition?: GenericRestSetupModel;
  webhook?: GenericRestWebhookListModel;
}

export interface ScheduleMasterDto {
  id?: string;
  active?: boolean;
  /** @format int32 */
  authenticationFail?: number;
  currentRunServer?: string;
  email?: string[];
  emailFrequency?: string;
  /** @format int32 */
  failureCount?: number;
  htmlEmail?: boolean;
  /** @format date-time */
  lastFailRunDateTime?: string;
  /** @format date-time */
  lastRunDateTime?: string;
  lastRunSuccess?: boolean;
  /** @format date-time */
  lastSuccessRunDateTime?: string;
  /** @format int32 */
  loadFail?: number;
  longRunningSchedule?: boolean;
  /** @format date-time */
  nextEmailDateTime?: string;
  /** @format date-time */
  nextRunDateTime?: string;
  /** @format uuid */
  runUser?: string;
  /** @format int32 */
  runStopped?: number;
  timeZone?: string;
  timeZoneOffset?: string;
  triggerJson?: string;
  triggerLink?: string;
  /** @format date-time */
  initialStartDateTime?: string;
}

export interface ScheduleRequestDto {
  description?: string;
  timeZoneOffset?: string;
  timeZone?: string;
  startDateTimeUtc?: string;
  trigger?: ScheduleTriggerDto;
  schedule?: ScheduleMasterDto;
  /** @format int32 */
  minScheduleMinutes?: number;
}

export interface ScheduleTriggerDto {
  /** @format uuid */
  triggerId?: string;
  /** @format int32 */
  daysInterval?: number;
  /** @format int32 */
  durationMinutes?: number;
  /** @format int32 */
  intervalMinutes?: number;
  monthsData?: string;
  /** @format int32 */
  monthDay?: number;
  monthlyTriggerType?: string;
  repeatEnabled?: boolean;
  /** @format int32 */
  startHour?: number;
  /** @format int32 */
  startMinute?: number;
  triggerType?: string;
  weekDaysData?: string;
  daysData?: string;
  /** @format int32 */
  weeksInterval?: number;
  /** @format int32 */
  whichWeeks?: number;
  /** @format date-time */
  endTime?: string;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  runDateTime?: string;
  months?: string[];
  weekDays?: string[];
  days?: string[];
}

export interface SchemaColumn {
  sourceName?: string;
  displayName?: string;
  dataType?: string;
  /** @format int32 */
  length?: number;
  /** @format int32 */
  index?: number;
  included?: boolean;
  path?: string;
  parent?: string;
  isCustom?: boolean;
  required?: boolean;
}

export interface SchemaHeader {
  /** @format uuid */
  id?: string;
  colNameHeader?: boolean;
  useCustomHeaders?: boolean;
  textFileFormat?: TextFileFormat;
  encoding?: TextFileEncoding;
  customDelimiter?: string;
  useColumnDataType?: boolean;
  useHeaderRow?: boolean;
  lines?: SchemaLine[];
}

export interface SchemaLine {
  /** @format uuid */
  id?: string;
  columnName?: string;
  sourceColumnName?: string;
  dataType?: TextFileDataType;
  included?: boolean;
  dataTypeAsSystemType?: string;
  /** @format int32 */
  dataTypeWidth?: number;
  /** @format int32 */
  startPosition?: number;
  /** @format int32 */
  sequenceNumber?: number;
  schemaHeader?: SchemaHeader;
}

export interface ScriptNamespacesModel {
  id?: string;
  assemblyPath?: string;
  isSystem?: boolean;
}

export interface SessionUserModel {
  /** @format uuid */
  sessionId?: string;
  /** @format uuid */
  regionId?: string;
  email?: string;
  accountName?: string;
  multipleAccounts?: boolean;
  isAdmin?: boolean;
  theme?: string;
  culture?: string;
  timeZone?: string;
}

export interface SettingsModel {
  culture?: string;
  timeZone?: string;
  /** @format int32 */
  logEventDays?: number;
  /** @format int32 */
  logRequestDays?: number;
  /** @format date-time */
  lastMaintenanceRun?: string;
  /** @format int32 */
  changeDataSourceClearDownDays?: number;
  changeDataSourceClearDownWhenProcessed?: boolean;
  defaultScriptLanguage?: ScriptOptions;
  smtpServer?: string;
  /** @format int32 */
  smtpPort?: number;
  smtpUseSsl?: boolean;
  smtpSecurityType?: string;
  smtpAuthMethod?: string;
  smtpRequiresAuth?: boolean;
  smtpUsername?: string;
  smtpPassword?: string;
  smtpDomain?: string;
  /** @format uuid */
  emailGraphConnectionId?: string;
  emailConnectionProtocol?: string;
  /** @format int32 */
  draftLockDuration?: number;
}

export interface SharedAccount {
  /** @format uuid */
  accountId?: string;
  name?: string;
  country?: string;
  status?: string;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  modified?: string;
  eqa?: boolean;
  currency?: string;
}

export interface SharedProductInstance {
  name?: string;
  url?: string;
  type?: string;
}

export interface SharedUserProduct {
  /** @format uuid */
  accountProductId?: string;
  /** @format uuid */
  productId?: string;
  name?: string;
  region?: string;
  /** @format uuid */
  regionId?: string;
  status?: string;
  mfaEnabled?: boolean;
  mfaSetupRequired?: boolean;
  account?: SharedAccount;
  instances?: SharedProductInstance[];
  appUri?: string;
}

export interface SidebarCountsDto {
  /** @format int32 */
  processes?: number;
  /** @format int32 */
  drafts?: number;
  /** @format int32 */
  currentRuns?: number;
  /** @format int32 */
  runHistory?: number;
  /** @format int32 */
  outputs?: number;
  /** @format int32 */
  realtimeStaging?: number;
}

export interface SidebarCountsDtoBaseResponse {
  data?: SidebarCountsDto;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface SimpleProcessModel {
  /** @format uuid */
  key?: string;
  id?: string;
  description?: string;
  /** @format uuid */
  sourceId?: string;
  sourceType?: string;
  sourceDescription?: string;
  /** @format uuid */
  sourceConnectionId?: string;
  sourceConnectionType?: string;
  targetType?: string;
  /** @format uuid */
  targetConnectionId?: string;
  targetConnectionType?: string;
  /** @format date-time */
  createdDate?: string;
  createdUser?: string;
  /** @format date-time */
  modifiedDate?: string;
  modifiedUser?: string;
  /** @format date-time */
  lastRunDate?: string;
  /** @format int64 */
  lastRunNumber?: string;
}

export interface SlackChannel {
  name?: string;
  id?: string;
}

export interface SlackChannelListBaseResponse {
  data?: SlackChannel[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export type SlackInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  service?: string;
  clientId?: string;
  clientSecret?: string;
  scope?: string;
  state?: string;
  token?: string;
  refreshToken?: string;
  /** @format date-time */
  tokenExpiry?: string;
  fromMemoCache?: boolean;
  userName?: string;
};

export interface SqlObject {
  schema?: string;
  name?: string;
  displayName?: string;
}

export interface SqlObjectListBaseResponse {
  data?: SqlObject[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface StringBaseResponse {
  data?: string;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface StringBooleanValueTuple {
  item1?: string;
  item2?: boolean;
}

export interface StringInt16KeyValuePair {
  key?: string;
  /** @format int32 */
  value?: number;
}

export interface StringListBaseResponse {
  data?: string[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface StringStringDictionaryListBaseResponse {
  data?: Record<string, string>[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface StringStringKeyValuePair {
  key?: string;
  value?: string;
}

export interface StringStringKeyValuePairListBaseResponse {
  data?: StringStringKeyValuePair[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface StringStringValueTuple {
  item1?: string;
  item2?: string;
}

export interface SummaryMessage {
  /** @format uuid */
  runId?: string;
  /** @format uuid */
  parentRunId?: string;
  /** @format uuid */
  customerId?: string;
  /** @format uuid */
  userId?: string;
  email?: string;
  /** @format uuid */
  mapKey?: string;
  id?: string;
  description?: string;
  /** @format int64 */
  runNumber?: string;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  /** @format int32 */
  recordCount?: number;
  /** @format int32 */
  successCount?: number;
  /** @format int32 */
  errorCount?: number;
  /** @format int32 */
  restrictCount?: number;
  /** @format int32 */
  sourceRecordCount?: number;
  /** @format int32 */
  dataSourceRestrictCount?: number;
  status?: MapRunStatus;
  statusDescription?: string;
  message?: string;
  cancelledBy?: string;
  /** @format date-time */
  cancelledAt?: string;
  cancelTrigger?: CancelTrigger;
  cancelReason?: string;
  /** @format int64 */
  cancelledRecordCount?: string;
  downloads?: boolean;
  fileHolders?: FileHolderRef[];
  /** @format date-time */
  messageDateTime?: string;
  messageType?: SummaryMessageType;
  /** @format int32 */
  percentComplete?: number;
  runType?: MapRunType;
  isSuccessful?: boolean;
  source?: string;
  target?: string;
  sourceType?: string;
  /** @format date-time */
  queryStartTime?: string;
  /** @format date-time */
  queryEndTime?: string;
  /** @format date-time */
  processingStartTime?: string;
  /** @format date-time */
  processingEndTime?: string;
  processErrorsSaved?: boolean;
}

export interface SwitchRequest {
  userProduct?: SharedUserProduct;
  mfaCode?: string;
  password?: string;
}

export interface SystemSettingDto {
  cultures?: SystemSettingItem[];
  timezones?: SystemSettingItem[];
  systemSettings?: SettingsModel;
}

export interface SystemSettingDtoBaseResponse {
  data?: SystemSettingDto;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface SystemSettingItem {
  value?: string;
  label?: string;
}

export interface TeamConnectionModel {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  system?: string;
  roles?: TeamRoleModel[];
}

export interface TeamMemberModel {
  /** @format uuid */
  id?: string;
  name?: string;
  email?: string;
}

export interface TeamMemberRequest {
  email?: string;
}

export interface TeamModel {
  /** @format uuid */
  id?: string;
  name?: string;
  description?: string;
  isAdmin?: boolean;
  connections?: TeamConnectionModel[];
  members?: TeamMemberModel[];
  roles?: TeamRoleModel[];
}

export interface TeamRoleModel {
  /** @format uuid */
  id?: string;
  path?: string;
  role?: TeamRole;
}

export interface TeamRoleRequest {
  path?: string;
  role?: string;
}

/** Refer to TeamStubRequest */
export interface TeamStubRequest {
  name?: string;
  description?: string;
}

export interface TeamsChatItem {
  topic?: string;
  chatType?: string;
  id?: string;
}

export interface TeamsChatItemListBaseResponse {
  data?: TeamsChatItem[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface TeamsItem {
  displayName?: string;
  id?: string;
}

export interface TeamsItemListBaseResponse {
  data?: TeamsItem[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface TenantBase {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  customerId?: string;
  /** @format uuid */
  connectionInstanceId?: string;
  /** @format uuid */
  mapId?: string;
  selected?: boolean;
  technicalName?: string;
  technicalValue?: string;
  name?: string;
  scriptingName?: string;
  serverName?: string;
  isUserAdded?: boolean;
  includeInScripting?: boolean;
  tenantType?: TenantType;
  connectorInstanceName?: string;
}

export interface TenantBaseListBaseResponse {
  data?: TenantBase[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface TenantCapability {
  technicalName?: string;
  name?: string;
  serverName?: string;
  selected?: boolean;
  write?: boolean;
  change?: boolean;
  serverless?: boolean;
}

export interface TenantModelBase {
  /** @format int32 */
  sequence?: number;
  /** @format uuid */
  mapId?: string;
  uniqueName?: string;
  name?: string;
  serverName?: string;
  technicalName?: string;
  technicalValue?: string;
  isUserAdded?: boolean;
  selected?: boolean;
  includeInScripting?: boolean;
  /** @format uuid */
  connectionInstanceId?: string;
  connectorInstanceName?: string;
  /** @format uuid */
  tenantId?: string;
}

export interface TestAlertRequest {
  entityType?: EventLogEntityType;
  /** @format uuid */
  entityId?: string;
  title?: string;
  message?: string;
  notificationMessage?: string;
  diagnostics?: string;
  isHtml?: boolean;
  scope?: NotificationScope;
}

export interface TextFileDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  sourceLocationType?: FileDataSourceSourceLocationType;
  schemaHeader?: SchemaHeader;
  /** @format uuid */
  fileHolderId?: string;
  templateFile?: string;
  sourceFolder?: string;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface TextFileDestinationModel {
  destinationType?: DestinationType;
  columnSeparator?: TextFileFormat;
  customDelimiter?: string;
  fileDestinationPath?: string;
  fileName?: string;
  columnCharacterSet?: TextFileCharacterSet;
  separateFilePerKeyField?: boolean;
  appendKeyFieldToFilename?: boolean;
  overwriteFile?: boolean;
  appendDateTime?: boolean;
  includeColumnHeadings?: boolean;
  encloseInQuotes?: boolean;
  columnHeaders?: GenericFileColumnHeader[];
  /** @format uuid */
  sourceId?: string;
  msGpDestinationType?: string;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  toFile?: boolean;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface TextFolderDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  filesAtRuntime?: boolean;
  successFolder?: string;
  failureFolder?: string;
  emptyFileAction?: string;
  overwriteFile?: boolean;
  appendDateTime?: boolean;
  instances?: ConnectorOption[];
  sourceLocationType?: FileDataSourceSourceLocationType;
  schemaHeader?: SchemaHeader;
  /** @format uuid */
  fileHolderId?: string;
  templateFile?: string;
  sourceFolder?: string;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface TokenResponse {
  accessToken?: string;
  /** @format date-time */
  expiresAt?: string;
}

export interface TokenResponseBaseResponse {
  data?: TokenResponse;
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface TranslationTableModel {
  /** @format uuid */
  translationTableId?: string;
  id?: string;
  description?: string;
  lines?: TranslationTableRowModel[];
}

export interface TranslationTableRowModel {
  fromValue?: string;
  toValue?: string;
}

export type TrelloInstanceModel = BaseConnectorInstanceBaseModel & {
  instanceType?: string;
  typeName?: string;
  logonKey?: string;
  logonToken?: string;
};

export interface TrelloItem {
  name?: string;
  id?: string;
}

export interface TrelloItemListBaseResponse {
  data?: TrelloItem[];
  success?: boolean;
  errorCode?: string;
  errorMessage?: string;
}

export interface UserConnectorSecurityModel {
  /** @format uuid */
  id?: string;
  name?: string;
  roles?: UserSecurityModel[];
}

export interface UserListModel {
  /** @format uuid */
  id?: string;
  email?: string;
  active?: boolean;
  firstName?: string;
  lastName?: string;
}

export interface UserModel {
  /** @format uuid */
  id?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  active?: boolean;
  administrator?: boolean;
  password?: string;
  error?: string;
  fullName?: string;
  status?: string;
  role?: string;
  roles?: UserSecurityModel[];
  connectorRoles?: UserConnectorSecurityModel[];
  teams?: UserTeamModel[];
  theme?: string;
  timeZone?: string;
  culture?: string;
}

export interface UserPasswordModel {
  /** @format uuid */
  id?: string;
  email?: string;
  oldPassword?: string;
  newPassword?: string;
}

export interface UserRoleModel {
  roles?: TeamRoleModel[];
  connectionRoles?: Record<string, TeamRoleModel[]>;
}

export interface UserSecurityModel {
  /** @format uuid */
  id?: string;
  path?: string;
  effectiveRole?: string;
  teams?: UserTeamRoleModel[];
}

export interface UserTeamModel {
  /** @format uuid */
  id?: string;
  name?: string;
  description?: string;
}

export interface UserTeamRoleModel {
  /** @format uuid */
  id?: string;
  name?: string;
  role?: string;
}

export interface UserWebFormOptionModel {
  /** @format uuid */
  userWebFormOptionId?: string;
  formName?: string;
  /** @format uuid */
  userId?: string;
}

/** Body for validating a single calculated-field script (parse-only). */
export interface ValidateScriptRequest {
  script?: string;
}

export interface VirtualNetworkListModel {
  /** @format uuid */
  id?: string;
  name?: string;
  description?: string;
}

export interface XmlDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  transformFile?: string;
  xmlUri?: string;
  xmlFormat?: string;
  xmlFields?: XmlFieldModel[];
  fieldTypes?: StringInt16KeyValuePair[];
  sourceLocationType?: FileDataSourceSourceLocationType;
  schemaHeader?: SchemaHeader;
  /** @format uuid */
  fileHolderId?: string;
  templateFile?: string;
  sourceFolder?: string;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface XmlFieldModel {
  /** @format uuid */
  fieldId?: string;
  name?: string;
  path?: string;
  /** @format uuid */
  parentId?: string;
  type?: FieldType;
  typeString?: string;
  selected?: boolean;
  allowSelect?: boolean;
  displayName?: string;
  hasCdata?: boolean;
  hasText?: boolean;
}

export interface XmlFileDestinationModel {
  destinationType?: DestinationType;
  xmlFormat?: XmlFormatModel[];
  declaration?: string;
  namespaces?: XmlNamespace[];
  transformationFileName?: string;
  transformationFileContent?: string;
  fileDestinationPath?: string;
  fileName?: string;
  columnCharacterSet?: TextFileCharacterSet;
  separateFilePerKeyField?: boolean;
  appendKeyFieldToFilename?: boolean;
  overwriteFile?: boolean;
  appendDateTime?: boolean;
  includeColumnHeadings?: boolean;
  encloseInQuotes?: boolean;
  columnHeaders?: GenericFileColumnHeader[];
  /** @format uuid */
  sourceId?: string;
  msGpDestinationType?: string;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  connectionId?: string;
  /** @format uuid */
  mapId?: string;
  productType?: ConnectorProductType;
  toFile?: boolean;
  tenantScript?: string;
  tenants?: TenantModelBase[];
}

export interface XmlFolderDataSourceModel {
  sourceType?: DataSourceType;
  schemaShowParent?: boolean;
  transformFile?: string;
  xmlUri?: string;
  xmlFormat?: string;
  xmlFields?: XmlFieldModel[];
  fieldTypes?: StringInt16KeyValuePair[];
  filesAtRuntime?: boolean;
  successFolder?: string;
  failureFolder?: string;
  emptyFileAction?: string;
  overwriteFile?: boolean;
  appendDateTime?: boolean;
  instances?: ConnectorOption[];
  sourceLocationType?: FileDataSourceSourceLocationType;
  schemaHeader?: SchemaHeader;
  /** @format uuid */
  fileHolderId?: string;
  templateFile?: string;
  sourceFolder?: string;
  typeName?: string;
  /** @format uuid */
  dataSourceId?: string;
  /** @format uuid */
  connectionId?: string;
  description?: string;
  sourceName?: string;
  isComplete?: boolean;
  queryText?: string;
  schemaColumns?: SchemaColumn[];
  pipeline?: DataSourcePipelineConfig;
  hasQueryBuilder?: boolean;
  hasQueryEditor?: boolean;
  allowPreviewLogging?: boolean;
  allowAddSchemaColumn?: boolean;
  allowDeleteTracking?: boolean;
  keyUpdateField?: string;
  allowChangeDateEdit?: boolean;
}

export interface XmlFormatModel {
  checked?: boolean;
  eOneXmlNodeText?: string;
  eOneXmlNodeType?: string;
  eOneXmlContent?: string;
  eOneXmlNodeValue?: string;
  eOneRequired?: boolean;
  eOneGrouped?: boolean;
  eOneXmlNodeItems?: XmlFormatModel[];
  eOneXmlNodeId?: string;
  eOneXmlNamespace?: string;
}

export interface XmlNamespace {
  id?: string;
  name?: string;
  value?: string;
}

interface BaseConnectorInstanceBaseModel {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  customerId?: string;
  description?: string;
  loadError?: string;
  isComplete?: boolean;
  instanceType?: string;
  typeName?: string;
  installNotes?: string;
}

type BaseConnectorInstanceBaseModelInstanceTypeMapping<Key, Type> = {
  InstanceType: Key;
} & Type;

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<
  AxiosRequestConfig,
  'data' | 'params' | 'url' | 'responseType'
> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<
  AxiosRequestConfig,
  'data' | 'cancelToken'
> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title WebApp Api Document
 * @version v1
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags ScriptNamespaces
   * @name Get
   * @request GET:/script-namespaces
   */
  get = (params: RequestParams = {}) =>
    this.request<ScriptNamespacesModel[], any>({
      path: `/script-namespaces`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  account = {
    /**
     * No description
     *
     * @tags Account
     * @name GetApiModel
     * @request GET:/api/account/get-api
     */
    getApiModel: (params: RequestParams = {}) =>
      this.request<AccountApiModel, any>({
        path: `/api/account/get-api`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name SwitchAccount
     * @request POST:/api/account/switch
     */
    switchAccount: (data: SwitchRequest, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/account/switch`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name GetAccounts
     * @request GET:/api/account/get-accounts
     */
    getAccounts: (params: RequestParams = {}) =>
      this.request<AccountSwitchModelListBaseResponse, any>({
        path: `/api/account/get-accounts`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name SwitchAccount2
     * @request POST:/api/account/switch-account
     * @originalName switchAccount
     * @duplicate
     */
    switchAccount2: (data: AccountSwitchRequest, params: RequestParams = {}) =>
      this.request<StringBaseResponse, any>({
        path: `/api/account/switch-account`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name GetUsage
     * @request GET:/api/account/usage
     */
    getUsage: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/account/usage`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  additionalColumn = {
    /**
     * No description
     *
     * @tags AdditionalColumn
     * @name GetAdditionalColumnAllowGroupBy
     * @request POST:/api/additional-column/allow-group-by
     */
    getAdditionalColumnAllowGroupBy: (
      data: GetAdditionalColumnAllowGroupByRequest,
      params: RequestParams = {},
    ) =>
      this.request<BooleanBaseResponse, any>({
        path: `/api/additional-column/allow-group-by`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdditionalColumn
     * @name SaveDateCalculationFormats
     * @request POST:/api/additional-column/date-format/save
     */
    saveDateCalculationFormats: (data: DateTimeFormat, params: RequestParams = {}) =>
      this.request<BooleanBaseResponse, any>({
        path: `/api/additional-column/date-format/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  appRegistration = {
    /**
     * No description
     *
     * @tags AppRegistration
     * @name GetAppRegistrationModel
     * @request GET:/api/app-registration/{id}
     */
    getAppRegistrationModel: (id: string, params: RequestParams = {}) =>
      this.request<AppRegistrationModelBaseResponse, any>({
        path: `/api/app-registration/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppRegistration
     * @name SaveAppRegistration
     * @request PATCH:/api/app-registration/{id}
     */
    saveAppRegistration: (id: string, data: AppRegistrationModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/app-registration/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppRegistration
     * @name DeleteAppRegistration
     * @request DELETE:/api/app-registration/{id}
     */
    deleteAppRegistration: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/app-registration/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppRegistration
     * @name CreateAppRegistration
     * @request POST:/api/app-registration
     */
    createAppRegistration: (data: AppRegistrationStubRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/app-registration`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppRegistration
     * @name CreateAppRegistrationSecret
     * @request POST:/api/app-registration/secret
     */
    createAppRegistrationSecret: (
      data: AppRegistrationSecretStubRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/app-registration/secret`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppRegistration
     * @name DeleteAppRegistrationSecret
     * @request DELETE:/api/app-registration/secret/{id}
     */
    deleteAppRegistrationSecret: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/app-registration/secret/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  appStore = {
    /**
     * No description
     *
     * @tags AppStore
     * @name GetProcessTemplates
     * @request GET:/api/app-store/templates
     */
    getProcessTemplates: (
      query?: {
        directory?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/app-store/templates`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  auditLog = {
    /**
     * No description
     *
     * @tags AuditLog
     * @name GetEntityAuditLogs
     * @request POST:/api/audit-log/entity-log/list
     */
    getEntityAuditLogs: (data: GetEntityAuditLogRequest, params: RequestParams = {}) =>
      this.request<AuditLogDtoListBaseResponse, any>({
        path: `/api/audit-log/entity-log/list`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuditLog
     * @name GetEntityAuditLogDetail
     * @request POST:/api/audit-log/detail
     */
    getEntityAuditLogDetail: (data: GetEntityAuditLogDetailRequest, params: RequestParams = {}) =>
      this.request<StringBaseResponse, any>({
        path: `/api/audit-log/detail`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuditLog
     * @name GetDeletedObjects
     * @request POST:/api/audit-log/deleted-objects/list
     */
    getDeletedObjects: (params: RequestParams = {}) =>
      this.request<AuditLogDtoListBaseResponse, any>({
        path: `/api/audit-log/deleted-objects/list`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuditLog
     * @name ExportSingleAuditLog
     * @request POST:/api/audit-log/export/single
     */
    exportSingleAuditLog: (data: GetEntityAuditLogDetailRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/audit-log/export/single`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuditLog
     * @name ExportAllAuditLogs
     * @request POST:/api/audit-log/export/all
     */
    exportAllAuditLogs: (data: ExportEntityAuditLogsRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/audit-log/export/all`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  cache = {
    /**
     * No description
     *
     * @tags Cache
     * @name GetCachedItem
     * @request GET:/api/cache/{cacheKey}
     */
    getCachedItem: (cacheKey: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/cache/${cacheKey}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cache
     * @name GetCustomerKeys
     * @request GET:/api/cache/customer-keys
     */
    getCustomerKeys: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/cache/customer-keys`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cache
     * @name DeleteCachedItems
     * @request DELETE:/api/cache/{id}
     */
    deleteCachedItems: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/cache/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  ceChange = {
    /**
     * No description
     *
     * @tags CeChangeDataSource
     * @name Save
     * @request POST:/api/ce-change/save
     */
    save: (data: CeChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-change/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeChangeDataSource
     * @name Validate
     * @request POST:/api/ce-change/validate
     */
    validate: (data: CeChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-change/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeChangeDataSource
     * @name CreateTables
     * @request POST:/api/ce-change/create-tables
     */
    createTables: (data: CeChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-change/create-tables`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeChangeDataSource
     * @name GetPreview
     * @request POST:/api/ce-change/preview
     */
    getPreview: (data: CeChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/ce-change/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeChangeDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/ce-change/schema-columns/reload
     */
    reloadSchemaColumns: (data: CeChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-change/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeChangeDataSource
     * @name CacheDataSource
     * @request POST:/api/ce-change/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: CeChangeDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-change/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeChangeDataSource
     * @name GetQueryText
     * @request POST:/api/ce-change/get-query-text
     */
    getQueryText: (data: CeChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-change/get-query-text`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  ceDestination = {
    /**
     * No description
     *
     * @tags CeDestination
     * @name GetEntities
     * @request GET:/api/ce-destination/get-entities/{connectorInstanceId}/{organizationName}
     */
    getEntities: (
      connectorInstanceId: string,
      organizationName: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-destination/get-entities/${connectorInstanceId}/${organizationName}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeDestination
     * @name Validate
     * @request POST:/api/ce-destination/validate
     */
    validate: (data: CeDestinationModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-destination/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeDestination
     * @name GetActions
     * @summary Top-level "Add Action" picker — lists unbound actions.
     * @request GET:/api/ce-destination/get-actions/{connectorInstanceId}/{organizationName}
     */
    getActions: (
      connectorInstanceId: string,
      organizationName: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-destination/get-actions/${connectorInstanceId}/${organizationName}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeDestination
     * @name GetEntityActions
     * @summary Per-entity "Add Action" picker — lists bound actions for the given entity.
     * @request GET:/api/ce-destination/get-actions/{connectorInstanceId}/{organizationName}/{entityLogicalName}
     */
    getEntityActions: (
      connectorInstanceId: string,
      organizationName: string,
      entityLogicalName: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-destination/get-actions/${connectorInstanceId}/${organizationName}/${entityLogicalName}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeDestination
     * @name GetMapLines
     * @request POST:/api/ce-destination/get-destination-lines
     */
    getMapLines: (data: CeDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/ce-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeDestination
     * @name GetMapLineParameters
     * @request POST:/api/ce-destination/get-destination-line-parameters/{mapLineTechnicalName}/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalName: string,
      mapLineTechnicalValue: string,
      data: CeDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/ce-destination/get-destination-line-parameters/${mapLineTechnicalName}/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  ceQuery = {
    /**
     * No description
     *
     * @tags CeQueryDataSource
     * @name Save
     * @request POST:/api/ce-query/save
     */
    save: (data: CeQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeQueryDataSource
     * @name GetPreview
     * @request POST:/api/ce-query/preview
     */
    getPreview: (data: CeQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/ce-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeQueryDataSource
     * @name Validate
     * @request POST:/api/ce-query/validate
     */
    validate: (data: CeQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeQueryDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/ce-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: CeQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeQueryDataSource
     * @name CacheDataSource
     * @request POST:/api/ce-query/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: CeQueryDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-query/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  ceRealtime = {
    /**
     * No description
     *
     * @tags CeRealTimeDataSource
     * @name Save
     * @request POST:/api/ce-realtime/save
     */
    save: (data: CeRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-realtime/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeRealTimeDataSource
     * @name Validate
     * @request POST:/api/ce-realtime/validate
     */
    validate: (data: CeRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-realtime/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeRealTimeDataSource
     * @name GetPreview
     * @request POST:/api/ce-realtime/preview
     */
    getPreview: (data: CeRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/ce-realtime/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeRealTimeDataSource
     * @name CacheDataSource
     * @request POST:/api/ce-realtime/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: CeRealTimeDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-realtime/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeRealTimeDataSource
     * @name GetLinkedMaps
     * @request GET:/api/ce-realtime/get-linked-maps/{id}
     */
    getLinkedMaps: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-realtime/get-linked-maps/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeRealTimeDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/ce-realtime/schema-columns/reload
     */
    reloadSchemaColumns: (data: CeRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-realtime/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeRealTimeDataSource
     * @name RegisterDataSource
     * @request POST:/api/ce-realtime/register-datasource
     */
    registerDataSource: (data: CeRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-realtime/register-datasource`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeRealTimeDataSource
     * @name GetQueryText
     * @request POST:/api/ce-realtime/get-query-text
     */
    getQueryText: (data: CeRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-realtime/get-query-text`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  ceRealtimeWebhook = {
    /**
     * No description
     *
     * @tags CeRealtimeWebhookDataSource
     * @name Save
     * @request POST:/api/ce-realtime-webhook/save
     */
    save: (data: CeRealtimeDataSourceWebhookModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-realtime-webhook/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeRealtimeWebhookDataSource
     * @name Validate
     * @request POST:/api/ce-realtime-webhook/validate
     */
    validate: (data: CeRealtimeDataSourceWebhookModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-realtime-webhook/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CeRealtimeWebhookDataSource
     * @name GetLinkedMaps
     * @request GET:/api/ce-realtime-webhook/get-linked-maps/{id}
     */
    getLinkedMaps: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ce-realtime-webhook/get-linked-maps/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  connectorInstance = {
    /**
     * No description
     *
     * @tags ConnectorInstance
     * @name Get
     * @request GET:/api/connector-instance
     */
    get: (params: RequestParams = {}) =>
      this.request<GetConnectInstanceResponseBaseResponse, any>({
        path: `/api/connector-instance`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConnectorInstance
     * @name CheckInstanceName
     * @request POST:/api/connector-instance/check-name-instance
     */
    checkInstanceName: (data: ConnectorInstanceCheckNameRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/connector-instance/check-name-instance`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConnectorInstance
     * @name QueryConnection
     * @request POST:/api/connector-instance/list
     */
    queryConnection: (data: ConnectionRequest, params: RequestParams = {}) =>
      this.request<ConnectionModel[], any>({
        path: `/api/connector-instance/list`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConnectorInstance
     * @name Get2
     * @request GET:/api/connector-instance/{id}/{type}
     * @originalName get
     * @duplicate
     */
    get2: (id: string, type: string, params: RequestParams = {}) =>
      this.request<ConnectorInstanceBaseModelBaseResponse, any>({
        path: `/api/connector-instance/${id}/${type}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConnectorInstance
     * @name Get3
     * @request GET:/api/connector-instance/{id}
     * @originalName get
     * @duplicate
     */
    get3: (id: string, params: RequestParams = {}) =>
      this.request<ConnectorInstanceBaseModelBaseResponse, any>({
        path: `/api/connector-instance/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConnectorInstance
     * @name Delete
     * @request DELETE:/api/connector-instance/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<DeleteConnectorInstanceResponseBaseResponse, any>({
        path: `/api/connector-instance/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConnectorInstance
     * @name GetConnectionOptions
     * @request GET:/api/connector-instance/options
     */
    getConnectionOptions: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/connector-instance/options`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConnectorInstance
     * @name Create
     * @request POST:/api/connector-instance/add
     */
    create: (data: CreateConnectorInstanceListModel, params: RequestParams = {}) =>
      this.request<ConnectorInstanceListModelBaseResponse, any>({
        path: `/api/connector-instance/add`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConnectorInstance
     * @name GetConnectorInstanceByType
     * @request GET:/api/connector-instance/get-by-type/{connectionType}
     */
    getConnectorInstanceByType: (connectionType: string, params: RequestParams = {}) =>
      this.request<StringStringKeyValuePairListBaseResponse, any>({
        path: `/api/connector-instance/get-by-type/${connectionType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConnectorInstance
     * @name GetDestinationTenants
     * @request POST:/api/connector-instance/get-destination-tenants/{destinationType}/{connectorInstanceId}
     */
    getDestinationTenants: (
      destinationType: DestinationType,
      connectorInstanceId: string,
      params: RequestParams = {},
    ) =>
      this.request<TenantBaseListBaseResponse, any>({
        path: `/api/connector-instance/get-destination-tenants/${destinationType}/${connectorInstanceId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  customerEngagement = {
    /**
     * No description
     *
     * @tags CustomerEngagement
     * @name ValidateConnection
     * @request POST:/api/customer-engagement/validate/{id}
     */
    validateConnection: (
      id: string,
      data: CustomerEngagementInstanceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/customer-engagement/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerEngagement
     * @name SaveConnection
     * @request POST:/api/customer-engagement/save/{id}
     */
    saveConnection: (
      id: string,
      data: CustomerEngagementInstanceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/customer-engagement/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerEngagement
     * @name AuthCallback
     * @request GET:/api/customer-engagement/authCallback
     */
    authCallback: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/customer-engagement/authCallback`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerEngagement
     * @name GetOrganizations
     * @request GET:/api/customer-engagement/get-organizations/{id}
     */
    getOrganizations: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/customer-engagement/get-organizations/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerEngagement
     * @name GetOrganizationMetadataStatus
     * @summary SC-785: all reachable orgs merged with their per-org metadata state — feeds the setup grid. POST so the live org list can be fetched with the posted model's credentials — a brand-new connection's just-validated token isn't persisted to the DB until Save.
     * @request POST:/api/customer-engagement/get-organization-metadata-status/{id}
     */
    getOrganizationMetadataStatus: (
      id: string,
      data: CustomerEngagementInstanceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/customer-engagement/get-organization-metadata-status/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerEngagement
     * @name RefreshOrgMetadata
     * @summary SC-785: purge + re-fetch one org's metadata in the background, then update its fetched flag.
     * @request PATCH:/api/customer-engagement/refresh-org-metadata/{id}/{organization}
     */
    refreshOrgMetadata: (id: string, organization: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/customer-engagement/refresh-org-metadata/${id}/${organization}`,
        method: 'PATCH',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerEngagement
     * @name GetOrganizationEntities
     * @request GET:/api/customer-engagement/get-organization-entities/{id}/{organization}
     */
    getOrganizationEntities: (id: string, organization: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/customer-engagement/get-organization-entities/${id}/${organization}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerEngagement
     * @name GetWebhookSupportedEntities
     * @request GET:/api/customer-engagement/get-webhook-supported-entities/{id}/{organization}
     */
    getWebhookSupportedEntities: (id: string, organization: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/customer-engagement/get-webhook-supported-entities/${id}/${organization}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerEngagement
     * @name GetEntityAttributes
     * @request GET:/api/customer-engagement/get-entity-attributes/{id}/{organization}/{entity}
     */
    getEntityAttributes: (
      id: string,
      organization: string,
      entity: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/customer-engagement/get-entity-attributes/${id}/${organization}/${entity}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerEngagement
     * @name GetEntityOptionSetAttributes
     * @summary Option-set attributes (single-select Picklist AND multi-select MultiSelectPicklist) of an entity, each tagged with `isMultiSelect`. Backs the "List Option Lookup" additional-column attribute picker, which the generic query-builder field endpoint can't serve because it filters out the (typically Virtual) multi-select picklist attributes.
     * @request GET:/api/customer-engagement/get-entity-option-set-attributes/{id}/{organization}/{entity}
     */
    getEntityOptionSetAttributes: (
      id: string,
      organization: string,
      entity: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/customer-engagement/get-entity-option-set-attributes/${id}/${organization}/${entity}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  dashboard = {
    /**
     * No description
     *
     * @tags Dashboard
     * @name GetLayout
     * @summary Get home layout for current user
     * @request POST:/api/dashboard/layout/get
     */
    getLayout: (params: RequestParams = {}) =>
      this.request<HomeLayoutDtoBaseResponse, any>({
        path: `/api/dashboard/layout/get`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboard
     * @name SaveLayout
     * @summary Save or update home layout for current user
     * @request POST:/api/dashboard/layout/save
     */
    saveLayout: (data: HomeLayoutDto, params: RequestParams = {}) =>
      this.request<HomeLayoutDtoBaseResponse, any>({
        path: `/api/dashboard/layout/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboard
     * @name GetLatestNews
     * @summary Get latest news
     * @request POST:/api/dashboard/latest-news
     */
    getLatestNews: (params: RequestParams = {}) =>
      this.request<EOneNewsListBaseResponse, any>({
        path: `/api/dashboard/latest-news`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboard
     * @name GetLatestRunActivities
     * @summary Get latest 5 run activities for dashboard
     * @request POST:/api/dashboard/latest-activities
     */
    getLatestRunActivities: (
      data: GetLatestHistoryRunActivityRequest,
      params: RequestParams = {},
    ) =>
      this.request<MapRunActivityModelListBaseResponse, any>({
        path: `/api/dashboard/latest-activities`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboard
     * @name GetNextSchedules
     * @request POST:/api/dashboard/next-schedules
     */
    getNextSchedules: (data: GetNextScheduleRunsRequest, params: RequestParams = {}) =>
      this.request<NextScheduleDtoListBaseResponse, any>({
        path: `/api/dashboard/next-schedules`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboard
     * @name GetIntegrationHealthMetrics
     * @request POST:/api/dashboard/metrics/integration-health
     */
    getIntegrationHealthMetrics: (
      data: GetIntegrationHealthMetricsRequest,
      params: RequestParams = {},
    ) =>
      this.request<IntegrationHealthMetricsDtoBaseResponse, any>({
        path: `/api/dashboard/metrics/integration-health`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboard
     * @name GetIntegrationLiveActivity
     * @request POST:/api/dashboard/metrics/live-activity
     */
    getIntegrationLiveActivity: (
      data: GetIntegrationLiveActivityRequest,
      params: RequestParams = {},
    ) =>
      this.request<IntegrationLiveActivityDtoBaseResponse, any>({
        path: `/api/dashboard/metrics/live-activity`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboard
     * @name GetCurrentUsageMetrics
     * @request POST:/api/dashboard/metrics/current-usage
     */
    getCurrentUsageMetrics: (data: GetCurrentUsageMetricsRequest, params: RequestParams = {}) =>
      this.request<CurrentUsageMetricsDtoBaseResponse, any>({
        path: `/api/dashboard/metrics/current-usage`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboard
     * @name GetGroupHealthMetrics
     * @request POST:/api/dashboard/metrics/group-health
     */
    getGroupHealthMetrics: (data: GetGroupHealthMetricsRequest, params: RequestParams = {}) =>
      this.request<GroupHealthMetricsDtoBaseResponse, any>({
        path: `/api/dashboard/metrics/group-health`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboard
     * @name GetIncompleteDataSources
     * @summary Get incomplete data sources for dashboard todo list
     * @request POST:/api/dashboard/datasource-todos
     */
    getIncompleteDataSources: (params: RequestParams = {}) =>
      this.request<DataSourceTodoModelListBaseResponse, any>({
        path: `/api/dashboard/datasource-todos`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboard
     * @name GetIncompleteConnectorInstances
     * @summary Get incomplete connector instances for dashboard todo list
     * @request POST:/api/dashboard/connector-todos
     */
    getIncompleteConnectorInstances: (params: RequestParams = {}) =>
      this.request<ConnectorInstanceToDoModelListBaseResponse, any>({
        path: `/api/dashboard/connector-todos`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  dataSource = {
    /**
     * No description
     *
     * @tags DataSource
     * @name Get
     * @request GET:/api/data-source
     */
    get: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/data-source`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name Get2
     * @request GET:/api/data-source/{id}
     * @originalName get
     * @duplicate
     */
    get2: (id: string, params: RequestParams = {}) =>
      this.request<DataSourceBaseModelBaseResponse, any>({
        path: `/api/data-source/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name Delete
     * @request DELETE:/api/data-source/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/data-source/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetByConnection
     * @request GET:/api/data-source/connection/{id}
     */
    getByConnection: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/data-source/connection/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetPipeline
     * @request GET:/api/data-source/{id}/pipeline
     */
    getPipeline: (id: string, params: RequestParams = {}) =>
      this.request<DataSourcePipelineConfigBaseResponse, any>({
        path: `/api/data-source/${id}/pipeline`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name ValidatePipelineScript
     * @request POST:/api/data-source/{id}/pipeline/validate-script
     */
    validatePipelineScript: (id: string, data: ValidateScriptRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/data-source/${id}/pipeline/validate-script`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name CheckPipelineReferences
     * @request POST:/api/data-source/{id}/pipeline/check-references
     */
    checkPipelineReferences: (
      id: string,
      data: CheckPipelineReferencesRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/data-source/${id}/pipeline/check-references`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetConnections
     * @request GET:/api/data-source/connections
     */
    getConnections: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/data-source/connections`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name CheckDataSourceName
     * @request POST:/api/data-source/check-name-source
     */
    checkDataSourceName: (data: DataSourceCheckNameRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/data-source/check-name-source`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetDirectories
     * @request POST:/api/data-source/get-directories/{connectionId}/{type}
     */
    getDirectories: (connectionId: string, type: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/data-source/get-directories/${connectionId}/${type}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetDirectoryContents
     * @request POST:/api/data-source/get-directory-contents/{connectionId}/{type}
     */
    getDirectoryContents: (connectionId: string, type: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/data-source/get-directory-contents/${connectionId}/${type}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetIntegrationsByDataSourceId
     * @request GET:/api/data-source/{id}/integrations
     */
    getIntegrationsByDataSourceId: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/data-source/${id}/integrations`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetDraftsByDataSourceId
     * @request GET:/api/data-source/{id}/drafts
     */
    getDraftsByDataSourceId: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/data-source/${id}/drafts`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name SaveDataSourceStub
     * @request POST:/api/data-source/create-stub
     */
    saveDataSourceStub: (data: DataSourceStubRequest, params: RequestParams = {}) =>
      this.request<GuidBaseResponse, any>({
        path: `/api/data-source/create-stub`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name CreateDataSourceFromImport
     * @request POST:/api/data-source/create-from-import
     */
    createDataSourceFromImport: (
      data: DataSourceCreateFromImportRequest,
      params: RequestParams = {},
    ) =>
      this.request<GuidBaseResponse, any>({
        path: `/api/data-source/create-from-import`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetDataSourceOptions
     * @request GET:/api/data-source/options
     */
    getDataSourceOptions: (params: RequestParams = {}) =>
      this.request<ConnectorDataSourceListBaseResponse, any>({
        path: `/api/data-source/options`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetMsNavOdataApiDataSources
     * @request POST:/api/data-source/msnavodata/api-sources
     */
    getMsNavOdataApiDataSources: (params: RequestParams = {}) =>
      this.request<MsNavOdataApiDataSourceSetupDtoListBaseResponse, any>({
        path: `/api/data-source/msnavodata/api-sources`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetMsNavOdataBulkDataSources
     * @request POST:/api/data-source/msnavodata/bulk-sources
     */
    getMsNavOdataBulkDataSources: (data: GetDataSourceRequest, params: RequestParams = {}) =>
      this.request<MsNavOdataBulkDataSourceDtoListBaseResponse, any>({
        path: `/api/data-source/msnavodata/bulk-sources`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetFinOpsDataSources
     * @request POST:/api/data-source/fin-ops/query-sources
     */
    getFinOpsDataSources: (params: RequestParams = {}) =>
      this.request<FinOpsOdataDataSourceDtoListBaseResponse, any>({
        path: `/api/data-source/fin-ops/query-sources`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetMsNavOdataChangeDataSources
     * @request POST:/api/data-source/msnavodata/change-data-sources
     */
    getMsNavOdataChangeDataSources: (data: GetDataSourceRequest, params: RequestParams = {}) =>
      this.request<MsNavOdataChangeDataSourceSetupDtoListBaseResponse, any>({
        path: `/api/data-source/msnavodata/change-data-sources`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetMssqlQueryDataSources
     * @request POST:/api/data-source/mssql/query-data-sources
     */
    getMssqlQueryDataSources: (params: RequestParams = {}) =>
      this.request<MsSqlQueryDataSourceSetupDtoListBaseResponse, any>({
        path: `/api/data-source/mssql/query-data-sources`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetExcelDataSources
     * @request POST:/api/data-source/excel/data-sources
     */
    getExcelDataSources: (params: RequestParams = {}) =>
      this.request<ExcelDataSourceSetupDtoListBaseResponse, any>({
        path: `/api/data-source/excel/data-sources`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetGenericConnectionsByEntity
     * @request GET:/api/data-source/get-generic-connections/{entityId}
     */
    getGenericConnectionsByEntity: (entityId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/data-source/get-generic-connections/${entityId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataSource
     * @name GetDataSourceListByType
     * @request GET:/api/data-source/query-by-type/{type}
     */
    getDataSourceListByType: (type: string, params: RequestParams = {}) =>
      this.request<GuidStringKeyValuePairListBaseResponse, any>({
        path: `/api/data-source/query-by-type/${type}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  dateTimeFormat = {
    /**
     * No description
     *
     * @tags DateTimeFormat
     * @name GetList
     * @request GET:/api/date-time-format
     */
    getList: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/date-time-format`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DateTimeFormat
     * @name Create
     * @request POST:/api/date-time-format
     */
    create: (data: DateTimeFormatDto, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/date-time-format`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DateTimeFormat
     * @name Update
     * @request PATCH:/api/date-time-format
     */
    update: (data: DateTimeFormat, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/date-time-format`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DateTimeFormat
     * @name GetCombinedList
     * @request GET:/api/date-time-format/date-format/list
     */
    getCombinedList: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/date-time-format/date-format/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DateTimeFormat
     * @name Delete
     * @request DELETE:/api/date-time-format/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/date-time-format/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DateTimeFormat
     * @name CheckName
     * @request POST:/api/date-time-format/check-name
     */
    checkName: (data: CheckNameRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/date-time-format/check-name`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  destination = {
    /**
     * No description
     *
     * @tags Destination
     * @name GetDestinationByType
     * @request GET:/api/destination/query-by-type/{targetType}
     */
    getDestinationByType: (targetType: DestinationType, params: RequestParams = {}) =>
      this.request<ConnectionModelListBaseResponse, any>({
        path: `/api/destination/query-by-type/${targetType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  draft = {
    /**
     * No description
     *
     * @tags Draft
     * @name GetList
     * @request GET:/api/draft/list
     */
    getList: (params: RequestParams = {}) =>
      this.request<DraftBriefingDtoListBaseResponse, any>({
        path: `/api/draft/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Draft
     * @name GetDraftByProcessId
     * @request GET:/api/draft/get-by-process/{processId}
     */
    getDraftByProcessId: (processId: string, params: RequestParams = {}) =>
      this.request<DraftBriefingDtoBaseResponse, any>({
        path: `/api/draft/get-by-process/${processId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Draft
     * @name SaveDraft
     * @request POST:/api/draft/save
     */
    saveDraft: (data: SaveDraftRequest, params: RequestParams = {}) =>
      this.request<DraftDtoBaseResponse, any>({
        path: `/api/draft/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Draft
     * @name ResetDraftLock
     * @request POST:/api/draft/lock/reset
     */
    resetDraftLock: (data: ResetDraftLockRequest, params: RequestParams = {}) =>
      this.request<ResetDraftLockResponseBaseResponse, any>({
        path: `/api/draft/lock/reset`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Draft
     * @name Unlock
     * @request POST:/api/draft/unlock/{id}
     */
    unlock: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/draft/unlock/${id}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Draft
     * @name GetDraft
     * @request POST:/api/draft/get
     */
    getDraft: (data: GetDraftRequest, params: RequestParams = {}) =>
      this.request<DraftDtoBaseResponse, any>({
        path: `/api/draft/get`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Draft
     * @name Delete
     * @request POST:/api/draft/delete
     */
    delete: (data: DeleteDraftRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/draft/delete`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  dropbox = {
    /**
     * No description
     *
     * @tags Dropbox
     * @name ValidateConnection
     * @request POST:/api/dropbox/validate/{id}
     */
    validateConnection: (id: string, data: DropboxInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/dropbox/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dropbox
     * @name SaveConnection
     * @request POST:/api/dropbox/save/{id}
     */
    saveConnection: (id: string, data: DropboxInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/dropbox/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dropbox
     * @name AuthCallback
     * @request GET:/api/dropbox/authCallback
     */
    authCallback: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/dropbox/authCallback`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  excelDataSource = {
    /**
     * No description
     *
     * @tags ExcelFile
     * @name GetPreview
     * @request POST:/api/excel-data-source/preview
     */
    getPreview: (data: ExcelDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/excel-data-source/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExcelFile
     * @name Validate
     * @request POST:/api/excel-data-source/validate
     */
    validate: (data: ExcelDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/excel-data-source/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExcelFile
     * @name Save
     * @request POST:/api/excel-data-source/save
     */
    save: (data: ExcelDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/excel-data-source/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExcelFile
     * @name LoadExcelFile
     * @request POST:/api/excel-data-source/load-file/{fileName}
     */
    loadExcelFile: (fileName: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/excel-data-source/load-file/${fileName}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExcelFile
     * @name ReloadSchemaColumns
     * @request POST:/api/excel-data-source/schema-columns/reload
     */
    reloadSchemaColumns: (data: ExcelDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/excel-data-source/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExcelFile
     * @name GetWorksheets
     * @request POST:/api/excel-data-source/get-worksheets
     */
    getWorksheets: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/excel-data-source/get-worksheets`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  excelFileDestination = {
    /**
     * No description
     *
     * @tags ExcelFileDestination
     * @name GetDestinations
     * @request GET:/api/excel-file-destination/list
     */
    getDestinations: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/excel-file-destination/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExcelFileDestination
     * @name GetDestinationData
     * @request POST:/api/excel-file-destination/get-destination-data
     */
    getDestinationData: (data: ExcelFileDestinationModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/excel-file-destination/get-destination-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExcelFileDestination
     * @name GetDestinationLines
     * @request GET:/api/excel-file-destination/get-destination-lines
     */
    getDestinationLines: (params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/excel-file-destination/get-destination-lines`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExcelFileDestination
     * @name GetMapLineParameters
     * @request POST:/api/excel-file-destination/get-destination-line-parameters/{mapLineTechnicalName}/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalName: string,
      mapLineTechnicalValue: string,
      data: ExcelFileDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/excel-file-destination/get-destination-line-parameters/${mapLineTechnicalName}/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  excelFolder = {
    /**
     * No description
     *
     * @tags ExcelFolder
     * @name GetPreview
     * @request POST:/api/excel-folder/preview
     */
    getPreview: (data: ExcelFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/excel-folder/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExcelFolder
     * @name Validate
     * @request POST:/api/excel-folder/validate
     */
    validate: (data: ExcelFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/excel-folder/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExcelFolder
     * @name ReloadSchemaColumns
     * @request POST:/api/excel-folder/schema-columns/reload
     */
    reloadSchemaColumns: (data: ExcelFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/excel-folder/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExcelFolder
     * @name Save
     * @request POST:/api/excel-folder/save
     */
    save: (data: ExcelFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/excel-folder/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExcelFolder
     * @name LoadExcelFile
     * @request POST:/api/excel-folder/load-file/{fileName}
     */
    loadExcelFile: (fileName: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/excel-folder/load-file/${fileName}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  extenderQuery = {
    /**
     * No description
     *
     * @tags ExtnderQueryDataSource
     * @name Save
     * @request POST:/api/extender-query/save
     */
    save: (data: ExtenderQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/extender-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExtnderQueryDataSource
     * @name Validate
     * @request POST:/api/extender-query/validate
     */
    validate: (data: ExtenderQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/extender-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExtnderQueryDataSource
     * @name GetPreview
     * @request POST:/api/extender-query/preview
     */
    getPreview: (data: ExtenderQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/extender-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExtnderQueryDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/extender-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: ExtenderQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/extender-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExtnderQueryDataSource
     * @name CacheDataSource
     * @request POST:/api/extender-query/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: ExtenderQueryDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/extender-query/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExtnderQueryDataSource
     * @name GetExtenderIds
     * @request POST:/api/extender-query/get-extender-ids
     */
    getExtenderIds: (data: ExtenderQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/extender-query/get-extender-ids`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  fabric = {
    /**
     * No description
     *
     * @tags Fabric
     * @name ValidateConnection
     * @request POST:/api/fabric/validate/{id}
     */
    validateConnection: (id: string, data: FabricInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fabric
     * @name SaveConnection
     * @request POST:/api/fabric/save/{id}
     */
    saveConnection: (id: string, data: FabricInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fabric
     * @name GetDatabases
     * @request POST:/api/fabric/get-external-settings/{id}
     */
    getDatabases: (id: string, data: FabricInstanceModel, params: RequestParams = {}) =>
      this.request<MssqlDatabaseListResponseBaseResponse, any>({
        path: `/api/fabric/get-external-settings/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fabric
     * @name GetDatabases2
     * @summary Database list for the Fabric query source edit form. Fabric artifacts are discovered via REST and persisted as tenant capabilities; the list comes solely from that classification (selected tenants only) — never from a sys.databases enumeration, so there is no crossover into MssqlInstance. An unclassified connection surfaces nothing (it can't be a usable connection — validate requires a classification). value = technical name (what's persisted as the database); label = friendly display name (a Fabric technical name carries a guid, so it must not be shown to the user).
     * @request GET:/api/fabric/get-databases/{id}
     * @originalName getDatabases
     * @duplicate
     */
    getDatabases2: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric/get-databases/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fabric
     * @name GetChangeDatabases
     * @summary Database list for the Fabric change source edit form. Only tenants that support change tracking (selected AND Change) are offered, so a Warehouse / Lakehouse that can't host tracking triggers is excluded. value = the technical name persisted as the database; label = the friendly display name. The list is derived solely from the connection's own REST classification (no MssqlInstance enumeration); an unclassified connection surfaces nothing.
     * @request GET:/api/fabric/get-change-databases/{id}
     */
    getChangeDatabases: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric/get-change-databases/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fabric
     * @name GetTables
     * @request GET:/api/fabric/get-tables/{id}/{database}
     */
    getTables: (id: string, database: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric/get-tables/${id}/${database}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fabric
     * @name GetTableColumnsWithTypes
     * @request GET:/api/fabric/get-table-columns-with-types/{id}/{database}/{table}
     */
    getTableColumnsWithTypes: (
      id: string,
      database: string,
      table: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric/get-table-columns-with-types/${id}/${database}/${table}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fabric
     * @name GetTableColumns
     * @request GET:/api/fabric/get-table-columns/{id}/{database}/{table}
     */
    getTableColumns: (id: string, database: string, table: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric/get-table-columns/${id}/${database}/${table}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fabric
     * @name ValidateCommand
     * @summary Design-time validation for the Fabric command task: is the T-SQL valid to run against the selected store? A pure read (SELECT) is valid on any store; a write/DDL command needs a store whose tenant capability permits writes (a lakehouse SQL endpoint is read-only). Shares SmartConnect.Generic.Helpers.FabricSqlCommandValidator + the writable check with the runtime guard so the two can't diverge. Unclassified/legacy connections are treated as writable.
     * @request POST:/api/fabric/validate-command
     */
    validateCommand: (data: FabricCommandValidationRequest, params: RequestParams = {}) =>
      this.request<FabricCommandValidationResponseBaseResponse, any>({
        path: `/api/fabric/validate-command`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fabric
     * @name GetLookupPreview
     * @summary Runs a Fabric additional-column lookup as the editor has it configured, for the column's Test button. A Fabric store is a T-SQL endpoint, so the query itself is the MSSQL one.
     * @request POST:/api/fabric/lookup/preview
     */
    getLookupPreview: (data: MssqlLookupPreviewModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric/lookup/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  fabricChange = {
    /**
     * No description
     *
     * @tags FabricChangeDataSource
     * @name Validate
     * @request POST:/api/fabric-change/validate
     */
    validate: (data: FabricChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric-change/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricChangeDataSource
     * @name Save
     * @request POST:/api/fabric-change/save
     */
    save: (data: FabricChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric-change/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricChangeDataSource
     * @name GetPreview
     * @request POST:/api/fabric-change/preview
     */
    getPreview: (data: FabricChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/fabric-change/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricChangeDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/fabric-change/schema-columns/reload
     */
    reloadSchemaColumns: (data: FabricChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric-change/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricChangeDataSource
     * @name CacheDataSource
     * @request POST:/api/fabric-change/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: FabricChangeDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric-change/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  fabricQuery = {
    /**
     * No description
     *
     * @tags FabricQuerySource
     * @name Validate
     * @request POST:/api/fabric-query/validate
     */
    validate: (data: FabricQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricQuerySource
     * @name Save
     * @request POST:/api/fabric-query/save
     */
    save: (data: FabricQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricQuerySource
     * @name GetPreview
     * @request POST:/api/fabric-query/preview
     */
    getPreview: (data: FabricQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/fabric-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricQuerySource
     * @name ReloadSchemaColumns
     * @request POST:/api/fabric-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: FabricQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricQuerySource
     * @name CacheDataSource
     * @request POST:/api/fabric-query/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: FabricQueryDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric-query/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  fabricTableDestination = {
    /**
     * No description
     *
     * @tags FabricTableDestination
     * @name GetDestinations
     * @request GET:/api/fabric-table-destination/list
     */
    getDestinations: (params: RequestParams = {}) =>
      this.request<FabricInstanceModelListBaseResponse, any>({
        path: `/api/fabric-table-destination/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricTableDestination
     * @name GetDestinationData
     * @request POST:/api/fabric-table-destination/get-destination-data
     */
    getDestinationData: (data: FabricTableDestinationModel, params: RequestParams = {}) =>
      this.request<SqlObjectListBaseResponse, any>({
        path: `/api/fabric-table-destination/get-destination-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricTableDestination
     * @name GetDestinationLines
     * @request POST:/api/fabric-table-destination/get-destination-lines
     */
    getDestinationLines: (data: FabricTableDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/fabric-table-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricTableDestination
     * @name GetMapLineParameters
     * @request POST:/api/fabric-table-destination/get-destination-line-parameters/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalValue: string,
      data: FabricTableDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/fabric-table-destination/get-destination-line-parameters/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  fabricRealtime = {
    /**
     * No description
     *
     * @tags FabricTableRealTimeDataSource
     * @name Save
     * @request POST:/api/fabric-realtime/save
     */
    save: (data: FabricRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric-realtime/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricTableRealTimeDataSource
     * @name Validate
     * @request POST:/api/fabric-realtime/validate
     */
    validate: (data: FabricRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric-realtime/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricTableRealTimeDataSource
     * @name GetLinkedMaps
     * @request GET:/api/fabric-realtime/get-linked-maps/{id}
     */
    getLinkedMaps: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric-realtime/get-linked-maps/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricTableRealTimeDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/fabric-realtime/schema-columns/reload
     */
    reloadSchemaColumns: (data: FabricRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric-realtime/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricTableRealTimeDataSource
     * @name CacheDataSource
     * @request POST:/api/fabric-realtime/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: FabricRealTimeDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric-realtime/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FabricTableRealTimeDataSource
     * @name RegisterDataSource
     * @request POST:/api/fabric-realtime/register-datasource
     */
    registerDataSource: (data: FabricRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/fabric-realtime/register-datasource`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  finops = {
    /**
     * No description
     *
     * @tags FinOps
     * @name ValidateConnection
     * @request POST:/api/finops/validate/{id}
     */
    validateConnection: (id: string, data: FinOpsInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOps
     * @name GetCompanies
     * @request POST:/api/finops/get-external-settings/{id}
     */
    getCompanies: (id: string, data: FinOpsInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops/get-external-settings/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOps
     * @name GetEntities
     * @request GET:/api/finops/entities/{id}
     */
    getEntities: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops/entities/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOps
     * @name SaveConnection
     * @request POST:/api/finops/save/{id}
     */
    saveConnection: (id: string, data: FinOpsInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOps
     * @name RefreshMetadata
     * @request POST:/api/finops/refresh-metadata/{id}
     */
    refreshMetadata: (id: string, data: FinOpsRefreshMetadataRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops/refresh-metadata/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOps
     * @name AuthCallback
     * @request GET:/api/finops/authCallback
     */
    authCallback: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops/authCallback`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  finopsDestination = {
    /**
     * No description
     *
     * @tags FinOpsDestination
     * @name GetServices
     * @request GET:/api/finops-destination/get-services/{instanceId}
     */
    getServices: (instanceId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops-destination/get-services/${instanceId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOpsDestination
     * @name GetEntityDetails
     * @request GET:/api/finops-destination/get-entity-details/{instanceId}/{entity}
     */
    getEntityDetails: (instanceId: string, entity: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops-destination/get-entity-details/${instanceId}/${entity}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOpsDestination
     * @name GetMapLines
     * @request POST:/api/finops-destination/get-destination-lines
     */
    getMapLines: (data: FinOpsOdataDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/finops-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOpsDestination
     * @name GetMapLineParameters
     * @request POST:/api/finops-destination/get-destination-line-parameters/{mapLineTechnicalName}/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalName: string,
      mapLineTechnicalValue: string,
      data: FinOpsOdataDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/finops-destination/get-destination-line-parameters/${mapLineTechnicalName}/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  finopsQuery = {
    /**
     * No description
     *
     * @tags FinOpsQuerySource
     * @name GetCompanies
     * @request GET:/api/finops-query/get-companies/{instanceId}
     */
    getCompanies: (instanceId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops-query/get-companies/${instanceId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOpsQuerySource
     * @name GetServices
     * @request GET:/api/finops-query/get-services/{instanceId}
     */
    getServices: (instanceId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops-query/get-services/${instanceId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOpsQuerySource
     * @name GetNavigationChildren
     * @request GET:/api/finops-query/get-navigation-children/{instanceId}/{entity}
     */
    getNavigationChildren: (instanceId: string, entity: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops-query/get-navigation-children/${instanceId}/${entity}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOpsQuerySource
     * @name GetFields
     * @request GET:/api/finops-query/get-fields/{instanceId}/{entity}
     */
    getFields: (instanceId: string, entity: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops-query/get-fields/${instanceId}/${entity}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOpsQuerySource
     * @name ReloadSchemaColumns
     * @request POST:/api/finops-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: FinOpsQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOpsQuerySource
     * @name Save
     * @request POST:/api/finops-query/save
     */
    save: (data: FinOpsQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOpsQuerySource
     * @name Validate
     * @request POST:/api/finops-query/validate
     */
    validate: (data: FinOpsQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/finops-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinOpsQuerySource
     * @name GetPreview
     * @request POST:/api/finops-query/preview
     */
    getPreview: (data: FinOpsQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/finops-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  ftp = {
    /**
     * No description
     *
     * @tags FTP
     * @name DeleteKeyFile
     * @request DELETE:/api/ftp/delete-key-file/{id}
     */
    deleteKeyFile: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ftp/delete-key-file/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FTP
     * @name ValidateConnection
     * @request POST:/api/ftp/validate/{id}
     */
    validateConnection: (id: string, data: FtpInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ftp/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FTP
     * @name LoadKeyFile
     * @request POST:/api/ftp/upload-file/{connectorInstanceId}/{fileName}
     */
    loadKeyFile: (connectorInstanceId: string, fileName: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ftp/upload-file/${connectorInstanceId}/${fileName}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FTP
     * @name SaveConnection
     * @request POST:/api/ftp/save/{id}
     */
    saveConnection: (id: string, data: FtpInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/ftp/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  genericRest = {
    /**
     * No description
     *
     * @tags GenericRest
     * @name Get
     * @request GET:/api/generic-rest
     */
    get: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name Get2
     * @request GET:/api/generic-rest/{id}
     * @originalName get
     * @duplicate
     */
    get2: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name DeleteRestDefinition
     * @request DELETE:/api/generic-rest/{id}
     */
    deleteRestDefinition: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name GetWebhook
     * @request GET:/api/generic-rest/webhook/{webhookId}
     */
    getWebhook: (webhookId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/webhook/${webhookId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name GetLookup
     * @request GET:/api/generic-rest/lookup/{lookupId}
     */
    getLookup: (lookupId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/lookup/${lookupId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name GetEntity
     * @request GET:/api/generic-rest/entity/{entityId}
     */
    getEntity: (entityId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/entity/${entityId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name GetAction
     * @request GET:/api/generic-rest/action/{actionId}
     */
    getAction: (actionId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/action/${actionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name Clone
     * @request POST:/api/generic-rest/clone-setup/{id}
     */
    clone: (id: string, data: CheckNameRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/clone-setup/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name ExportSetup
     * @request GET:/api/generic-rest/export-setup/{id}
     */
    exportSetup: (id: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/generic-rest/export-setup/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name PreviewImportSetup
     * @request POST:/api/generic-rest/import-setup/preview
     */
    previewImportSetup: (
      data: {
        /** @format binary */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/import-setup/preview`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name ConfirmImportSetup
     * @request POST:/api/generic-rest/import-setup/confirm
     */
    confirmImportSetup: (data: ConfirmRestImportRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/import-setup/confirm`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name CancelImportSetup
     * @request POST:/api/generic-rest/import-setup/cancel
     */
    cancelImportSetup: (data: ConfirmRestImportRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/import-setup/cancel`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name CheckName
     * @request POST:/api/generic-rest/check-name
     */
    checkName: (data: CheckNameRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/check-name`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name GetRestDestinationDetails
     * @request POST:/api/generic-rest/destination-details
     */
    getRestDestinationDetails: (
      data: GetRestDestinationDetailsRequest,
      params: RequestParams = {},
    ) =>
      this.request<GetRestDestinationDetailsResponse, any>({
        path: `/api/generic-rest/destination-details`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name GetGenericRestDataSources
     * @request POST:/api/generic-rest/data-sources
     */
    getGenericRestDataSources: (data: GetRestDataSourceListRequest, params: RequestParams = {}) =>
      this.request<GenericRestDataSourceSetupDto[], any>({
        path: `/api/generic-rest/data-sources`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name GetRealTimeDataSources
     * @request POST:/api/generic-rest/real-time/data-sources
     */
    getRealTimeDataSources: (data: GetRestDataSourceListRequest, params: RequestParams = {}) =>
      this.request<GenericListItemListBaseResponse, any>({
        path: `/api/generic-rest/real-time/data-sources`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name GetExternalSettings
     * @request GET:/api/generic-rest/external-settings/{id}
     */
    getExternalSettings: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/external-settings/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name CreateNew
     * @request POST:/api/generic-rest/add-new
     */
    createNew: (data: GenericRestSetupListModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/add-new`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name CreateRestAction
     * @request POST:/api/generic-rest/{id}/add-action
     */
    createRestAction: (id: string, data: SaveActionModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/${id}/add-action`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name CreateRestEntity
     * @request POST:/api/generic-rest/{id}/add-entity
     */
    createRestEntity: (id: string, data: SaveEntityModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/${id}/add-entity`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name CreateRestLookup
     * @request POST:/api/generic-rest/{id}/add-lookup
     */
    createRestLookup: (id: string, data: SaveLookupModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/${id}/add-lookup`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name CreateRestWebhook
     * @request POST:/api/generic-rest/{id}/add-webhook
     */
    createRestWebhook: (id: string, data: SaveWebhookModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/${id}/add-webhook`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name DuplicateRestAction
     * @request POST:/api/generic-rest/duplicate-action
     */
    duplicateRestAction: (data: SaveActionModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/duplicate-action`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name DuplicateRestEntity
     * @request POST:/api/generic-rest/duplicate-entity
     */
    duplicateRestEntity: (data: SaveEntityModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/duplicate-entity`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name DuplicateRestLookup
     * @request POST:/api/generic-rest/duplicate-lookup
     */
    duplicateRestLookup: (data: SaveLookupModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/duplicate-lookup`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name DuplicateRestWebhook
     * @request POST:/api/generic-rest/duplicate-webhook
     */
    duplicateRestWebhook: (data: SaveWebhookModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/duplicate-webhook`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name SaveRestLookup
     * @request PATCH:/api/generic-rest/lookup
     */
    saveRestLookup: (data: GenericRestLookupModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/lookup`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name SaveWebhook
     * @request PATCH:/api/generic-rest/webhook
     */
    saveWebhook: (data: GenericRestWebhookModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/webhook`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name SaveAction
     * @request PATCH:/api/generic-rest/action
     */
    saveAction: (data: GenericRestActionModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/action`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name SaveEntity
     * @request PATCH:/api/generic-rest/entity
     */
    saveEntity: (data: GenericRestEntityModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/entity`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name SaveDefinition
     * @request PATCH:/api/generic-rest/definition
     */
    saveDefinition: (data: GenericRestSetupModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/definition`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name CheckChildUsage
     * @summary SC-1513: asked by the setup editor before it removes an entity or lookup row, so the user is warned at that point rather than after a save that would be rejected wholesale.
     * @request GET:/api/generic-rest/child-usage
     */
    checkChildUsage: (
      query?: {
        /** @format uuid */
        entityId?: string;
        /** @format uuid */
        lookupId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GenericRestChildUsageResponseBaseResponse, any>({
        path: `/api/generic-rest/child-usage`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name ValidateStructure
     * @request POST:/api/generic-rest/validate-structure/{actionId}
     */
    validateStructure: (
      actionId: string,
      data: RestActionValidateStructureRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/validate-structure/${actionId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name GetConnectorInstances
     * @request GET:/api/generic-rest/{setupId}/connector-instances
     */
    getConnectorInstances: (setupId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest/${setupId}/connector-instances`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name LoadFields
     * @request POST:/api/generic-rest/entity/load-fields
     */
    loadFields: (data: LoadRestFieldsRequest, params: RequestParams = {}) =>
      this.request<RestFieldDefinitionListBaseResponse, any>({
        path: `/api/generic-rest/entity/load-fields`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRest
     * @name LoadContent
     * @request POST:/api/generic-rest/load-content
     */
    loadContent: (data: LoadRestContentRequest, params: RequestParams = {}) =>
      this.request<LoadRestContentResponseBaseResponse, any>({
        path: `/api/generic-rest/load-content`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  genericRestDestination = {
    /**
     * No description
     *
     * @tags GenericRestDestination
     * @name GetMapLines
     * @request POST:/api/generic-rest-destination/get-destination-lines
     */
    getMapLines: (data: GenericRestDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/generic-rest-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRestDestination
     * @name GetMapLineParameters
     * @request POST:/api/generic-rest-destination/get-destination-line-parameters/{technicalName}
     */
    getMapLineParameters: (
      technicalName: string,
      data: GenericRestDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/generic-rest-destination/get-destination-line-parameters/${technicalName}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRestDestination
     * @name GetDestinationDetails
     * @request POST:/api/generic-rest-destination/destination-details/{setupId}
     */
    getDestinationDetails: (setupId: string, params: RequestParams = {}) =>
      this.request<GenericRestDetailsModelBaseResponse, any>({
        path: `/api/generic-rest-destination/destination-details/${setupId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRestDestination
     * @name GetRestLookupProviders
     * @request POST:/api/generic-rest-destination/lookup-providers
     */
    getRestLookupProviders: (params: RequestParams = {}) =>
      this.request<GuidStringDictionaryBaseResponse, any>({
        path: `/api/generic-rest-destination/lookup-providers`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRestDestination
     * @name GetLookupOptionsByProvider
     * @request POST:/api/generic-rest-destination/lookup-options-by-provider/{providerId}
     */
    getLookupOptionsByProvider: (providerId: string, params: RequestParams = {}) =>
      this.request<GenericRestLookupOptionsModelBaseResponse, any>({
        path: `/api/generic-rest-destination/lookup-options-by-provider/${providerId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRestDestination
     * @name GetLookupDetails
     * @request POST:/api/generic-rest-destination/lookup-details/{lookupId}
     */
    getLookupDetails: (lookupId: string, params: RequestParams = {}) =>
      this.request<GenericRestLookupDetailsModelBaseResponse, any>({
        path: `/api/generic-rest-destination/lookup-details/${lookupId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  genericRestWebhook = {
    /**
     * No description
     *
     * @tags GenericRestWebhookDataSource
     * @name Save
     * @request POST:/api/generic-rest-webhook/save
     */
    save: (data: GenericRestWebhookDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-webhook/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRestWebhookDataSource
     * @name Validate
     * @request POST:/api/generic-rest-webhook/validate
     */
    validate: (data: GenericRestWebhookDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-webhook/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRestWebhookDataSource
     * @name RegisterDataSource
     * @request POST:/api/generic-rest-webhook/register-datasource
     */
    registerDataSource: (data: GenericRestWebhookDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-webhook/register-datasource`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRestWebhookDataSource
     * @name GetLinkedMaps
     * @request GET:/api/generic-rest-webhook/get-linked-maps/{id}
     */
    getLinkedMaps: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-webhook/get-linked-maps/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericRestWebhookDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/generic-rest-webhook/schema-columns/reload
     */
    reloadSchemaColumns: (data: GenericRestWebhookDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-webhook/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  globalVariable = {
    /**
     * No description
     *
     * @tags GlobalVariable
     * @name Get
     * @request GET:/api/global-variable/for-map
     */
    get: (params: RequestParams = {}) =>
      this.request<GlobalVariableDtoListBaseResponse, any>({
        path: `/api/global-variable/for-map`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalVariable
     * @name GetVariable
     * @request GET:/api/global-variable/{id}
     */
    getVariable: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/global-variable/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalVariable
     * @name Delete
     * @request DELETE:/api/global-variable/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/global-variable/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalVariable
     * @name GetForMapTask
     * @request GET:/api/global-variable/for-map-task
     */
    getForMapTask: (params: RequestParams = {}) =>
      this.request<GlobalVariableDtoListBaseResponse, any>({
        path: `/api/global-variable/for-map-task`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalVariable
     * @name GetListForAdditionalColumns
     * @request POST:/api/global-variable/for-additional-columns
     */
    getListForAdditionalColumns: (params: RequestParams = {}) =>
      this.request<StringListBaseResponse, any>({
        path: `/api/global-variable/for-additional-columns`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalVariable
     * @name Create
     * @request POST:/api/global-variable
     */
    create: (data: GlobalVariable, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/global-variable`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalVariable
     * @name Update
     * @request PATCH:/api/global-variable
     */
    update: (data: GlobalVariable, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/global-variable`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalVariable
     * @name CheckName
     * @request POST:/api/global-variable/check-name
     */
    checkName: (data: CheckNameRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/global-variable/check-name`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  googledrive = {
    /**
     * No description
     *
     * @tags GoogleDrive
     * @name ValidateConnection
     * @request POST:/api/googledrive/validate/{id}
     */
    validateConnection: (id: string, data: GoogleDriveInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/googledrive/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleDrive
     * @name SaveConnection
     * @request POST:/api/googledrive/save/{id}
     */
    saveConnection: (id: string, data: GoogleDriveInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/googledrive/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleDrive
     * @name AuthCallback
     * @request GET:/api/googledrive/authCallback
     */
    authCallback: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/googledrive/authCallback`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  gpQuery = {
    /**
     * No description
     *
     * @tags GpQueryDataSource
     * @name Save
     * @request POST:/api/gp-query/save
     */
    save: (data: GpQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/gp-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GpQueryDataSource
     * @name Validate
     * @request POST:/api/gp-query/validate
     */
    validate: (data: GpQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/gp-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GpQueryDataSource
     * @name GetPreview
     * @request POST:/api/gp-query/preview
     */
    getPreview: (data: GpQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/gp-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GpQueryDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/gp-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: GpQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/gp-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GpQueryDataSource
     * @name CacheDataSource
     * @request POST:/api/gp-query/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: GpQueryDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/gp-query/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  graph = {
    /**
     * No description
     *
     * @tags Graph
     * @name ValidateConnection
     * @request POST:/api/graph/validate/{id}
     */
    validateConnection: (id: string, data: MsGraphInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/graph/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Graph
     * @name SaveConnection
     * @request POST:/api/graph/save/{id}
     */
    saveConnection: (id: string, data: MsGraphInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/graph/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Graph
     * @name AuthCallback
     * @request GET:/api/graph/authCallback
     */
    authCallback: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/graph/authCallback`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  help = {
    /**
     * No description
     *
     * @tags Help
     * @name SendEmail
     * @request POST:/api/help/sendemail
     */
    sendEmail: (data: EmailModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/help/sendemail`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  getWebForms = {
    /**
     * No description
     *
     * @tags Home
     * @name GetWebForm
     * @request GET:/home/get-web-forms
     */
    getWebForm: (params: RequestParams = {}) =>
      this.request<DbUserWebFormOption[], any>({
        path: `/home/get-web-forms`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  getWebFormDetails = {
    /**
     * No description
     *
     * @tags Home
     * @name GetWebFormDetails
     * @request GET:/home/get-web-form-details/{formId}
     */
    getWebFormDetails: (formId: string, params: RequestParams = {}) =>
      this.request<DbUserWebFormOptionDetail[], any>({
        path: `/home/get-web-form-details/${formId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  getUser = {
    /**
     * No description
     *
     * @tags Home
     * @name GetUser
     * @request GET:/home/get-user
     */
    getUser: (params: RequestParams = {}) =>
      this.request<SessionUserModel, any>({
        path: `/home/get-user`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  saveDetails = {
    /**
     * No description
     *
     * @tags Home
     * @name SaveDetails
     * @request POST:/home/save-details/{formId}
     */
    saveDetails: (formId: string, data: UserWebFormOptionModel[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/home/save-details/${formId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  save = {
    /**
     * No description
     *
     * @tags Home
     * @name Save
     * @request POST:/home/save
     */
    save: (data: UserWebFormOptionModel[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/home/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ScriptNamespaces
     * @name Save2
     * @request POST:/script-namespaces/save
     * @originalName save
     * @duplicate
     */
    save2: (data: ScriptNamespacesModel[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/script-namespaces/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  getNews = {
    /**
     * No description
     *
     * @tags Home
     * @name GetNews
     * @request GET:/home/get-news
     */
    getNews: (
      query?: {
        /**
         * @format int32
         * @default 5
         */
        count?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DashboardNewsModel[], any>({
        path: `/home/get-news`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  getLogins = {
    /**
     * No description
     *
     * @tags Home
     * @name GetLogins
     * @request GET:/home/get-logins
     */
    getLogins: (params: RequestParams = {}) =>
      this.request<DashboardLoginModel[], any>({
        path: `/home/get-logins`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  getMapRuns = {
    /**
     * No description
     *
     * @tags Home
     * @name GetMapRuns
     * @request GET:/home/get-map-runs
     */
    getMapRuns: (params: RequestParams = {}) =>
      this.request<DbMap[], any>({
        path: `/home/get-map-runs`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  logout = {
    /**
     * No description
     *
     * @tags Home
     * @name LogOut
     * @request GET:/home/logout
     */
    logOut: (params: RequestParams = {}) =>
      this.request<StringBaseResponse, any>({
        path: `/home/logout`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  version = {
    /**
     * No description
     *
     * @tags Home
     * @name GetVersion
     * @request GET:/home/version
     */
    getVersion: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/home/version`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  token = {
    /**
     * No description
     *
     * @tags Home
     * @name GetToken
     * @request POST:/home/token
     */
    getToken: (params: RequestParams = {}) =>
      this.request<TokenResponseBaseResponse, any>({
        path: `/home/token`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  apiSettings = {
    /**
     * No description
     *
     * @tags Home
     * @name GetApiSettings
     * @request GET:/home/api-settings
     */
    getApiSettings: (params: RequestParams = {}) =>
      this.request<ApiSettingsBaseResponse, any>({
        path: `/home/api-settings`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  image = {
    /**
     * No description
     *
     * @tags Image
     * @name Get
     * @request GET:/api/image/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/image/${id}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Image
     * @name Delete
     * @request DELETE:/api/image/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/image/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Image
     * @name Upload
     * @request POST:/api/image
     */
    upload: (
      data: {
        /** @format binary */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/image`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),
  };
  integrationGroup = {
    /**
     * No description
     *
     * @tags IntegrationGroup
     * @name GetList
     * @request GET:/api/integration-group/list
     */
    getList: (params: RequestParams = {}) =>
      this.request<IntegrationGroupModelListBaseResponse, any>({
        path: `/api/integration-group/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags IntegrationGroup
     * @name GetIntegrationGroup
     * @request GET:/api/integration-group/{id}
     */
    getIntegrationGroup: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/integration-group/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags IntegrationGroup
     * @name Delete
     * @request DELETE:/api/integration-group/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/integration-group/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags IntegrationGroup
     * @name Create
     * @request POST:/api/integration-group
     */
    create: (data: IntegrationGroupModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/integration-group`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags IntegrationGroup
     * @name Save
     * @request PATCH:/api/integration-group
     */
    save: (data: IntegrationGroupModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/integration-group`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags IntegrationGroup
     * @name CheckName
     * @request POST:/api/integration-group/check-name
     */
    checkName: (data: CheckNameRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/integration-group/check-name`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  jsonFileDataSource = {
    /**
     * No description
     *
     * @tags JsonFile
     * @name ReloadSchemaColumns
     * @request POST:/api/json-file-data-source/schema-columns/reload
     */
    reloadSchemaColumns: (data: JsonDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/json-file-data-source/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFile
     * @name LoadJsonFile
     * @request POST:/api/json-file-data-source/load-file/{fileName}
     */
    loadJsonFile: (fileName: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/json-file-data-source/load-file/${fileName}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFile
     * @name Validate
     * @request POST:/api/json-file-data-source/validate
     */
    validate: (data: JsonDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/json-file-data-source/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFile
     * @name Save
     * @request POST:/api/json-file-data-source/save
     */
    save: (data: JsonDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/json-file-data-source/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFile
     * @name GetPreview
     * @request POST:/api/json-file-data-source/preview
     */
    getPreview: (data: JsonDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/json-file-data-source/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  jsonFileDestination = {
    /**
     * No description
     *
     * @tags JsonFileDestination
     * @name GetJsonFormatFromString
     * @request POST:/api/json-file-destination/parse-json
     */
    getJsonFormatFromString: (data: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/json-file-destination/parse-json`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFileDestination
     * @name ValidateJsonTemplate
     * @request POST:/api/json-file-destination/validate-template
     */
    validateJsonTemplate: (data: JsonValidateTemplateRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/json-file-destination/validate-template`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFileDestination
     * @name GetJsonFormatFromFiles
     * @request POST:/api/json-file-destination/parse-files
     */
    getJsonFormatFromFiles: (
      data: {
        files?: File[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/json-file-destination/parse-files`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFileDestination
     * @name GetJsonFormatFromFilesAsNodes
     * @request POST:/api/json-file-destination/parse-files-nodes
     */
    getJsonFormatFromFilesAsNodes: (
      data: {
        files?: File[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/json-file-destination/parse-files-nodes`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFileDestination
     * @name GetFieldTypes
     * @request GET:/api/json-file-destination/field-types
     */
    getFieldTypes: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/json-file-destination/field-types`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFileDestination
     * @name GetDestinations
     * @request GET:/api/json-file-destination/list
     */
    getDestinations: (params: RequestParams = {}) =>
      this.request<MssqlInstanceModelListBaseResponse, any>({
        path: `/api/json-file-destination/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFileDestination
     * @name GetDestinationData
     * @request POST:/api/json-file-destination/get-destination-data
     */
    getDestinationData: (data: JsonFileDestinationModel, params: RequestParams = {}) =>
      this.request<SqlObjectListBaseResponse, any>({
        path: `/api/json-file-destination/get-destination-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFileDestination
     * @name GetDestinationLines
     * @request POST:/api/json-file-destination/get-destination-lines
     */
    getDestinationLines: (data: JsonFileDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/json-file-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFileDestination
     * @name GetMapLineParameters
     * @request POST:/api/json-file-destination/get-destination-line-parameters/{mapLineTechnicalName}/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalName: string,
      mapLineTechnicalValue: string,
      data: JsonFileDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/json-file-destination/get-destination-line-parameters/${mapLineTechnicalName}/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  jsonFolder = {
    /**
     * No description
     *
     * @tags JsonFolder
     * @name ReloadSchemaColumns
     * @request POST:/api/json-folder/schema-columns/reload
     */
    reloadSchemaColumns: (data: JsonFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/json-folder/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFolder
     * @name LoadJsonFile
     * @request POST:/api/json-folder/load-file/{fileName}
     */
    loadJsonFile: (fileName: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/json-folder/load-file/${fileName}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFolder
     * @name Validate
     * @request POST:/api/json-folder/validate
     */
    validate: (data: JsonFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/json-folder/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFolder
     * @name Save
     * @request POST:/api/json-folder/save
     */
    save: (data: JsonFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/json-folder/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags JsonFolder
     * @name GetPreview
     * @request POST:/api/json-folder/preview
     */
    getPreview: (data: JsonFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/json-folder/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  logStore = {
    /**
     * No description
     *
     * @tags LogStore
     * @name GetLatestDataSourceLogs
     * @request GET:/api/log-store/latest-run/{dataSourceId}
     */
    getLatestDataSourceLogs: (dataSourceId: string, params: RequestParams = {}) =>
      this.request<LogStoreLatestRunModelBaseResponse, any>({
        path: `/api/log-store/latest-run/${dataSourceId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LogStore
     * @name GetAllLogSummaries
     * @request GET:/api/log-store/summaries
     */
    getAllLogSummaries: (params: RequestParams = {}) =>
      this.request<LogStoreSummaryModelListBaseResponse, any>({
        path: `/api/log-store/summaries`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LogStore
     * @name GetLogRecordsByLogNumber
     * @request GET:/api/log-store/records/{logNumber}
     */
    getLogRecordsByLogNumber: (logNumber: number, params: RequestParams = {}) =>
      this.request<LogStoreRecordModelListBaseResponse, any>({
        path: `/api/log-store/records/${logNumber}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LogStore
     * @name DeleteLogByLogNumber
     * @request DELETE:/api/log-store/{logNumber}
     */
    deleteLogByLogNumber: (logNumber: number, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/log-store/${logNumber}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  maintenance = {
    /**
     * No description
     *
     * @tags Maintenance
     * @name GetChangeTriggerMaintenanceAndCachedItems
     * @request GET:/api/maintenance
     */
    getChangeTriggerMaintenanceAndCachedItems: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/maintenance`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name GetChangeTrigger
     * @request GET:/api/maintenance/change-trigger/{id}
     */
    getChangeTrigger: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/maintenance/change-trigger/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name DeleteChangeDataSource
     * @request DELETE:/api/maintenance/change-trigger/{id}
     */
    deleteChangeDataSource: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/maintenance/change-trigger/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name SaveChangeDataSource
     * @request PATCH:/api/maintenance/change-trigger/save
     */
    saveChangeDataSource: (data: ChangeDataSourceMaintenanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/maintenance/change-trigger/save`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name CreateChangeDataSourceStub
     * @request POST:/api/maintenance/create-stub
     */
    createChangeDataSourceStub: (
      data: ChangeDataSourceMaintenanceStubRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/maintenance/create-stub`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  msgp = {
    /**
     * No description
     *
     * @tags MsGp
     * @name ValidateConnection
     * @request POST:/api/msgp/validate/{id}
     */
    validateConnection: (id: string, data: GpInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/msgp/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsGp
     * @name SaveConnection
     * @request POST:/api/msgp/save/{id}
     */
    saveConnection: (id: string, data: GpInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/msgp/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsGp
     * @name GetCompanies
     * @request POST:/api/msgp/get-external-settings/{id}
     */
    getCompanies: (id: string, data: GpInstanceModel, params: RequestParams = {}) =>
      this.request<GenericListItemListBaseResponse, any>({
        path: `/api/msgp/get-external-settings/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsGp
     * @name GetCompaniesFromId
     * @request GET:/api/msgp/get-companies/{id}
     */
    getCompaniesFromId: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/msgp/get-companies/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  navOdata = {
    /**
     * No description
     *
     * @tags MsNavOdata
     * @name ValidateConnection
     * @request POST:/api/nav-odata/validate/{id}
     */
    validateConnection: (id: string, data: MsNavOdataInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name SaveConnection
     * @request POST:/api/nav-odata/save/{id}
     */
    saveConnection: (id: string, data: MsNavOdataInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name AuthCallback
     * @request GET:/api/nav-odata/authCallback
     */
    authCallback: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/authCallback`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetCompaniesAndApiRoutes
     * @request POST:/api/nav-odata/get-external-settings/{id}
     */
    getCompaniesAndApiRoutes: (
      id: string,
      data: MsNavOdataInstanceModel,
      params: RequestParams = {},
    ) =>
      this.request<MsNavOdataGetCompaniesAndRoutesBaseResponse, any>({
        path: `/api/nav-odata/get-external-settings/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetCompanies
     * @request GET:/api/nav-odata/get-companies/{id}
     */
    getCompanies: (id: string, params: RequestParams = {}) =>
      this.request<GenericListItemListBaseResponse, any>({
        path: `/api/nav-odata/get-companies/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetApiRoutes
     * @summary Get the api routes for a the company
     * @request POST:/api/nav-odata/get-routes/{id}
     */
    getApiRoutes: (id: string, data: MsNavOdataInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/get-routes/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetApiRoutesFromInstance
     * @request GET:/api/nav-odata/get-routes-from-instance/{id}
     */
    getApiRoutesFromInstance: (id: string, params: RequestParams = {}) =>
      this.request<MsNavOdataApiRouteModelListBaseResponse, any>({
        path: `/api/nav-odata/get-routes-from-instance/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetDestinationServiceList
     * @request GET:/api/nav-odata/get-destination-service-list/{id}/{route}
     */
    getDestinationServiceList: (id: string, route: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/get-destination-service-list/${id}/${route}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetDataSourceServiceList
     * @request GET:/api/nav-odata/get-data-source-service-list/{id}/{route}
     */
    getDataSourceServiceList: (id: string, route: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/get-data-source-service-list/${id}/${route}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetLookupServiceList
     * @request GET:/api/nav-odata/get-lookup-service-list/{id}/{route}
     */
    getLookupServiceList: (id: string, route: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/get-lookup-service-list/${id}/${route}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetActionList
     * @request GET:/api/nav-odata/get-action-list/{id}/{apiRoute}
     */
    getActionList: (id: string, apiRoute: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/get-action-list/${id}/${apiRoute}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetEntityFieldsByType
     * @request GET:/api/nav-odata/get-entity-fields-by-type/{instanceId}/{apiRoute}/{entityType}
     */
    getEntityFieldsByType: (
      instanceId: string,
      apiRoute: string,
      entityType: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/get-entity-fields-by-type/${instanceId}/${apiRoute}/${entityType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetEntityFieldsByName
     * @request GET:/api/nav-odata/get-entity-fields-by-name/{instanceId}/{apiRoute}/{entityName}
     */
    getEntityFieldsByName: (
      instanceId: string,
      apiRoute: string,
      entityName: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/get-entity-fields-by-name/${instanceId}/${apiRoute}/${entityName}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetGenericEntityList
     * @request GET:/api/nav-odata/get-generic-entity-list/{id}/{apiRouteId}
     */
    getGenericEntityList: (id: string, apiRouteId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/get-generic-entity-list/${id}/${apiRouteId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetGenericEntityListNoChild
     * @request GET:/api/nav-odata/get-generic-entity-list-no-child/{id}/{apiRouteId}
     */
    getGenericEntityListNoChild: (id: string, apiRouteId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/get-generic-entity-list-no-child/${id}/${apiRouteId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetGenericEntityFieldList
     * @request GET:/api/nav-odata/get-generic-entity-field-list/{id}/{apiRouteId}/{entityType}
     */
    getGenericEntityFieldList: (
      id: string,
      apiRouteId: string,
      entityType: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/get-generic-entity-field-list/${id}/${apiRouteId}/${entityType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetCompanyServices
     * @request GET:/api/nav-odata/get-services/{id}
     */
    getCompanyServices: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/get-services/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name RefreshServiceList
     * @request PATCH:/api/nav-odata/refresh-service-list/{id}
     */
    refreshServiceList: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/refresh-service-list/${id}`,
        method: 'PATCH',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetChildEntityDetails
     * @request GET:/api/nav-odata/get-child-entity-details/{instanceId}/{apiId}/{headerType}/{headerJson}/{headerId}/{entityType}
     */
    getChildEntityDetails: (
      instanceId: string,
      apiId: string,
      headerType: string,
      headerJson: string,
      headerId: string,
      entityType: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/get-child-entity-details/${instanceId}/${apiId}/${headerType}/${headerJson}/${headerId}/${entityType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdata
     * @name GetEntityDetails
     * @request GET:/api/nav-odata/get-entity-details/{id}/{apiId}/{entityType}
     */
    getEntityDetails: (id: string, apiId: string, entityType: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/nav-odata/get-entity-details/${id}/${apiId}/${entityType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  navodataApiDestination = {
    /**
     * No description
     *
     * @tags MsNavOdataApiDestination
     * @name GetActions
     * @request GET:/api/navodata-api-destination/get-actions/{connectorInstanceId}/{routeId}
     */
    getActions: (connectorInstanceId: string, routeId: string, params: RequestParams = {}) =>
      this.request<MsNavOdataActionListBaseResponse, any>({
        path: `/api/navodata-api-destination/get-actions/${connectorInstanceId}/${routeId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdataApiDestination
     * @name GetActionDetails
     * @request GET:/api/navodata-api-destination/get-action-details/{id}/{apiId}/{entityType}
     */
    getActionDetails: (id: string, apiId: string, entityType: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-api-destination/get-action-details/${id}/${apiId}/${entityType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdataApiDestination
     * @name ValidateApiServices
     * @request POST:/api/navodata-api-destination/service/validate
     */
    validateApiServices: (data: NavOdataApiServiceValidateRequest, params: RequestParams = {}) =>
      this.request<NavOdataApiServiceValidateResponseBaseResponse, any>({
        path: `/api/navodata-api-destination/service/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdataApiDestination
     * @name GetMapLines
     * @request POST:/api/navodata-api-destination/get-destination-lines
     */
    getMapLines: (data: MsNavOdataApiDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/navodata-api-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdataApiDestination
     * @name GetMapLineParameters
     * @request POST:/api/navodata-api-destination/get-destination-line-parameters/{mapLineTechnicalName}/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalName: string,
      mapLineTechnicalValue: string,
      data: MsNavOdataApiDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/navodata-api-destination/get-destination-line-parameters/${mapLineTechnicalName}/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  navodataApiQuery = {
    /**
     * No description
     *
     * @tags MsNavOdataApiQuery
     * @name GetApiRoutes
     * @request GET:/api/navodata-api-query/get-api-routes/{instanceId}
     */
    getApiRoutes: (instanceId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-api-query/get-api-routes/${instanceId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdataApiQuery
     * @name Save
     * @request POST:/api/navodata-api-query/save
     */
    save: (data: MsNavOdataApiDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-api-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdataApiQuery
     * @name Validate
     * @request POST:/api/navodata-api-query/validate
     */
    validate: (data: MsNavOdataApiDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-api-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdataApiQuery
     * @name GetPreview
     * @request POST:/api/navodata-api-query/preview
     */
    getPreview: (data: MsNavOdataApiDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-api-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdataApiQuery
     * @name ReloadSchemaColumns
     * @request POST:/api/navodata-api-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: MsNavOdataApiDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-api-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  navodataDestination = {
    /**
     * No description
     *
     * @tags MsNavOdataDestination
     * @name GetMapLines
     * @request POST:/api/navodata-destination/get-destination-lines
     */
    getMapLines: (data: MsNavOdataDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/navodata-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsNavOdataDestination
     * @name GetMapLineParameters
     * @request POST:/api/navodata-destination/get-destination-line-parameters/{mapLineTechnicalName}/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalName: string,
      mapLineTechnicalValue: string,
      data: MsNavOdataDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/navodata-destination/get-destination-line-parameters/${mapLineTechnicalName}/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  mssql = {
    /**
     * No description
     *
     * @tags Mssql
     * @name ValidateConnection
     * @request POST:/api/mssql/validate/{id}
     */
    validateConnection: (id: string, data: MssqlInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mssql
     * @name SaveConnection
     * @request POST:/api/mssql/save/{id}
     */
    saveConnection: (id: string, data: MssqlInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mssql
     * @name GetDatabases
     * @request POST:/api/mssql/get-external-settings/{id}
     */
    getDatabases: (id: string, data: MssqlInstanceModel, params: RequestParams = {}) =>
      this.request<MssqlDatabaseListResponseBaseResponse, any>({
        path: `/api/mssql/get-external-settings/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mssql
     * @name GetDatabases2
     * @request GET:/api/mssql/get-databases/{id}
     * @originalName getDatabases
     * @duplicate
     */
    getDatabases2: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql/get-databases/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mssql
     * @name GetTables
     * @request GET:/api/mssql/get-tables/{id}/{database}
     */
    getTables: (id: string, database: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql/get-tables/${id}/${database}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mssql
     * @name GetTableColumns
     * @request GET:/api/mssql/get-table-columns/{id}/{database}/{table}
     */
    getTableColumns: (id: string, database: string, table: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql/get-table-columns/${id}/${database}/${table}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mssql
     * @name GetTableColumnsWithTypes
     * @request GET:/api/mssql/get-table-columns-with-types/{id}/{database}/{table}
     */
    getTableColumnsWithTypes: (
      id: string,
      database: string,
      table: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql/get-table-columns-with-types/${id}/${database}/${table}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mssql
     * @name GetLookupPreview
     * @summary Runs an MSSQL additional-column lookup as the editor has it configured, for the column's Test button.
     * @request POST:/api/mssql/lookup/preview
     */
    getLookupPreview: (data: MssqlLookupPreviewModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql/lookup/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  mssqlChange = {
    /**
     * No description
     *
     * @tags MssqlChangeDataSource
     * @name Validate
     * @request POST:/api/mssql-change/validate
     */
    validate: (data: MssqlChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql-change/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlChangeDataSource
     * @name Save
     * @request POST:/api/mssql-change/save
     */
    save: (data: MssqlChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql-change/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlChangeDataSource
     * @name GetPreview
     * @request POST:/api/mssql-change/preview
     */
    getPreview: (data: MssqlChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/mssql-change/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlChangeDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/mssql-change/schema-columns/reload
     */
    reloadSchemaColumns: (data: MssqlChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql-change/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlChangeDataSource
     * @name CacheDataSource
     * @request POST:/api/mssql-change/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: MssqlChangeDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql-change/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  mssqlDestination = {
    /**
     * No description
     *
     * @tags MssqlDestination
     * @name GetDestinations
     * @request GET:/api/mssql-destination/list
     */
    getDestinations: (params: RequestParams = {}) =>
      this.request<MssqlInstanceModelListBaseResponse, any>({
        path: `/api/mssql-destination/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlDestination
     * @name GetMssqlTableDestinationData
     * @request POST:/api/mssql-destination/destination-data-table
     */
    getMssqlTableDestinationData: (data: MssqlTableDestinationModel, params: RequestParams = {}) =>
      this.request<SqlObjectListBaseResponse, any>({
        path: `/api/mssql-destination/destination-data-table`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlDestination
     * @name GetMssqlStoredProcDestinationData
     * @request POST:/api/mssql-destination/get-stored-proc-data
     */
    getMssqlStoredProcDestinationData: (
      data: MssqlStoredProcDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<SqlObjectListBaseResponse, any>({
        path: `/api/mssql-destination/get-stored-proc-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlDestination
     * @name GetMssqlStoredProcDestinationLines
     * @request POST:/api/mssql-destination/get-stored-proc-lines
     */
    getMssqlStoredProcDestinationLines: (
      data: MssqlStoredProcDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/mssql-destination/get-stored-proc-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlDestination
     * @name GetDestinationLines
     * @request POST:/api/mssql-destination/get-destination-lines
     */
    getDestinationLines: (data: MssqlDestinationModelBase, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/mssql-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlDestination
     * @name GetMapLineParameters
     * @request POST:/api/mssql-destination/get-destination-line-parameters/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalValue: string,
      data: MssqlDestinationModelBase,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/mssql-destination/get-destination-line-parameters/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  mssqlQuery = {
    /**
     * No description
     *
     * @tags MssqlQuerySource
     * @name Validate
     * @request POST:/api/mssql-query/validate
     */
    validate: (data: MssqlQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlQuerySource
     * @name Save
     * @request POST:/api/mssql-query/save
     */
    save: (data: MssqlQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlQuerySource
     * @name GetPreview
     * @request POST:/api/mssql-query/preview
     */
    getPreview: (data: MssqlQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/mssql-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlQuerySource
     * @name ReloadSchemaColumns
     * @request POST:/api/mssql-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: MssqlQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlQuerySource
     * @name CacheDataSource
     * @request POST:/api/mssql-query/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: MssqlQueryDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql-query/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  mssqlSpDestination = {
    /**
     * No description
     *
     * @tags MssqlStoredProcDestination
     * @name GetDestinations
     * @request GET:/api/mssql-sp-destination/list
     */
    getDestinations: (params: RequestParams = {}) =>
      this.request<MssqlInstanceModelListBaseResponse, any>({
        path: `/api/mssql-sp-destination/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlStoredProcDestination
     * @name GetDestinationData
     * @request POST:/api/mssql-sp-destination/get-destination-data
     */
    getDestinationData: (data: MssqlStoredProcDestinationModel, params: RequestParams = {}) =>
      this.request<SqlObjectListBaseResponse, any>({
        path: `/api/mssql-sp-destination/get-destination-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlStoredProcDestination
     * @name GetDestinationLines
     * @request POST:/api/mssql-sp-destination/get-destination-lines
     */
    getDestinationLines: (data: MssqlStoredProcDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/mssql-sp-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlStoredProcDestination
     * @name GetMapLineParameters
     * @request POST:/api/mssql-sp-destination/get-destination-line-parameters/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalValue: string,
      data: MssqlStoredProcDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/mssql-sp-destination/get-destination-line-parameters/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  mssqlTableDestination = {
    /**
     * No description
     *
     * @tags MssqlTableDestination
     * @name GetDestinations
     * @request GET:/api/mssql-table-destination/list
     */
    getDestinations: (params: RequestParams = {}) =>
      this.request<MssqlInstanceModelListBaseResponse, any>({
        path: `/api/mssql-table-destination/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlTableDestination
     * @name GetDestinationData
     * @request POST:/api/mssql-table-destination/get-destination-data
     */
    getDestinationData: (data: MssqlTableDestinationModel, params: RequestParams = {}) =>
      this.request<SqlObjectListBaseResponse, any>({
        path: `/api/mssql-table-destination/get-destination-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlTableDestination
     * @name GetDestinationLines
     * @request POST:/api/mssql-table-destination/get-destination-lines
     */
    getDestinationLines: (data: MssqlTableDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/mssql-table-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MssqlTableDestination
     * @name GetMapLineParameters
     * @request POST:/api/mssql-table-destination/get-destination-line-parameters/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalValue: string,
      data: MssqlTableDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/mssql-table-destination/get-destination-line-parameters/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  mssqlRealtime = {
    /**
     * No description
     *
     * @tags MsSqlTableRealTimeDataSource
     * @name Save
     * @request POST:/api/mssql-realtime/save
     */
    save: (data: MssqlRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql-realtime/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsSqlTableRealTimeDataSource
     * @name Validate
     * @request POST:/api/mssql-realtime/validate
     */
    validate: (data: MssqlRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql-realtime/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsSqlTableRealTimeDataSource
     * @name GetLinkedMaps
     * @request GET:/api/mssql-realtime/get-linked-maps/{id}
     */
    getLinkedMaps: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql-realtime/get-linked-maps/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsSqlTableRealTimeDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/mssql-realtime/schema-columns/reload
     */
    reloadSchemaColumns: (data: MssqlRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql-realtime/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsSqlTableRealTimeDataSource
     * @name CacheDataSource
     * @request POST:/api/mssql-realtime/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: MssqlRealTimeDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql-realtime/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MsSqlTableRealTimeDataSource
     * @name RegisterDataSource
     * @request POST:/api/mssql-realtime/register-datasource
     */
    registerDataSource: (data: MssqlRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mssql-realtime/register-datasource`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  mysql = {
    /**
     * No description
     *
     * @tags MySql
     * @name ValidateConnection
     * @request POST:/api/mysql/validate/{id}
     */
    validateConnection: (id: string, data: MySqlInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mysql/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySql
     * @name SaveConnection
     * @request POST:/api/mysql/save/{id}
     */
    saveConnection: (id: string, data: MySqlInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mysql/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySql
     * @name GetDatabases
     * @request POST:/api/mysql/get-external-settings/{id}
     */
    getDatabases: (id: string, data: MySqlInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mysql/get-external-settings/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySql
     * @name GetDatabases2
     * @request GET:/api/mysql/get-databases/{id}
     * @originalName getDatabases
     * @duplicate
     */
    getDatabases2: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mysql/get-databases/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySql
     * @name GetTables
     * @request GET:/api/mysql/get-tables/{id}/{database}
     */
    getTables: (id: string, database: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mysql/get-tables/${id}/${database}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySql
     * @name GetTableColumns
     * @request GET:/api/mysql/get-table-columns/{id}/{database}/{table}
     */
    getTableColumns: (id: string, database: string, table: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mysql/get-table-columns/${id}/${database}/${table}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  mysqlChange = {
    /**
     * No description
     *
     * @tags MySqlChangeDataSource
     * @name Validate
     * @request POST:/api/mysql-change/validate
     */
    validate: (data: MySqlChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mysql-change/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySqlChangeDataSource
     * @name Save
     * @request POST:/api/mysql-change/save
     */
    save: (data: MySqlChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mysql-change/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySqlChangeDataSource
     * @name GetPreview
     * @request POST:/api/mysql-change/preview
     */
    getPreview: (data: MySqlChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/mysql-change/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySqlChangeDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/mysql-change/schema-columns/reload
     */
    reloadSchemaColumns: (data: MySqlChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mysql-change/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySqlChangeDataSource
     * @name CacheDataSource
     * @request POST:/api/mysql-change/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: MySqlChangeDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/mysql-change/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  mysqlQuery = {
    /**
     * No description
     *
     * @tags MySqlQuerySource
     * @name Validate
     * @request POST:/api/mysql-query/validate
     */
    validate: (data: MySqlQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mysql-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySqlQuerySource
     * @name Save
     * @request POST:/api/mysql-query/save
     */
    save: (data: MySqlQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mysql-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySqlQuerySource
     * @name GetPreview
     * @request POST:/api/mysql-query/preview
     */
    getPreview: (data: MySqlQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/mysql-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySqlQuerySource
     * @name ReloadSchemaColumns
     * @request POST:/api/mysql-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: MySqlQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/mysql-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySqlQuerySource
     * @name CacheDataSource
     * @request POST:/api/mysql-query/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: MySqlQueryDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/mysql-query/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  mysqlSpDestination = {
    /**
     * No description
     *
     * @tags MySqlStoredProcDestination
     * @name GetDestinations
     * @request GET:/api/mysql-sp-destination/list
     */
    getDestinations: (params: RequestParams = {}) =>
      this.request<MySqlInstanceModelListBaseResponse, any>({
        path: `/api/mysql-sp-destination/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySqlStoredProcDestination
     * @name GetDestinationData
     * @request POST:/api/mysql-sp-destination/get-destination-data
     */
    getDestinationData: (data: MySqlStoredProcDestinationModel, params: RequestParams = {}) =>
      this.request<SqlObjectListBaseResponse, any>({
        path: `/api/mysql-sp-destination/get-destination-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySqlStoredProcDestination
     * @name GetDestinationLines
     * @request POST:/api/mysql-sp-destination/get-destination-lines
     */
    getDestinationLines: (data: MySqlStoredProcDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/mysql-sp-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySqlStoredProcDestination
     * @name GetMapLineParameters
     * @request POST:/api/mysql-sp-destination/get-destination-line-parameters/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalValue: string,
      data: MySqlStoredProcDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/mysql-sp-destination/get-destination-line-parameters/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  mysqlTableDestination = {
    /**
     * No description
     *
     * @tags MySqlTableDestination
     * @name GetDestinations
     * @request GET:/api/mysql-table-destination/list
     */
    getDestinations: (params: RequestParams = {}) =>
      this.request<MySqlInstanceModelListBaseResponse, any>({
        path: `/api/mysql-table-destination/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySqlTableDestination
     * @name GetDestinationData
     * @request POST:/api/mysql-table-destination/get-destination-data
     */
    getDestinationData: (data: MySqlTableDestinationModel, params: RequestParams = {}) =>
      this.request<SqlObjectListBaseResponse, any>({
        path: `/api/mysql-table-destination/get-destination-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySqlTableDestination
     * @name GetDestinationLines
     * @request POST:/api/mysql-table-destination/get-destination-lines
     */
    getDestinationLines: (data: MySqlTableDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/mysql-table-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MySqlTableDestination
     * @name GetMapLineParameters
     * @request POST:/api/mysql-table-destination/get-destination-line-parameters/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalValue: string,
      data: MySqlTableDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/mysql-table-destination/get-destination-line-parameters/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  navodataBulkQuery = {
    /**
     * No description
     *
     * @tags NavOdataBulkQuerySource
     * @name Save
     * @request POST:/api/navodata-bulk-query/save
     */
    save: (data: MsNavOdataBulkDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-bulk-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataBulkQuerySource
     * @name Validate
     * @request POST:/api/navodata-bulk-query/validate
     */
    validate: (data: MsNavOdataBulkDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-bulk-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataBulkQuerySource
     * @name GetPreview
     * @request POST:/api/navodata-bulk-query/preview
     */
    getPreview: (data: MsNavOdataBulkDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-bulk-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataBulkQuerySource
     * @name ReloadSchemaColumns
     * @request POST:/api/navodata-bulk-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: MsNavOdataBulkDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-bulk-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataBulkQuerySource
     * @name ExternalSettings
     * @request GET:/api/navodata-bulk-query/external-settings/{connectionId}
     */
    externalSettings: (connectionId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-bulk-query/external-settings/${connectionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataBulkQuerySource
     * @name CacheDataSource
     * @request POST:/api/navodata-bulk-query/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: MsNavOdataBulkDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-bulk-query/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  navodataChange = {
    /**
     * No description
     *
     * @tags NavOdataChangeDataSource
     * @name Save
     * @request POST:/api/navodata-change/save
     */
    save: (data: MsNavOdataChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-change/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataChangeDataSource
     * @name Validate
     * @request POST:/api/navodata-change/validate
     */
    validate: (data: MsNavOdataChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-change/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataChangeDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/navodata-change/schema-columns/reload
     */
    reloadSchemaColumns: (data: MsNavOdataChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-change/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataChangeDataSource
     * @name GetPreview
     * @request POST:/api/navodata-change/preview
     */
    getPreview: (data: MsNavOdataChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-change/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataChangeDataSource
     * @name GetTables
     * @request POST:/api/navodata-change/get-tables
     */
    getTables: (data: MsNavOdataChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-change/get-tables`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataChangeDataSource
     * @name GetTableFields
     * @request POST:/api/navodata-change/get-table-fields
     */
    getTableFields: (data: MsNavOdataChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-change/get-table-fields`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  navodataRealtime = {
    /**
     * No description
     *
     * @tags NavOdataRealTimeDataSource
     * @name Save
     * @request POST:/api/navodata-realtime/save
     */
    save: (data: MsNavOdataRealtimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-realtime/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataRealTimeDataSource
     * @name Validate
     * @request POST:/api/navodata-realtime/validate
     */
    validate: (data: MsNavOdataRealtimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-realtime/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataRealTimeDataSource
     * @name GetWebhookEntities
     * @request GET:/api/navodata-realtime/get-webhook-entities/{connectionId}/{apiRoute}
     */
    getWebhookEntities: (connectionId: string, apiRoute: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-realtime/get-webhook-entities/${connectionId}/${apiRoute}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataRealTimeDataSource
     * @name GetServiceFields
     * @request GET:/api/navodata-realtime/get-service-fields/{connectionId}/{apiRoute}/{entityName}/{entityDescription}/{isMainEntity}
     */
    getServiceFields: (
      connectionId: string,
      apiRoute: string,
      entityName: string,
      entityDescription: string,
      isMainEntity: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-realtime/get-service-fields/${connectionId}/${apiRoute}/${entityName}/${entityDescription}/${isMainEntity}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataRealTimeDataSource
     * @name GetLinkedServices
     * @request GET:/api/navodata-realtime/get-linked-services/{connectionId}/{apiRoute}/{entityName}/{isMainEntity}
     */
    getLinkedServices: (
      connectionId: string,
      apiRoute: string,
      entityName: string,
      isMainEntity: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-realtime/get-linked-services/${connectionId}/${apiRoute}/${entityName}/${isMainEntity}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataRealTimeDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/navodata-realtime/schema-columns/reload
     */
    reloadSchemaColumns: (data: MsNavOdataRealtimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-realtime/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NavOdataRealTimeDataSource
     * @name RegisterDataSource
     * @request POST:/api/navodata-realtime/register-datasource
     */
    registerDataSource: (data: MsNavOdataRealtimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/navodata-realtime/register-datasource`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  netsuiteRest = {
    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name ValidateConnection
     * @request POST:/api/netsuite-rest/validate/{id}
     */
    validateConnection: (id: string, data: NetSuiteInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name SaveConnection
     * @request POST:/api/netsuite-rest/save/{id}
     */
    saveConnection: (id: string, data: NetSuiteInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name AuthCallback
     * @request GET:/api/netsuite-rest/authCallback
     */
    authCallback: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/authCallback`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name GenerateOssoKeyPair
     * @request POST:/api/netsuite-rest/generate-osso-keypair/{id}
     */
    generateOssoKeyPair: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/generate-osso-keypair/${id}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name RemoveOssoCertificate
     * @request POST:/api/netsuite-rest/remove-osso-keypair/{id}
     */
    removeOssoCertificate: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/remove-osso-keypair/${id}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name RefreshRestMetadata
     * @request PATCH:/api/netsuite-rest/refresh-rest-metadata/{id}
     */
    refreshRestMetadata: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/refresh-rest-metadata/${id}`,
        method: 'PATCH',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name GetDestinationLines
     * @request POST:/api/netsuite-rest/destination/lines/{id}
     */
    getDestinationLines: (id: string, data: NetSuiteDestinationModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/destination/lines/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name GetDestinationLineParameters
     * @request POST:/api/netsuite-rest/destination/line-parameters/{id}
     */
    getDestinationLineParameters: (
      id: string,
      data: NetSuiteLineParameterRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/destination/line-parameters/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name GetChildActionLines
     * @request POST:/api/netsuite-rest/destination/child-action-lines/{id}
     */
    getChildActionLines: (
      id: string,
      data: NetSuiteChildActionRequest,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/destination/child-action-lines/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name GetRecordTypes
     * @request GET:/api/netsuite-rest/lookup/record-types/{id}
     */
    getRecordTypes: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/lookup/record-types/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name GetRecordFields
     * @request GET:/api/netsuite-rest/lookup/record-fields/{id}
     */
    getRecordFields: (
      id: string,
      query?: {
        recordType?: string;
        /** @default false */
        includeChildren?: boolean;
        /** @default false */
        expandJson?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/lookup/record-fields/${id}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name GetRecordFilterFields
     * @request GET:/api/netsuite-rest/lookup/record-filter-fields/{id}
     */
    getRecordFilterFields: (
      id: string,
      query?: {
        recordType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/lookup/record-filter-fields/${id}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name GetListOptionFields
     * @request GET:/api/netsuite-rest/lookup/list-option-fields/{id}
     */
    getListOptionFields: (
      id: string,
      query?: {
        recordType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/lookup/list-option-fields/${id}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name GetListOptions
     * @request GET:/api/netsuite-rest/lookup/list-options/{id}
     */
    getListOptions: (
      id: string,
      query?: {
        recordType?: string;
        field?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/lookup/list-options/${id}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name GetLookupPreview
     * @request POST:/api/netsuite-rest/lookup/preview
     */
    getLookupPreview: (data: NetSuiteRestLookupPreviewModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/lookup/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name GetSchemaHelper
     * @request GET:/api/netsuite-rest/schema-helper/{id}
     */
    getSchemaHelper: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/schema-helper/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRest
     * @name SaveMetadataFile
     * @request POST:/api/netsuite-rest/upload-meta/{id}
     */
    saveMetadataFile: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest/upload-meta/${id}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  netsuiteRestChange = {
    /**
     * No description
     *
     * @tags NetSuiteRestChangeDataSource
     * @name Save
     * @request POST:/api/netsuite-rest-change/save
     */
    save: (data: NetSuiteChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-change/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestChangeDataSource
     * @name Validate
     * @request POST:/api/netsuite-rest-change/validate
     */
    validate: (data: NetSuiteChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-change/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestChangeDataSource
     * @name GetPreview
     * @request POST:/api/netsuite-rest-change/preview
     */
    getPreview: (data: NetSuiteChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/netsuite-rest-change/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestChangeDataSource
     * @name GetRoleTypes
     * @request GET:/api/netsuite-rest-change/get-role-types/{connectionId}
     */
    getRoleTypes: (
      connectionId: string,
      query?: {
        /** @format uuid */
        dataSourceId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-change/get-role-types/${connectionId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestChangeDataSource
     * @name GetDateFields
     * @request GET:/api/netsuite-rest-change/get-date-fields/{connectionId}
     */
    getDateFields: (
      connectionId: string,
      query?: {
        roleType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-change/get-date-fields/${connectionId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestChangeDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/netsuite-rest-change/schema-columns/reload
     */
    reloadSchemaColumns: (data: NetSuiteChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-change/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  netsuiteRestQuery = {
    /**
     * No description
     *
     * @tags NetSuiteRestQueryDataSource
     * @name Save
     * @request POST:/api/netsuite-rest-query/save
     */
    save: (data: NetSuiteQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestQueryDataSource
     * @name Validate
     * @request POST:/api/netsuite-rest-query/validate
     */
    validate: (data: NetSuiteQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestQueryDataSource
     * @name GetPreview
     * @request POST:/api/netsuite-rest-query/preview
     */
    getPreview: (data: NetSuiteQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestQueryDataSource
     * @name ReloadSchemaColumns
     * @summary Builds the schema columns for the selected role type and column list. Called automatically after a successful validate so the Fields tab populates.
     * @request POST:/api/netsuite-rest-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: NetSuiteQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestQueryDataSource
     * @name GetSearchRecordTypes
     * @request GET:/api/netsuite-rest-query/get-search-record-types
     */
    getSearchRecordTypes: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-query/get-search-record-types`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestQueryDataSource
     * @name GetRoleTypes
     * @summary Returns the list of NetSuite record types available for the given connection, derived from the REST API metadata (OpenAPI document) already cached on the instance. Custom record and custom list types are enriched with their friendly names.
     * @request GET:/api/netsuite-rest-query/get-role-types/{connectionId}
     */
    getRoleTypes: (connectionId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-query/get-role-types/${connectionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestQueryDataSource
     * @name GetColumns
     * @summary Returns the fields/columns available for a given role type (entity), derived from the REST API OpenAPI metadata already cached on the instance.
     * @request GET:/api/netsuite-rest-query/get-columns/{connectionId}/{roleType}
     */
    getColumns: (connectionId: string, roleType: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-query/get-columns/${connectionId}/${roleType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  netsuiteRestRealtime = {
    /**
     * No description
     *
     * @tags NetSuiteRestRealTimeDataSource
     * @name Save
     * @request POST:/api/netsuite-rest-realtime/save
     */
    save: (data: NetSuiteRestRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-realtime/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestRealTimeDataSource
     * @name Validate
     * @request POST:/api/netsuite-rest-realtime/validate
     */
    validate: (data: NetSuiteRestRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-realtime/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestRealTimeDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/netsuite-rest-realtime/schema-columns/reload
     */
    reloadSchemaColumns: (data: NetSuiteRestRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-realtime/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestRealTimeDataSource
     * @name GetRoleTypes
     * @request GET:/api/netsuite-rest-realtime/get-role-types/{connectionId}
     */
    getRoleTypes: (
      connectionId: string,
      query?: {
        /** @format uuid */
        dataSourceId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-realtime/get-role-types/${connectionId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestRealTimeDataSource
     * @name GetLinkedMaps
     * @request GET:/api/netsuite-rest-realtime/get-linked-maps/{id}
     */
    getLinkedMaps: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-realtime/get-linked-maps/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestRealTimeDataSource
     * @name RegisterDataSource
     * @request POST:/api/netsuite-rest-realtime/register-datasource
     */
    registerDataSource: (data: NetSuiteRestRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-rest-realtime/register-datasource`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestRealTimeDataSource
     * @name GetSuiteScript
     * @request GET:/api/netsuite-rest-realtime/suitescript/{dataSourceId}
     */
    getSuiteScript: (dataSourceId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/netsuite-rest-realtime/suitescript/${dataSourceId}`,
        method: 'GET',
        ...params,
      }),
  };
  netsuiteRestletQuery = {
    /**
     * No description
     *
     * @tags NetSuiteRestRESTletQueryDataSource
     * @name Validate
     * @request POST:/api/netsuite-restlet-query/validate
     */
    validate: (data: NetSuiteRESTletQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-restlet-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestRESTletQueryDataSource
     * @name Save
     * @request POST:/api/netsuite-restlet-query/save
     */
    save: (data: NetSuiteRESTletQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-restlet-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestRESTletQueryDataSource
     * @name Preview
     * @request POST:/api/netsuite-restlet-query/preview
     */
    preview: (data: NetSuiteRESTletQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-restlet-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestRESTletQueryDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/netsuite-restlet-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: NetSuiteRESTletQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-restlet-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestRESTletQueryDataSource
     * @name GetEndpoint
     * @request GET:/api/netsuite-restlet-query/endpoint/{connectionId}
     */
    getEndpoint: (connectionId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-restlet-query/endpoint/${connectionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  netsuiteSuiteqlQuery = {
    /**
     * No description
     *
     * @tags NetSuiteRestSuiteQLQueryDataSource
     * @name Validate
     * @request POST:/api/netsuite-suiteql-query/validate
     */
    validate: (data: NetSuiteSuiteQLQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-suiteql-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestSuiteQLQueryDataSource
     * @name Save
     * @request POST:/api/netsuite-suiteql-query/save
     */
    save: (data: NetSuiteSuiteQLQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-suiteql-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestSuiteQLQueryDataSource
     * @name Preview
     * @request POST:/api/netsuite-suiteql-query/preview
     */
    preview: (data: NetSuiteSuiteQLQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-suiteql-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestSuiteQLQueryDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/netsuite-suiteql-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: NetSuiteSuiteQLQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-suiteql-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NetSuiteRestSuiteQLQueryDataSource
     * @name FormatQl
     * @request POST:/api/netsuite-suiteql-query/format-ql
     */
    formatQl: (data: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/netsuite-suiteql-query/format-ql`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  notification = {
    /**
     * No description
     *
     * @tags Notification
     * @name GetHistory
     * @request GET:/api/notification/history
     */
    getHistory: (
      query?: {
        /**
         * @format int32
         * @default 50
         */
        top?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/notification/history`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name BroadcastMessage
     * @request POST:/api/notification/broadcast
     */
    broadcastMessage: (data: NotificationModel, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/notification/broadcast`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name SendToUser
     * @request POST:/api/notification/send-to-user
     */
    sendToUser: (data: NotificationModel, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/notification/send-to-user`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name SendToAdmin
     * @request POST:/api/notification/send-to-admin
     */
    sendToAdmin: (data: NotificationModel, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/notification/send-to-admin`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name SendProcessSummaryMessage
     * @request POST:/api/notification/process-summary
     */
    sendProcessSummaryMessage: (data: SummaryMessage, params: RequestParams = {}) =>
      this.request<SummaryMessage, any>({
        path: `/api/notification/process-summary`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name SendProcessSummarysMessage
     * @request POST:/api/notification/process-summarys
     */
    sendProcessSummarysMessage: (data: SummaryMessage, params: RequestParams = {}) =>
      this.request<SummaryMessage, any>({
        path: `/api/notification/process-summarys`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name SendProcessDetailMessage
     * @request POST:/api/notification/process-detail
     */
    sendProcessDetailMessage: (data: DetailMessage, params: RequestParams = {}) =>
      this.request<DetailMessage, any>({
        path: `/api/notification/process-detail`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name TestAlert
     * @summary Test endpoint: sends a SystemAlertMessage through Service Bus → AlertNotificationMessageProcessor → DB + SignalR bell. Usage from Postman: POST /api/notification/test-alert with optional JSON body.
     * @request POST:/api/notification/test-alert
     */
    testAlert: (data: TestAlertRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/notification/test-alert`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name TestAlertBurst
     * @summary Test endpoint: sends multiple alerts in quick succession to test burst/dedup behavior.
     * @request POST:/api/notification/test-alert-burst
     */
    testAlertBurst: (
      query?: {
        /**
         * @format int32
         * @default 3
         */
        count?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/notification/test-alert-burst`,
        method: 'POST',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name TestAlertGlobal
     * @summary Test endpoint: sends a global broadcast alert visible to ALL connected users. Usage from Postman: POST /api/notification/test-alert-global with optional JSON body.
     * @request POST:/api/notification/test-alert-global
     */
    testAlertGlobal: (data: TestAlertRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/notification/test-alert-global`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  odbc = {
    /**
     * No description
     *
     * @tags Odbc
     * @name ValidateConnection
     * @request POST:/api/odbc/validate/{id}
     */
    validateConnection: (id: string, data: OdbcInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/odbc/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Odbc
     * @name SaveConnection
     * @request POST:/api/odbc/save/{id}
     */
    saveConnection: (id: string, data: OdbcInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/odbc/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  odbcQuery = {
    /**
     * No description
     *
     * @tags OdbcDataSource
     * @name Validate
     * @request POST:/api/odbc-query/validate
     */
    validate: (data: OdbcQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/odbc-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdbcDataSource
     * @name Save
     * @request POST:/api/odbc-query/save
     */
    save: (data: OdbcQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/odbc-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdbcDataSource
     * @name GetPreview
     * @request POST:/api/odbc-query/preview
     */
    getPreview: (data: OdbcQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/odbc-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdbcDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/odbc-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: OdbcQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/odbc-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdbcDataSource
     * @name CacheDataSource
     * @request POST:/api/odbc-query/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: OdbcQueryDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/odbc-query/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  oledb = {
    /**
     * No description
     *
     * @tags Oledb
     * @name ValidateConnection
     * @request POST:/api/oledb/validate/{id}
     */
    validateConnection: (id: string, data: OledbInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/oledb/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Oledb
     * @name SaveConnection
     * @request POST:/api/oledb/save/{id}
     */
    saveConnection: (id: string, data: OledbInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/oledb/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  oledbQuery = {
    /**
     * No description
     *
     * @tags OledbDataSource
     * @name Validate
     * @request POST:/api/oledb-query/validate
     */
    validate: (data: OledbQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/oledb-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OledbDataSource
     * @name Save
     * @request POST:/api/oledb-query/save
     */
    save: (data: OledbQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/oledb-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OledbDataSource
     * @name GetPreview
     * @request POST:/api/oledb-query/preview
     */
    getPreview: (data: OledbQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/oledb-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OledbDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/oledb-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: OledbQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/oledb-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OledbDataSource
     * @name CacheDataSource
     * @request POST:/api/oledb-query/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: OledbQueryDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/oledb-query/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  popdock = {
    /**
     * No description
     *
     * @tags Popdock
     * @name GetExternalSettings
     * @request GET:/api/popdock/get-external-settings/{instanceId}
     */
    getExternalSettings: (instanceId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/popdock/get-external-settings/${instanceId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Popdock
     * @name GetPopdockList
     * @request POST:/api/popdock/get-pop-list
     */
    getPopdockList: (data: PopdockQueryInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/popdock/get-pop-list`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Popdock
     * @name GetFavoritesList
     * @request POST:/api/popdock/get-favorites-list
     */
    getFavoritesList: (data: PopdockQueryInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/popdock/get-favorites-list`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Popdock
     * @name GetHasCompanyList
     * @request GET:/api/popdock/get-has-company-list/{id}
     */
    getHasCompanyList: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/popdock/get-has-company-list/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Popdock
     * @name GetHasGroupList
     * @request GET:/api/popdock/get-has-group-list/{id}
     */
    getHasGroupList: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/popdock/get-has-group-list/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Popdock
     * @name GetAccounts
     * @request GET:/api/popdock/get-accounts/{id}
     */
    getAccounts: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/popdock/get-accounts/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Popdock
     * @name ValidateConnection
     * @request POST:/api/popdock/validate/{id}
     */
    validateConnection: (id: string, data: PopdockInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/popdock/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Popdock
     * @name SaveConnection
     * @request POST:/api/popdock/save/{id}
     */
    saveConnection: (id: string, data: PopdockInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/popdock/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  popdockQuery = {
    /**
     * No description
     *
     * @tags PopDockQuery
     * @name Save
     * @request POST:/api/popdock-query/save
     */
    save: (data: PopdockQueryInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/popdock-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PopDockQuery
     * @name Validate
     * @request POST:/api/popdock-query/validate
     */
    validate: (data: PopdockQueryInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/popdock-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PopDockQuery
     * @name GetPreview
     * @request POST:/api/popdock-query/preview
     */
    getPreview: (data: PopdockQueryInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/popdock-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PopDockQuery
     * @name GetHasGroupList
     * @request POST:/api/popdock-query/get-has-group
     */
    getHasGroupList: (data: PopdockQueryInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/popdock-query/get-has-group`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PopDockQuery
     * @name GetHasCompanyList
     * @request POST:/api/popdock-query/get-has-company
     */
    getHasCompanyList: (data: PopdockQueryInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/popdock-query/get-has-company`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PopDockQuery
     * @name ReloadSchemaColumns
     * @request POST:/api/popdock-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: PopdockQueryInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/popdock-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  postgresql = {
    /**
     * No description
     *
     * @tags PostgreSql
     * @name ValidateConnection
     * @request POST:/api/postgresql/validate/{id}
     */
    validateConnection: (id: string, data: PostgreSqlInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/postgresql/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreSql
     * @name SaveConnection
     * @request POST:/api/postgresql/save/{id}
     */
    saveConnection: (id: string, data: PostgreSqlInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/postgresql/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreSql
     * @name GetDatabases
     * @request POST:/api/postgresql/get-external-settings/{id}
     */
    getDatabases: (id: string, data: PostgreSqlInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/postgresql/get-external-settings/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreSql
     * @name GetDatabases2
     * @request GET:/api/postgresql/get-databases/{id}
     * @originalName getDatabases
     * @duplicate
     */
    getDatabases2: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/postgresql/get-databases/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreSql
     * @name GetTables
     * @request GET:/api/postgresql/get-tables/{id}/{database}
     */
    getTables: (id: string, database: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/postgresql/get-tables/${id}/${database}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreSql
     * @name GetTableColumns
     * @request GET:/api/postgresql/get-table-columns/{id}/{database}/{table}
     */
    getTableColumns: (id: string, database: string, table: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/postgresql/get-table-columns/${id}/${database}/${table}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  postgresqlChange = {
    /**
     * No description
     *
     * @tags PostgreSqlChangeDataSource
     * @name Validate
     * @request POST:/api/postgresql-change/validate
     */
    validate: (data: PostgreSqlChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/postgresql-change/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreSqlChangeDataSource
     * @name Save
     * @request POST:/api/postgresql-change/save
     */
    save: (data: PostgreSqlChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/postgresql-change/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreSqlChangeDataSource
     * @name GetPreview
     * @request POST:/api/postgresql-change/preview
     */
    getPreview: (data: PostgreSqlChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/postgresql-change/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreSqlChangeDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/postgresql-change/schema-columns/reload
     */
    reloadSchemaColumns: (data: PostgreSqlChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/postgresql-change/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreSqlChangeDataSource
     * @name CacheDataSource
     * @request POST:/api/postgresql-change/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: PostgreSqlChangeDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/postgresql-change/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  postgresqlQuery = {
    /**
     * No description
     *
     * @tags PostgreSqlQuerySource
     * @name Validate
     * @request POST:/api/postgresql-query/validate
     */
    validate: (data: PostgreSqlQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/postgresql-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreSqlQuerySource
     * @name Save
     * @request POST:/api/postgresql-query/save
     */
    save: (data: PostgreSqlQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/postgresql-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreSqlQuerySource
     * @name GetPreview
     * @request POST:/api/postgresql-query/preview
     */
    getPreview: (data: PostgreSqlQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/postgresql-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreSqlQuerySource
     * @name ReloadSchemaColumns
     * @request POST:/api/postgresql-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: PostgreSqlQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/postgresql-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreSqlQuerySource
     * @name CacheDataSource
     * @request POST:/api/postgresql-query/cache-query-model/{dataSourceId}
     */
    cacheDataSource: (
      dataSourceId: string,
      data: PostgreSqlQueryDataSourceModel,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/postgresql-query/cache-query-model/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  postgreSpDestination = {
    /**
     * No description
     *
     * @tags PostgreStoredProcDestination
     * @name GetDestinations
     * @request GET:/api/postgre-sp-destination/list
     */
    getDestinations: (params: RequestParams = {}) =>
      this.request<PostgreSqlInstanceModelListBaseResponse, any>({
        path: `/api/postgre-sp-destination/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreStoredProcDestination
     * @name GetDestinationData
     * @request POST:/api/postgre-sp-destination/get-destination-data
     */
    getDestinationData: (data: PostgreStoredProcDestinationModel, params: RequestParams = {}) =>
      this.request<SqlObjectListBaseResponse, any>({
        path: `/api/postgre-sp-destination/get-destination-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreStoredProcDestination
     * @name GetDestinationLines
     * @request POST:/api/postgre-sp-destination/get-destination-lines
     */
    getDestinationLines: (data: PostgreStoredProcDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/postgre-sp-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreStoredProcDestination
     * @name GetMapLineParameters
     * @request POST:/api/postgre-sp-destination/get-destination-line-parameters/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalValue: string,
      data: PostgreStoredProcDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/postgre-sp-destination/get-destination-line-parameters/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  postgreTableDestination = {
    /**
     * No description
     *
     * @tags PostgreTableDestination
     * @name GetDestinations
     * @request GET:/api/postgre-table-destination/list
     */
    getDestinations: (params: RequestParams = {}) =>
      this.request<PostgreSqlInstanceModelListBaseResponse, any>({
        path: `/api/postgre-table-destination/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreTableDestination
     * @name GetDestinationData
     * @request POST:/api/postgre-table-destination/get-destination-data
     */
    getDestinationData: (data: PostgreTableDestinationModel, params: RequestParams = {}) =>
      this.request<SqlObjectListBaseResponse, any>({
        path: `/api/postgre-table-destination/get-destination-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreTableDestination
     * @name GetDestinationLines
     * @request POST:/api/postgre-table-destination/get-destination-lines
     */
    getDestinationLines: (data: PostgreTableDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/postgre-table-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PostgreTableDestination
     * @name GetMapLineParameters
     * @request POST:/api/postgre-table-destination/get-destination-line-parameters/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalValue: string,
      data: PostgreTableDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/postgre-table-destination/get-destination-line-parameters/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  process = {
    /**
     * No description
     *
     * @tags Process
     * @name GetProcessList
     * @summary Get a list of process definition.
     * @request GET:/api/process/list
     */
    getProcessList: (params: RequestParams = {}) =>
      this.request<ProcessDto[], any>({
        path: `/api/process/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetProcessSourceAndTargetTypes
     * @request GET:/api/process/source-target-types
     */
    getProcessSourceAndTargetTypes: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process/source-target-types`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetSidebarCounts
     * @request GET:/api/process/sidebar-counts
     */
    getSidebarCounts: (params: RequestParams = {}) =>
      this.request<SidebarCountsDtoBaseResponse, any>({
        path: `/api/process/sidebar-counts`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name CheckNameDuplicate
     * @request POST:/api/process/check-name
     */
    checkNameDuplicate: (data: CheckMapNameDuplicateRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process/check-name`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetDataSourceTypes
     * @request GET:/api/process/data-source-type/list
     */
    getDataSourceTypes: (params: RequestParams = {}) =>
      this.request<ConnectorDataSourceListBaseResponse, any>({
        path: `/api/process/data-source-type/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetDestinationTypes
     * @request GET:/api/process/destination-type/list
     */
    getDestinationTypes: (params: RequestParams = {}) =>
      this.request<ConnectorDestinationListBaseResponse, any>({
        path: `/api/process/destination-type/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetMapListForTask
     * @request POST:/api/process/map-task
     */
    getMapListForTask: (data: GetMapForTaskRequest, params: RequestParams = {}) =>
      this.request<GenericMapListItem[], any>({
        path: `/api/process/map-task`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetSourceColumnsNew
     * @request POST:/api/process/source-columns-new
     */
    getSourceColumnsNew: (data: GetSourceColumnsRequest, params: RequestParams = {}) =>
      this.request<DataSourceSelectionResponseBaseResponse, any>({
        path: `/api/process/source-columns-new`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name Get
     * @request GET:/api/process/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<ProcessModel, any>({
        path: `/api/process/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetTasksByMapId
     * @request GET:/api/process/{mapId}/tasks
     */
    getTasksByMapId: (mapId: string, params: RequestParams = {}) =>
      this.request<ProcessTaskModel[], any>({
        path: `/api/process/${mapId}/tasks`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetLinesByMapId
     * @request GET:/api/process/{mapId}/lines
     */
    getLinesByMapId: (mapId: string, params: RequestParams = {}) =>
      this.request<ProcessMapLineModel[], any>({
        path: `/api/process/${mapId}/lines`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetLookupsByMapId
     * @request GET:/api/process/{mapId}/lookups
     */
    getLookupsByMapId: (mapId: string, params: RequestParams = {}) =>
      this.request<LookupColumnModel[], any>({
        path: `/api/process/${mapId}/lookups`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetRunMapEdges
     * @request GET:/api/process/visualizer/runmap-edges
     */
    getRunMapEdges: (params: RequestParams = {}) =>
      this.request<RunMapEdgeModel[], any>({
        path: `/api/process/visualizer/runmap-edges`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetIntegrationStructure
     * @request GET:/api/process/{mapId}/structure
     */
    getIntegrationStructure: (mapId: string, params: RequestParams = {}) =>
      this.request<IntegrationStructureModel, any>({
        path: `/api/process/${mapId}/structure`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetProcessesForConnection
     * @request GET:/api/process/connection/{id}
     */
    getProcessesForConnection: (id: string, params: RequestParams = {}) =>
      this.request<ProcessBizModelListBaseResponse, any>({
        path: `/api/process/connection/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetDraftsForConnection
     * @request GET:/api/process/connection-draft/{id}
     */
    getDraftsForConnection: (id: string, params: RequestParams = {}) =>
      this.request<DraftListDtoListBaseResponse, any>({
        path: `/api/process/connection-draft/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetFileTargetDestinationDetails
     * @request GET:/api/process/file-target-destination-details/{destinationId}
     */
    getFileTargetDestinationDetails: (destinationId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process/file-target-destination-details/${destinationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetDestinationTenantDetails
     * @request POST:/api/process/target-tenant-details
     */
    getDestinationTenantDetails: (
      data: GetTargetTenantDetailsRequest,
      params: RequestParams = {},
    ) =>
      this.request<GetTargetTenantDetailsResponseBaseResponse, any>({
        path: `/api/process/target-tenant-details`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name Compare
     * @request POST:/api/process/compare
     */
    compare: (data: IntegrationProcessDto, params: RequestParams = {}) =>
      this.request<CompareProcessResponseBaseResponse, any>({
        path: `/api/process/compare`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name Save
     * @request POST:/api/process/save
     */
    save: (data: IntegrationProcessDto, params: RequestParams = {}) =>
      this.request<IntegrationProcessDtoBaseResponse, any>({
        path: `/api/process/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name CheckRuntimeValues
     * @summary Checks whether saving this draft would overwrite runtime-updated values on the live integration (custom rolling column NextNumber or persisted map variable Values). Returns conflict details so the frontend can prompt the user before committing the save.
     * @request POST:/api/process/check-runtime-values
     */
    checkRuntimeValues: (data: IntegrationProcessDto, params: RequestParams = {}) =>
      this.request<CheckRuntimeValuesResponseBaseResponse, any>({
        path: `/api/process/check-runtime-values`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetCompleteProcessById
     * @request GET:/api/process/{mapId}/complete/{isReadOnly}
     */
    getCompleteProcessById: (mapId: string, isReadOnly: boolean, params: RequestParams = {}) =>
      this.request<IntegrationProcessDtoBaseResponse, any>({
        path: `/api/process/${mapId}/complete/${isReadOnly}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name Delete
     * @request POST:/api/process/delete
     */
    delete: (data: DeleteProcessRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process/delete`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetMappingColumnsDataNew
     * @request POST:/api/process/mapping-columns-new
     */
    getMappingColumnsDataNew: (data: GetMappingColumnsDataNewRequest, params: RequestParams = {}) =>
      this.request<GetMappingColumnsDataResponseBaseResponse, any>({
        path: `/api/process/mapping-columns-new`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetTargetColumnsData
     * @request POST:/api/process/target-columns
     */
    getTargetColumnsData: (data: GetTargetColumnsDataRequest, params: RequestParams = {}) =>
      this.request<GetTargetColumnsDataResponseBaseResponse, any>({
        path: `/api/process/target-columns`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetAdditionalColumnTypes
     * @request POST:/api/process/additional-column/types
     */
    getAdditionalColumnTypes: (
      data: GetSourceAdditionalColumnTypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<GenericListItemListBaseResponse, any>({
        path: `/api/process/additional-column/types`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetTargetColumnTypes
     * @request POST:/api/process/target-column/types
     */
    getTargetColumnTypes: (
      data: GetSourceAdditionalColumnTypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<GenericListItemListBaseResponse, any>({
        path: `/api/process/target-column/types`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name PreviewSourceNew
     * @request POST:/api/process/preview-source-new
     */
    previewSourceNew: (data: PreviewSourceRequest, params: RequestParams = {}) =>
      this.request<PreviewSourceResponseBaseResponse, any>({
        path: `/api/process/preview-source-new`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name UpdateProcessAuditingTest
     * @request POST:/api/process/auditing/test-update
     */
    updateProcessAuditingTest: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/process/auditing/test-update`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name CreateProcessAuditingTest
     * @request POST:/api/process/auditing/test-create
     */
    createProcessAuditingTest: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/process/auditing/test-create`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name DeleteProcessAuditingTest
     * @request POST:/api/process/auditing/test-delete
     */
    deleteProcessAuditingTest: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/process/auditing/test-delete`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name CloneMap
     * @request POST:/api/process/clone
     */
    cloneMap: (data: CloneMapRequest, params: RequestParams = {}) =>
      this.request<IntegrationProcessDtoBaseResponse, any>({
        path: `/api/process/clone`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name PrepareDuplicate
     * @request POST:/api/process/clone/prepare
     */
    prepareDuplicate: (data: PrepareDuplicateRequest, params: RequestParams = {}) =>
      this.request<ProcessImportFileDtoBaseResponse, any>({
        path: `/api/process/clone/prepare`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name ExportDocumentation
     * @request POST:/api/process/documentation/export
     */
    exportDocumentation: (data: ExportDocumentationRequest, params: RequestParams = {}) =>
      this.request<ExportProcessDocumentationResponseBaseResponse, any>({
        path: `/api/process/documentation/export`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name ExportProcess
     * @request POST:/api/process/export
     */
    exportProcess: (data: ExportProcessRequest, params: RequestParams = {}) =>
      this.request<ExportProcessResponseBaseResponse, any>({
        path: `/api/process/export`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name ImportFile
     * @request POST:/api/process/import-file/upload
     */
    importFile: (
      data: {
        Files?: File[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ProcessImportFileDtoListBaseResponse, any>({
        path: `/api/process/import-file/upload`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name ImportProcess
     * @request POST:/api/process/import
     */
    importProcess: (data: ProcessImportDto, params: RequestParams = {}) =>
      this.request<IntegrationProcessDtoBaseResponse, any>({
        path: `/api/process/import`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetFileDestinationLines
     * @request GET:/api/process/file-destination-lines
     */
    getFileDestinationLines: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process/file-destination-lines`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Process
     * @name GetGenericFileSchemaColumns
     * @request GET:/api/process/generic-file-schema-columns/{id}
     */
    getGenericFileSchemaColumns: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process/generic-file-schema-columns/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  processError = {
    /**
     * No description
     *
     * @tags ProcessErrors
     * @name GetProcessErrorSummary
     * @request GET:/api/process-error/summary
     */
    getProcessErrorSummary: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process-error/summary`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessErrors
     * @name GetProcessErrorDetails
     * @request GET:/api/process-error/detail/{mapId}
     */
    getProcessErrorDetails: (mapId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process-error/detail/${mapId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessErrors
     * @name GetProcessErrorsProcessModel
     * @request GET:/api/process-error/process-error-process-model/{mapId}
     */
    getProcessErrorsProcessModel: (mapId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process-error/process-error-process-model/${mapId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessErrors
     * @name GetProcessErrorSummaryNavigationMenu
     * @request GET:/api/process-error/summary-navigation
     */
    getProcessErrorSummaryNavigationMenu: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process-error/summary-navigation`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessErrors
     * @name GetProcessErrorSummaryNavigationMenuByMap
     * @request GET:/api/process-error/summary-navigation/{mapId}
     */
    getProcessErrorSummaryNavigationMenuByMap: (mapId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process-error/summary-navigation/${mapId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessErrors
     * @name GetProcessErrorDetailRows
     * @request GET:/api/process-error/source/{mapId}/{tenantDescription}/{runNumber}
     */
    getProcessErrorDetailRows: (
      mapId: string,
      tenantDescription: string,
      runNumber: number,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/process-error/source/${mapId}/${tenantDescription}/${runNumber}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessErrors
     * @name GetProcessErrorDetailRowsTest
     * @request GET:/api/process-error/source/{mapId}/{runNumber}
     */
    getProcessErrorDetailRowsTest: (mapId: string, runNumber: number, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process-error/source/${mapId}/${runNumber}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessErrors
     * @name GetProcessErrorDetailRowColumns
     * @request GET:/api/process-error/columns/{mapId}/{tenantDescription}/{runNumber}
     */
    getProcessErrorDetailRowColumns: (
      mapId: string,
      tenantDescription: string,
      runNumber: number,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/process-error/columns/${mapId}/${tenantDescription}/${runNumber}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessErrors
     * @name ExportFileExcel
     * @request GET:/api/process-error/export-to-excel/{mapId}/{tenantDescription}/{runNumber}
     */
    exportFileExcel: (
      mapId: string,
      tenantDescription: string,
      runNumber: number,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/process-error/export-to-excel/${mapId}/${tenantDescription}/${runNumber}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessErrors
     * @name SaveRunErrors
     * @request POST:/api/process-error/save/{mapId}
     */
    saveRunErrors: (mapId: string, data: any, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process-error/save/${mapId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessErrors
     * @name ImportFromExcel
     * @request POST:/api/process-error/import-from-excel/{mapId}/{tenantDescription}/{runNumber}
     */
    importFromExcel: (
      mapId: string,
      tenantDescription: string,
      runNumber: number,
      data: {
        /** @format binary */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/process-error/import-from-excel/${mapId}/${tenantDescription}/${runNumber}`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessErrors
     * @name DeleteErrors
     * @request DELETE:/api/process-error/delete/{mapId}/{tenantDescription}/{runNumber}
     */
    deleteErrors: (
      mapId: string,
      tenantDescription: string,
      runNumber: number,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/process-error/delete/${mapId}/${tenantDescription}/${runNumber}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessErrors
     * @name DeleteMultipleErrors
     * @request POST:/api/process-error/delete-multiple
     */
    deleteMultipleErrors: (data: IntegrationErrorDeleteMto[], params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process-error/delete-multiple`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  processHistory = {
    /**
     * No description
     *
     * @tags ProcessHistory
     * @name Test
     * @request GET:/api/process-history/test
     */
    test: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process-history/test`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessHistory
     * @name GetOutputs
     * @request POST:/api/process-history/outputs
     */
    getOutputs: (data: HistoryOutputQueryRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process-history/outputs`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessHistory
     * @name GetRunningActivitiesList
     * @request POST:/api/process-history/running-activity/list
     */
    getRunningActivitiesList: (params: RequestParams = {}) =>
      this.request<MapRunActivityModelListBaseResponse, any>({
        path: `/api/process-history/running-activity/list`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessHistory
     * @name CancelRunningActivity
     * @request POST:/api/process-history/running-activity/cancel
     */
    cancelRunningActivity: (data: CancelRunningActivityRequest, params: RequestParams = {}) =>
      this.request<BooleanBaseResponse, any>({
        path: `/api/process-history/running-activity/cancel`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessHistory
     * @name ClearProcess
     * @request POST:/api/process-history/running-activity/clear
     */
    clearProcess: (data: DeleteRunningActivityRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process-history/running-activity/clear`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessHistory
     * @name GetSummary
     * @request POST:/api/process-history/history-activity-sum/list
     */
    getSummary: (params: RequestParams = {}) =>
      this.request<MapRunActivitySummaryModelListBaseResponse, any>({
        path: `/api/process-history/history-activity-sum/list`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessHistory
     * @name GetMapRunActivities
     * @request POST:/api/process-history/history-activity-sum/map-activity/list
     */
    getMapRunActivities: (data: GetMapRunActivityRequest, params: RequestParams = {}) =>
      this.request<MapRunActivityModelPageBaseResponse, any>({
        path: `/api/process-history/history-activity-sum/map-activity/list`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessHistory
     * @name GetRealtimeActivityDetails
     * @request POST:/api/process-history/running-activity-detail/list
     */
    getRealtimeActivityDetails: (
      data: GetRealtimeActivityDetailRequest,
      params: RequestParams = {},
    ) =>
      this.request<MapRunActivityDetailModelListBaseResponse, any>({
        path: `/api/process-history/running-activity-detail/list`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessHistory
     * @name GetMapRunActivityDetails
     * @request POST:/api/process-history/history-activity-detail/list
     */
    getMapRunActivityDetails: (data: GetMapRunActivityDetailRequest, params: RequestParams = {}) =>
      this.request<MapRunActivityDetailModelListBaseResponse, any>({
        path: `/api/process-history/history-activity-detail/list`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessHistory
     * @name GetMapRunActivityDetailCount
     * @request POST:/api/process-history/history-activity-detail/count
     */
    getMapRunActivityDetailCount: (
      data: GetMapRunActivityDetailCountRequest,
      params: RequestParams = {},
    ) =>
      this.request<Int32BaseResponse, any>({
        path: `/api/process-history/history-activity-detail/count`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessHistory
     * @name DeleteOutput
     * @request DELETE:/api/process-history/outputs/{fileHolderId}
     */
    deleteOutput: (fileHolderId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process-history/outputs/${fileHolderId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessHistory
     * @name ExportMapRunActivityDetail
     * @request POST:/api/process-history/history-activity-detail/export
     */
    exportMapRunActivityDetail: (
      data: ExportMapRunActivityDetailRequest,
      params: RequestParams = {},
    ) =>
      this.request<ExportMapRunActivityDetailResponseBaseResponse, any>({
        path: `/api/process-history/history-activity-detail/export`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  processTask = {
    /**
     * No description
     *
     * @tags ProcessTask
     * @name Get
     * @request GET:/api/process-task/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<ProcessTaskModel, any>({
        path: `/api/process-task/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessTask
     * @name GetSqlDatabases
     * @request GET:/api/process-task/sql-databases/{connectorInstanceId}
     */
    getSqlDatabases: (connectorInstanceId: string, params: RequestParams = {}) =>
      this.request<StringListBaseResponse, any>({
        path: `/api/process-task/sql-databases/${connectorInstanceId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessTask
     * @name GetGraphConnections
     * @request GET:/api/process-task/graph-connections
     */
    getGraphConnections: (params: RequestParams = {}) =>
      this.request<GenericListItemListBaseResponse, any>({
        path: `/api/process-task/graph-connections`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessTask
     * @name GetTeamsList
     * @request GET:/api/process-task/graph-connection/{connectorInstanceId}/teams
     */
    getTeamsList: (connectorInstanceId: string, params: RequestParams = {}) =>
      this.request<TeamsItemListBaseResponse, any>({
        path: `/api/process-task/graph-connection/${connectorInstanceId}/teams`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessTask
     * @name GetGraphLists
     * @request GET:/api/process-task/graph-connection/{connectorInstanceId}/lists
     */
    getGraphLists: (connectorInstanceId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process-task/graph-connection/${connectorInstanceId}/lists`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessTask
     * @name GetChannelsList
     * @request GET:/api/process-task/graph-connection/{connectorInstanceId}/team/{teamId}/channels
     */
    getChannelsList: (connectorInstanceId: string, teamId: string, params: RequestParams = {}) =>
      this.request<TeamsItemListBaseResponse, any>({
        path: `/api/process-task/graph-connection/${connectorInstanceId}/team/${teamId}/channels`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessTask
     * @name GetChatsList
     * @request GET:/api/process-task/graph-connection/{connectorInstanceId}/chats
     */
    getChatsList: (connectorInstanceId: string, params: RequestParams = {}) =>
      this.request<TeamsChatItemListBaseResponse, any>({
        path: `/api/process-task/graph-connection/${connectorInstanceId}/chats`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessTask
     * @name GetSlackConnections
     * @request GET:/api/process-task/slack-connections
     */
    getSlackConnections: (params: RequestParams = {}) =>
      this.request<GenericListItemListBaseResponse, any>({
        path: `/api/process-task/slack-connections`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessTask
     * @name GetSlackChannels
     * @request GET:/api/process-task/slack-connection/{connectorInstanceId}/channels
     */
    getSlackChannels: (connectorInstanceId: string, params: RequestParams = {}) =>
      this.request<SlackChannelListBaseResponse, any>({
        path: `/api/process-task/slack-connection/${connectorInstanceId}/channels`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessTask
     * @name AddBotUserToChannel
     * @request POST:/api/process-task/slack-connection/add-bot-user-to-channel
     */
    addBotUserToChannel: (data: AddBotUserToChannelRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/process-task/slack-connection/add-bot-user-to-channel`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessTask
     * @name GetTrelloConnections
     * @request GET:/api/process-task/trello-connections
     */
    getTrelloConnections: (params: RequestParams = {}) =>
      this.request<GenericListItemListBaseResponse, any>({
        path: `/api/process-task/trello-connections`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessTask
     * @name GetTrelloBoardList
     * @request GET:/api/process-task/trello-connection/{connectorInstanceId}/boards
     */
    getTrelloBoardList: (connectorInstanceId: string, params: RequestParams = {}) =>
      this.request<TrelloItemListBaseResponse, any>({
        path: `/api/process-task/trello-connection/${connectorInstanceId}/boards`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessTask
     * @name GetTrelloListList
     * @request GET:/api/process-task/trello-connection/{connectorInstanceId}/board/{boardId}/lists
     */
    getTrelloListList: (connectorInstanceId: string, boardId: string, params: RequestParams = {}) =>
      this.request<TrelloItemListBaseResponse, any>({
        path: `/api/process-task/trello-connection/${connectorInstanceId}/board/${boardId}/lists`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProcessTask
     * @name GetTrelloCardList
     * @request GET:/api/process-task/trello-connection/{connectorInstanceId}/list/{listId}/cards
     */
    getTrelloCardList: (connectorInstanceId: string, listId: string, params: RequestParams = {}) =>
      this.request<TrelloItemListBaseResponse, any>({
        path: `/api/process-task/trello-connection/${connectorInstanceId}/list/${listId}/cards`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  queryBuilder = {
    /**
     * No description
     *
     * @tags QueryBuilder
     * @name SetQueryBuilder
     * @request POST:/api/query-builder/set-query-builder/{sessionId}
     */
    setQueryBuilder: (sessionId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/query-builder/set-query-builder/${sessionId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags QueryBuilder
     * @name GetTables
     * @request POST:/api/query-builder/get-tables/{sessionId}
     */
    getTables: (sessionId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/query-builder/get-tables/${sessionId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags QueryBuilder
     * @name GetTableFields
     * @request POST:/api/query-builder/get-table-fields/{sessionId}/{tableName}
     */
    getTableFields: (sessionId: string, tableName: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/query-builder/get-table-fields/${sessionId}/${tableName}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags QueryBuilder
     * @name Save
     * @request POST:/api/query-builder/save/{dataSourceId}
     */
    save: (dataSourceId: string, data: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/query-builder/save/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags QueryBuilder
     * @name Preview
     * @request POST:/api/query-builder/preview/{dataSourceId}
     */
    preview: (dataSourceId: string, data: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/query-builder/preview/${dataSourceId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags QueryBuilder
     * @name RemoveQueryBuilder
     * @request POST:/api/query-builder/remove/{sessionId}
     */
    removeQueryBuilder: (sessionId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/query-builder/remove/${sessionId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  realtimeRejection = {
    /**
     * No description
     *
     * @tags RealtimeRejection
     * @name GetAll
     * @request GET:/api/realtime-rejection
     */
    getAll: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/realtime-rejection`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RealtimeRejection
     * @name DeleteAll
     * @request DELETE:/api/realtime-rejection
     */
    deleteAll: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/realtime-rejection`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RealtimeRejection
     * @name GetByDataSource
     * @request GET:/api/realtime-rejection/by-datasource/{dataSourceId}
     */
    getByDataSource: (dataSourceId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/realtime-rejection/by-datasource/${dataSourceId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RealtimeRejection
     * @name Delete
     * @request DELETE:/api/realtime-rejection/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/realtime-rejection/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  realtimeStaging = {
    /**
     * No description
     *
     * @tags RealtimeStaging
     * @name GetRealtimeStagingLogs
     * @request GET:/api/realtime-staging
     */
    getRealtimeStagingLogs: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/realtime-staging`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RealtimeStaging
     * @name GetRealtimeStagingLogsByDataSource
     * @request GET:/api/realtime-staging/by-datasource/{dataSourceId}
     */
    getRealtimeStagingLogsByDataSource: (dataSourceId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/realtime-staging/by-datasource/${dataSourceId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RealtimeStaging
     * @name DeleteRealtimeStagingLog
     * @request DELETE:/api/realtime-staging/{id}
     */
    deleteRealtimeStagingLog: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/realtime-staging/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RealtimeStaging
     * @name Rerun
     * @request POST:/api/realtime-staging/rerun/{id}
     */
    rerun: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/realtime-staging/rerun/${id}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RealtimeStaging
     * @name DeleteLogs
     * @request DELETE:/api/realtime-staging/bulk/{type}
     */
    deleteLogs: (type: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/realtime-staging/bulk/${type}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RealtimeStaging
     * @name Export
     * @request GET:/api/realtime-staging/export/{id}
     */
    export: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/realtime-staging/export/${id}`,
        method: 'GET',
        ...params,
      }),
  };
  rest = {
    /**
     * No description
     *
     * @tags Rest
     * @name Validate
     * @request POST:/api/rest/validate/{id}
     */
    validate: (id: string, data: GenericRestInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/rest/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rest
     * @name OAuthInstanceRedirect
     * @request GET:/api/rest/authCallback
     */
    oAuthInstanceRedirect: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/rest/authCallback`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rest
     * @name SaveConnection
     * @request POST:/api/rest/save/{id}
     */
    saveConnection: (id: string, data: GenericRestInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/rest/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  genericRestQuery = {
    /**
     * No description
     *
     * @tags RestDataSource
     * @name RefreshDetailsFromSetup
     * @request GET:/api/generic-rest-query/refresh-details-setup/{entityId}/{setupId}
     */
    refreshDetailsFromSetup: (
      entityId: string,
      setupId: string,
      query?: {
        /** @format uuid */
        connectionId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-query/refresh-details-setup/${entityId}/${setupId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RestDataSource
     * @name GetSetupData
     * @request GET:/api/generic-rest-query/get-setup-data/{setupId}
     */
    getSetupData: (setupId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-query/get-setup-data/${setupId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RestDataSource
     * @name GetGroupsList
     * @request GET:/api/generic-rest-query/get-groups-list/{entityId}
     */
    getGroupsList: (entityId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-query/get-groups-list/${entityId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RestDataSource
     * @name GetEntitiesList
     * @request GET:/api/generic-rest-query/get-entities/{entityId}/{groupName}
     */
    getEntitiesList: (entityId: string, groupName: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-query/get-entities/${entityId}/${groupName}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RestDataSource
     * @name GetSourceDetails
     * @request GET:/api/generic-rest-query/get-source-details/{entityId}
     */
    getSourceDetails: (entityId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-query/get-source-details/${entityId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RestDataSource
     * @name SaveDetailsToSetup
     * @request POST:/api/generic-rest-query/save-details-to-setup
     */
    saveDetailsToSetup: (data: GenericRestDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-query/save-details-to-setup`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RestDataSource
     * @name Save
     * @request POST:/api/generic-rest-query/save
     */
    save: (data: GenericRestDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RestDataSource
     * @name Validate
     * @request POST:/api/generic-rest-query/validate
     */
    validate: (data: GenericRestDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RestDataSource
     * @name Preview
     * @request POST:/api/generic-rest-query/preview
     */
    preview: (data: GenericRestDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RestDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/generic-rest-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: GenericRestDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/generic-rest-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  rollingColumn = {
    /**
     * No description
     *
     * @tags RollingColumn
     * @name GetGlobalRollingColumns
     * @request GET:/api/rolling-column/global/list
     */
    getGlobalRollingColumns: (params: RequestParams = {}) =>
      this.request<GlobalRollingColumnsSetupModelListBaseResponse, any>({
        path: `/api/rolling-column/global/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RollingColumn
     * @name Get
     * @request GET:/api/rolling-column/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/rolling-column/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RollingColumn
     * @name Delete
     * @request DELETE:/api/rolling-column/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<GlobalRollingColumnsSetupModelListBaseResponse, any>({
        path: `/api/rolling-column/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RollingColumn
     * @name Update
     * @request PATCH:/api/rolling-column
     */
    update: (data: GlobalRollingColumnsSetupModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/rolling-column`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RollingColumn
     * @name CheckName
     * @request POST:/api/rolling-column/check-name
     */
    checkName: (data: CheckNameRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/rolling-column/check-name`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  runProcess = {
    /**
     * No description
     *
     * @tags RunProcess
     * @name GetProcess
     * @request GET:/api/run-process/get-process/{id}
     */
    getProcess: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/run-process/get-process/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RunProcess
     * @name TriggerProcess
     * @request POST:/api/run-process/trigger-process/{id}
     */
    triggerProcess: (id: string, data: RunRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/run-process/trigger-process/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RunProcess
     * @name CancelProcess
     * @request POST:/api/run-process/cancel-process/{id}
     */
    cancelProcess: (
      id: string,
      query?: {
        /** @format uuid */
        runId?: string;
        /** @format uuid */
        mapKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/run-process/cancel-process/${id}`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RunProcess
     * @name LoadFile
     * @request POST:/api/run-process/load-file/{sourceType}/{mapId}/{fileName}
     */
    loadFile: (fileName: string, mapId: string, sourceType: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/run-process/load-file/${sourceType}/${mapId}/${fileName}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RunProcess
     * @name LoadFiles
     * @request POST:/api/run-process/load-files/{sourceType}/{mapId}/{holderId}/{fileName}
     */
    loadFiles: (
      sourceType: string,
      mapId: string,
      holderId: string,
      fileName: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/run-process/load-files/${sourceType}/${mapId}/${holderId}/${fileName}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RunProcess
     * @name ClearFile
     * @request POST:/api/run-process/clear-file/{holderId}/{fileName}
     */
    clearFile: (holderId: string, fileName: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/run-process/clear-file/${holderId}/${fileName}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RunProcess
     * @name GetFileHolderFiles
     * @request GET:/api/run-process/file-holder/{fileHolderId}
     */
    getFileHolderFiles: (fileHolderId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/run-process/file-holder/${fileHolderId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RunProcess
     * @name DownloadFileHolderFile
     * @request GET:/api/run-process/file-holder/{fileHolderId}/{fileDataId}
     */
    downloadFileHolderFile: (
      fileHolderId: string,
      fileDataId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/run-process/file-holder/${fileHolderId}/${fileDataId}`,
        method: 'GET',
        ...params,
      }),
  };
  salesforce = {
    /**
     * No description
     *
     * @tags Salesforce
     * @name ValidateConnection
     * @summary Validates the connection — both credential roles in one call, plus the sandbox link. SC-1520: there is no role argument and no browser redirect. Role-per-validate existed only because an OAuth authorization redirect could carry one role per round trip; JWT bearer validation is a server-side mint, so the server iterates whichever roles are configured.
     * @request POST:/api/salesforce/validate/{id}
     */
    validateConnection: (id: string, data: SalesforceInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salesforce
     * @name GenerateJwtCertificate
     * @request POST:/api/salesforce/generateJwtCertificate/{id}/{role}
     */
    generateJwtCertificate: (
      id: string,
      role: SalesforceCredentialRole,
      query?: {
        /** @format int32 */
        validityYears?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalesforceGeneratedCertificateResponseBaseResponse, any>({
        path: `/api/salesforce/generateJwtCertificate/${id}/${role}`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salesforce
     * @name DiscardPendingCertificate
     * @request POST:/api/salesforce/discardPendingCertificate/{id}/{role}
     */
    discardPendingCertificate: (
      id: string,
      role: SalesforceCredentialRole,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce/discardPendingCertificate/${id}/${role}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salesforce
     * @name SaveConnection
     * @request POST:/api/salesforce/save/{id}
     */
    saveConnection: (id: string, data: SalesforceInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salesforce
     * @name GetProductionInstances
     * @request GET:/api/salesforce/productionInstances
     */
    getProductionInstances: (params: RequestParams = {}) =>
      this.request<SalesforceProductionInstanceItemListBaseResponse, any>({
        path: `/api/salesforce/productionInstances`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salesforce
     * @name GetApiVersions
     * @request GET:/api/salesforce/apiVersions
     */
    getApiVersions: (
      query?: {
        serviceUrl?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalesforceApiVersionListBaseResponse, any>({
        path: `/api/salesforce/apiVersions`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salesforce
     * @name GetSObjects
     * @request GET:/api/salesforce/get-sobjects/{connectionId}
     */
    getSObjects: (connectionId: string, params: RequestParams = {}) =>
      this.request<StringStringDictionaryListBaseResponse, any>({
        path: `/api/salesforce/get-sobjects/${connectionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salesforce
     * @name GetChangeTrackableSObjects
     * @request GET:/api/salesforce/get-change-sobjects/{connectionId}
     */
    getChangeTrackableSObjects: (connectionId: string, params: RequestParams = {}) =>
      this.request<StringStringDictionaryListBaseResponse, any>({
        path: `/api/salesforce/get-change-sobjects/${connectionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salesforce
     * @name GetListViews
     * @request GET:/api/salesforce/get-listviews/{connectionId}/{sObject}
     */
    getListViews: (connectionId: string, sObject: string, params: RequestParams = {}) =>
      this.request<StringStringDictionaryListBaseResponse, any>({
        path: `/api/salesforce/get-listviews/${connectionId}/${sObject}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salesforce
     * @name GetSObjectFields
     * @request GET:/api/salesforce/get-sobject-fields/{connectionId}/{sObject}
     */
    getSObjectFields: (connectionId: string, sObject: string, params: RequestParams = {}) =>
      this.request<StringStringDictionaryListBaseResponse, any>({
        path: `/api/salesforce/get-sobject-fields/${connectionId}/${sObject}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salesforce
     * @name GetSObjectMetadata
     * @request GET:/api/salesforce/get-sobject-metadata/{connectionId}/{sObject}
     */
    getSObjectMetadata: (
      connectionId: string,
      sObject: string,
      query?: {
        /** @default false */
        refresh?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalesforceObjectMetadataDtoBaseResponse, any>({
        path: `/api/salesforce/get-sobject-metadata/${connectionId}/${sObject}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salesforce
     * @name BuildSoql
     * @request POST:/api/salesforce/build-soql/{connectionId}
     */
    buildSoql: (
      connectionId: string,
      data: SalesforceBuildSoqlRequest,
      params: RequestParams = {},
    ) =>
      this.request<StringBaseResponse, any>({
        path: `/api/salesforce/build-soql/${connectionId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salesforce
     * @name PreviewSoql
     * @request POST:/api/salesforce/preview-soql/{connectionId}
     */
    previewSoql: (
      connectionId: string,
      data: SalesforceBuildSoqlRequest,
      params: RequestParams = {},
    ) =>
      this.request<SalesforcePreviewDtoBaseResponse, any>({
        path: `/api/salesforce/preview-soql/${connectionId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salesforce
     * @name GetBaseQuery
     * @request GET:/api/salesforce/get-base-query/{connectionId}/{sObject}
     */
    getBaseQuery: (connectionId: string, sObject: string, params: RequestParams = {}) =>
      this.request<StringBaseResponse, any>({
        path: `/api/salesforce/get-base-query/${connectionId}/${sObject}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salesforce
     * @name DescribeSoql
     * @request POST:/api/salesforce/describe-soql/{connectionId}
     */
    describeSoql: (
      connectionId: string,
      data: SalesforceDescribeSoqlRequest,
      params: RequestParams = {},
    ) =>
      this.request<StringStringDictionaryListBaseResponse, any>({
        path: `/api/salesforce/describe-soql/${connectionId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  salesforceChange = {
    /**
     * No description
     *
     * @tags SalesforceChangeDataSource
     * @name Save
     * @request POST:/api/salesforce-change/save
     */
    save: (data: SalesForceChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce-change/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesforceChangeDataSource
     * @name GenerateSoql
     * @request POST:/api/salesforce-change/generate-soql
     */
    generateSoql: (data: SalesForceChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<StringBaseResponse, any>({
        path: `/api/salesforce-change/generate-soql`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesforceChangeDataSource
     * @name GetPreview
     * @request POST:/api/salesforce-change/preview
     */
    getPreview: (data: SalesForceChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/salesforce-change/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesforceChangeDataSource
     * @name Validate
     * @request POST:/api/salesforce-change/validate
     */
    validate: (data: SalesForceChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce-change/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesforceChangeDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/salesforce-change/schema-columns/reload
     */
    reloadSchemaColumns: (data: SalesForceChangeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce-change/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  salesforceDestination = {
    /**
     * No description
     *
     * @tags SalesforceDestination
     * @name GetMapLines
     * @request POST:/api/salesforce-destination/get-destination-lines
     */
    getMapLines: (data: SalesforceDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/salesforce-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesforceDestination
     * @name GetMapLineParameters
     * @request POST:/api/salesforce-destination/get-destination-line-parameters/{mapLineTechnicalName}/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalName: string,
      mapLineTechnicalValue: string,
      data: SalesforceDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/salesforce-destination/get-destination-line-parameters/${mapLineTechnicalName}/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  salesforceQuery = {
    /**
     * No description
     *
     * @tags SalesforceQuerySource
     * @name Save
     * @request POST:/api/salesforce-query/save
     */
    save: (data: SalesForceQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce-query/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesforceQuerySource
     * @name GetPreview
     * @request POST:/api/salesforce-query/preview
     */
    getPreview: (data: SalesForceQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<DataSourcePreviewResponseBaseResponse, any>({
        path: `/api/salesforce-query/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesforceQuerySource
     * @name Validate
     * @request POST:/api/salesforce-query/validate
     */
    validate: (data: SalesForceQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce-query/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesforceQuerySource
     * @name ReloadSchemaColumns
     * @request POST:/api/salesforce-query/schema-columns/reload
     */
    reloadSchemaColumns: (data: SalesForceQueryDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce-query/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  salesforceRealtime = {
    /**
     * No description
     *
     * @tags SalesforceRealTimeDataSource
     * @name Save
     * @request POST:/api/salesforce-realtime/save
     */
    save: (data: SalesForceRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce-realtime/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesforceRealTimeDataSource
     * @name Validate
     * @request POST:/api/salesforce-realtime/validate
     */
    validate: (data: SalesForceRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce-realtime/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesforceRealTimeDataSource
     * @name GetLinkedMaps
     * @request GET:/api/salesforce-realtime/get-linked-maps/{id}
     */
    getLinkedMaps: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce-realtime/get-linked-maps/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesforceRealTimeDataSource
     * @name ReloadSchemaColumns
     * @request POST:/api/salesforce-realtime/schema-columns/reload
     */
    reloadSchemaColumns: (data: SalesForceRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce-realtime/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesforceRealTimeDataSource
     * @name RegisterDataSource
     * @request POST:/api/salesforce-realtime/register-datasource
     */
    registerDataSource: (data: SalesForceRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce-realtime/register-datasource`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesforceRealTimeDataSource
     * @name UnregisterDataSource
     * @request POST:/api/salesforce-realtime/unregister-datasource
     */
    unregisterDataSource: (data: SalesForceRealTimeDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce-realtime/unregister-datasource`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesforceRealTimeDataSource
     * @name GetProvisionState
     * @request GET:/api/salesforce-realtime/provision-state/{id}
     */
    getProvisionState: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/salesforce-realtime/provision-state/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  schedule = {
    /**
     * No description
     *
     * @tags Scheduler
     * @name Get
     * @request GET:/api/schedule
     */
    get: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/schedule`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name GetOptions
     * @request GET:/api/schedule/options
     */
    getOptions: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/schedule/options`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name GetRunActivityForIntegration
     * @request GET:/api/schedule/run-activity/{id}
     */
    getRunActivityForIntegration: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/schedule/run-activity/${id}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name Get2
     * @request GET:/api/schedule/{scheduleId}
     * @originalName get
     * @duplicate
     */
    get2: (scheduleId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/schedule/${scheduleId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name GetExternalSettings
     * @request GET:/api/schedule/external-settings
     */
    getExternalSettings: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/schedule/external-settings`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name Delete
     * @request DELETE:/api/schedule/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/schedule/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name Save
     * @request PATCH:/api/schedule/{id}
     */
    save: (id: string, data: ScheduleRequestDto, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/schedule/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name CreateStub
     * @request POST:/api/schedule/create/{mapKey}
     */
    createStub: (mapKey: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/schedule/create/${mapKey}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name GetScheduleStats
     * @request GET:/api/schedule/getschedulestats/{scheduleId}
     */
    getScheduleStats: (scheduleId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/schedule/getschedulestats/${scheduleId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name SetScheduleState
     * @request GET:/api/schedule/setschedulestate/{id}
     */
    setScheduleState: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/schedule/setschedulestate/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name ExportFileExcel
     * @request GET:/api/schedule/export-to-excel/{id}
     */
    exportFileExcel: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/schedule/export-to-excel/${id}`,
        method: 'GET',
        ...params,
      }),
  };
  id = {
    /**
     * No description
     *
     * @tags ScriptNamespaces
     * @name Get
     * @request GET:/script-namespaces/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<ScriptNamespacesModel, any>({
        path: `/script-namespaces/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ScriptNamespaces
     * @name Delete
     * @request DELETE:/script-namespaces/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/script-namespaces/${id}`,
        method: 'DELETE',
        ...params,
      }),
  };
  loadFromGac = {
    /**
     * No description
     *
     * @tags ScriptNamespaces
     * @name LoadFromGac
     * @request GET:/script-namespaces/load-from-gac/{dllName}
     */
    loadFromGac: (dllName: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/script-namespaces/load-from-gac/${dllName}`,
        method: 'GET',
        ...params,
      }),
  };
  loadFromFile = {
    /**
     * No description
     *
     * @tags ScriptNamespaces
     * @name LoadFromFile
     * @request POST:/script-namespaces/load-from-file/{dllName}
     */
    loadFromFile: (dllName: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/script-namespaces/load-from-file/${dllName}`,
        method: 'POST',
        ...params,
      }),
  };
  security = {
    /**
     * No description
     *
     * @tags Security
     * @name GetSecurityData
     * @request GET:/api/security
     */
    getSecurityData: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/security`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name GetFirewall
     * @request GET:/api/security/firewall/{id}
     */
    getFirewall: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/security/firewall/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SaveFirewall
     * @request PATCH:/api/security/firewall/{id}
     */
    saveFirewall: (id: string, data: FirewallModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/security/firewall/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name DeleteFirewall
     * @request DELETE:/api/security/firewall/{id}
     */
    deleteFirewall: (id: string, params: RequestParams = {}) =>
      this.request<FirewallModelListBaseResponse, any>({
        path: `/api/security/firewall/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name AddRegistration
     * @request POST:/api/security/application-registration
     */
    addRegistration: (data: SaveOAuthClientModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/security/application-registration`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SaveRegistration
     * @request PATCH:/api/security/application-registration/{id}
     */
    saveRegistration: (id: string, data: SaveOAuthClientModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/security/application-registration/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name DeleteRegistration
     * @request DELETE:/api/security/application-registration/{id}
     */
    deleteRegistration: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/security/application-registration/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SaveSecrets
     * @request PATCH:/api/security/application-registration-secrets/{id}
     */
    saveSecrets: (id: string, data: OAuthClientSettingModel[], params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/security/application-registration-secrets/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name DeleteSecret
     * @request DELETE:/api/security/application-registration-secret/{id}
     */
    deleteSecret: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/security/application-registration-secret/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SaveAuditSettings
     * @request POST:/api/security/audit-settings
     */
    saveAuditSettings: (data: AuditSettingModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/security/audit-settings`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SavePasswordPolicy
     * @request POST:/api/security/password-policy
     */
    savePasswordPolicy: (data: PasswordPolicyModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/security/password-policy`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name GetTeamRoles
     * @request POST:/api/security/team-roles
     */
    getTeamRoles: (data: string, params: RequestParams = {}) =>
      this.request<UserRoleModel, any>({
        path: `/api/security/team-roles`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name GetAccount
     * @request GET:/api/security/account
     */
    getAccount: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/security/account`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name UpdateAccount
     * @request POST:/api/security/account
     */
    updateAccount: (data: Account, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/security/account`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  settings = {
    /**
     * No description
     *
     * @tags Settings
     * @name GetBaseUrl
     * @request GET:/api/settings/base-url
     */
    getBaseUrl: (params: RequestParams = {}) =>
      this.request<ObjectBaseResponse, any>({
        path: `/api/settings/base-url`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name GetSettings
     * @request GET:/api/settings
     */
    getSettings: (params: RequestParams = {}) =>
      this.request<SystemSettingDtoBaseResponse, any>({
        path: `/api/settings`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SaveSystemSettings
     * @request PATCH:/api/settings/system-settings
     */
    saveSystemSettings: (data: SettingsModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/settings/system-settings`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name GetGraphConnections
     * @request GET:/api/settings/get-graph-connections
     */
    getGraphConnections: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/settings/get-graph-connections`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  slack = {
    /**
     * No description
     *
     * @tags SlackOdata
     * @name ValidateConnection
     * @request POST:/api/slack/validate/{id}
     */
    validateConnection: (id: string, data: SlackInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/slack/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SlackOdata
     * @name SaveConnection
     * @request POST:/api/slack/save/{id}
     */
    saveConnection: (id: string, data: SlackInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/slack/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SlackOdata
     * @name AuthCallback
     * @request GET:/api/slack/authCallback
     */
    authCallback: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/slack/authCallback`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  systemEvent = {
    /**
     * No description
     *
     * @tags SystemEvent
     * @name GetRecords
     * @request GET:/api/system_event
     */
    getRecords: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/system_event`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemEvent
     * @name GetDetail
     * @request GET:/api/system_event/{id}
     */
    getDetail: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/system_event/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemEvent
     * @name DeleteRecord
     * @request DELETE:/api/system_event/{id}
     */
    deleteRecord: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/system_event/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemEvent
     * @name DeleteSelected
     * @request POST:/api/system_event/delete-selected
     */
    deleteSelected: (data: string[], params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/system_event/delete-selected`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemEvent
     * @name DeleteOlderThan
     * @request DELETE:/api/system_event/older-than
     */
    deleteOlderThan: (
      query?: {
        /** @format date-time */
        olderThan?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/system_event/older-than`,
        method: 'DELETE',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemEvent
     * @name DeleteAll
     * @request DELETE:/api/system_event/all
     */
    deleteAll: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/system_event/all`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemEvent
     * @name GetBanner
     * @request POST:/api/system_event/banner
     */
    getBanner: (params: RequestParams = {}) =>
      this.request<BannerDtoListBaseResponse, any>({
        path: `/api/system_event/banner`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  team = {
    /**
     * No description
     *
     * @tags Team
     * @name Get
     * @request GET:/api/team
     */
    get: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name SaveTeamStub
     * @request POST:/api/team/create-stub
     */
    saveTeamStub: (data: TeamStubRequest, params: RequestParams = {}) =>
      this.request<GuidBaseResponse, any>({
        path: `/api/team/create-stub`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name CheckTeamName
     * @request POST:/api/team/check-name
     */
    checkTeamName: (data: CheckNameRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/check-name`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name GetTeamById
     * @request GET:/api/team/{id}
     */
    getTeamById: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name UpdateTeamById
     * @request PATCH:/api/team/{id}
     */
    updateTeamById: (id: string, data: TeamModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name DeleteTeam
     * @request DELETE:/api/team/{id}
     */
    deleteTeam: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name DeleteTeam2
     * @request DELETE:/api/team/{id}/members/{memberId}
     * @originalName deleteTeam
     * @duplicate
     */
    deleteTeam2: (id: string, memberId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/${id}/members/${memberId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name DuplicateTeam
     * @request POST:/api/team/{id}/duplicate
     */
    duplicateTeam: (id: string, data: TeamStubRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/${id}/duplicate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name GetTeamMembers
     * @request GET:/api/team/{id}/members
     */
    getTeamMembers: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/${id}/members`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name GetTeamMember
     * @request GET:/api/team/member/{email}
     * @deprecated
     */
    getTeamMember: (email: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/member/${email}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name GetTeamMemberByEmail
     * @request POST:/api/team/member
     */
    getTeamMemberByEmail: (data: TeamMemberRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/member`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name GetTeamMembersEmail
     * @request POST:/api/team/{id}/members/email
     */
    getTeamMembersEmail: (id: string, data: string[], params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/${id}/members/email`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name AddTeamMembers
     * @request POST:/api/team/{teamId}/members
     */
    addTeamMembers: (teamId: string, data: string[], params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/${teamId}/members`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name GetTeamConnections
     * @request GET:/api/team/{id}/connections
     */
    getTeamConnections: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/${id}/connections`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name GetTeamConnection
     * @request POST:/api/team/connections/{connectionId}
     */
    getTeamConnection: (connectionId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/connections/${connectionId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name GetTeamConnectionsList
     * @request POST:/api/team/{id}/connections/list
     */
    getTeamConnectionsList: (id: string, data: string[], params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/${id}/connections/list`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name GetTeamRoleTypes
     * @request GET:/api/team/roletypes
     */
    getTeamRoleTypes: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/roletypes`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name GetTeamRoles
     * @request GET:/api/team/{id}/roles
     */
    getTeamRoles: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/${id}/roles`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name GetTeamRolesSchema
     * @request POST:/api/team/{id}/roles/schema
     */
    getTeamRolesSchema: (id: string, data: TeamRoleModel[], params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/${id}/roles/schema`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name SaveTeamRolesSchema
     * @request PATCH:/api/team/{id}/roles/schema
     */
    saveTeamRolesSchema: (id: string, data: TeamRoleRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/${id}/roles/schema`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name GetConnectionTeamRolesSchema
     * @request POST:/api/team/{id}/connection/roles/schema
     */
    getConnectionTeamRolesSchema: (id: string, data: TeamRoleModel[], params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/team/${id}/connection/roles/schema`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  textFileDataSource = {
    /**
     * No description
     *
     * @tags TextFile
     * @name ReloadSchemaColumns
     * @request POST:/api/text-file-data-source/schema-columns/reload
     */
    reloadSchemaColumns: (data: TextFileDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/text-file-data-source/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TextFile
     * @name Save
     * @request POST:/api/text-file-data-source/save
     */
    save: (data: TextFileDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/text-file-data-source/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TextFile
     * @name Validate
     * @request POST:/api/text-file-data-source/validate
     */
    validate: (data: TextFileDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/text-file-data-source/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TextFile
     * @name GetPreview
     * @request POST:/api/text-file-data-source/preview
     */
    getPreview: (data: TextFileDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/text-file-data-source/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TextFile
     * @name DetectFixedColumns
     * @request POST:/api/text-file-data-source/detect-fixed-columns
     */
    detectFixedColumns: (data: TextFileDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/text-file-data-source/detect-fixed-columns`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TextFile
     * @name LoadTextFile
     * @request POST:/api/text-file-data-source/load-file/{fileName}
     */
    loadTextFile: (fileName: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/text-file-data-source/load-file/${fileName}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  textFileDestination = {
    /**
     * No description
     *
     * @tags TextFileDestination
     * @name GetDestinations
     * @request GET:/api/text-file-destination/list
     */
    getDestinations: (params: RequestParams = {}) =>
      this.request<MssqlInstanceModelListBaseResponse, any>({
        path: `/api/text-file-destination/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TextFileDestination
     * @name GetDestinationData
     * @request POST:/api/text-file-destination/get-destination-data
     */
    getDestinationData: (data: TextFileDestinationModel, params: RequestParams = {}) =>
      this.request<SqlObjectListBaseResponse, any>({
        path: `/api/text-file-destination/get-destination-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TextFileDestination
     * @name GetDestinationLines
     * @request GET:/api/text-file-destination/get-destination-lines
     */
    getDestinationLines: (params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/text-file-destination/get-destination-lines`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TextFileDestination
     * @name GetMapLineParameters
     * @request POST:/api/text-file-destination/get-destination-line-parameters/{mapLineTechnicalName}/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalName: string,
      mapLineTechnicalValue: string,
      data: TextFileDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/text-file-destination/get-destination-line-parameters/${mapLineTechnicalName}/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TextFileDestination
     * @name ParseTemplateHeaders
     * @request POST:/api/text-file-destination/parse-template-headers/{fileName}
     */
    parseTemplateHeaders: (
      fileName: string,
      query?: {
        columnSeparator?: TextFileFormat;
        /** @default "" */
        customDelimiter?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/text-file-destination/parse-template-headers/${fileName}`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  textFolder = {
    /**
     * No description
     *
     * @tags TextFolder
     * @name ReloadSchemaColumns
     * @request POST:/api/text-folder/schema-columns/reload
     */
    reloadSchemaColumns: (data: TextFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/text-folder/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TextFolder
     * @name GetPreview
     * @request POST:/api/text-folder/preview
     */
    getPreview: (data: TextFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/text-folder/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TextFolder
     * @name Validate
     * @request POST:/api/text-folder/validate
     */
    validate: (data: TextFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/text-folder/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TextFolder
     * @name LoadTextFile
     * @request POST:/api/text-folder/load-file/{fileName}
     */
    loadTextFile: (fileName: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/text-folder/load-file/${fileName}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TextFolder
     * @name Save
     * @request POST:/api/text-folder/save
     */
    save: (data: TextFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/text-folder/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  translationTable = {
    /**
     * No description
     *
     * @tags TranslationTable
     * @name GetTranslationTables
     * @request GET:/api/translation-table
     */
    getTranslationTables: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/translation-table`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TranslationTable
     * @name Create
     * @request POST:/api/translation-table
     */
    create: (data: CreateTranslationTableModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/translation-table`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TranslationTable
     * @name Save
     * @request PATCH:/api/translation-table
     */
    save: (data: TranslationTableModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/translation-table`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TranslationTable
     * @name GetTranslationTable
     * @request GET:/api/translation-table/{id}
     */
    getTranslationTable: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/translation-table/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TranslationTable
     * @name Delete
     * @request DELETE:/api/translation-table/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/translation-table/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TranslationTable
     * @name CheckName
     * @request POST:/api/translation-table/check-name
     */
    checkName: (data: CheckNameRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/translation-table/check-name`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TranslationTable
     * @name ImportFile
     * @request POST:/api/translation-table/import-file
     */
    importFile: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/translation-table/import-file`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TranslationTable
     * @name ImportFileJson
     * @request POST:/api/translation-table/import-file-json
     */
    importFileJson: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/translation-table/import-file-json`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TranslationTable
     * @name ExportFileExcel
     * @request GET:/api/translation-table/export-file-excel/{id}
     */
    exportFileExcel: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/translation-table/export-file-excel/${id}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TranslationTable
     * @name ExportFileJson
     * @request GET:/api/translation-table/export-file-json/{id}
     */
    exportFileJson: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/translation-table/export-file-json/${id}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TranslationTable
     * @name ImportTranslation
     * @request POST:/api/translation-table/import-translation
     */
    importTranslation: (
      data: {
        /** @format binary */
        file?: File;
        key?: string;
        description?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/translation-table/import-translation`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),
  };
  trello = {
    /**
     * No description
     *
     * @tags TrelloOdata
     * @name ValidateConnection
     * @request POST:/api/trello/validate/{id}
     */
    validateConnection: (id: string, data: TrelloInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/trello/validate/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TrelloOdata
     * @name SaveConnection
     * @request POST:/api/trello/save/{id}
     */
    saveConnection: (id: string, data: TrelloInstanceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/trello/save/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags User
     * @name GetUserById
     * @request GET:/api/user/{id}
     */
    getUserById: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UpdateUserById
     * @request PATCH:/api/user/{id}
     */
    updateUserById: (id: string, data: UserModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetSessionUser
     * @request GET:/api/user/session
     */
    getSessionUser: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/session`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetActiveUsers
     * @request GET:/api/user/active
     */
    getActiveUsers: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/active`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetTimezones
     * @request GET:/api/user/timezones
     */
    getTimezones: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/timezones`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetUser
     * @request GET:/api/user
     */
    getUser: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserAdd
     * @request POST:/api/user/add
     */
    userAdd: (data: UserModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/add`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserSave
     * @request PATCH:/api/user/save
     */
    userSave: (data: UserModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/save`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserExists
     * @request POST:/api/user/exists
     */
    userExists: (data: UserModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/exists`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ClearMfaSecret
     * @request DELETE:/api/user/clear-mfa-secret/{id}
     */
    clearMfaSecret: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/clear-mfa-secret/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name SyncUsers
     * @request GET:/api/user/sync-users
     */
    syncUsers: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/sync-users`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ResetAllPasswords
     * @request POST:/api/user/reset-all-passwords
     */
    resetAllPasswords: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/reset-all-passwords`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ResetPassword
     * @request POST:/api/user/reset-password/{id}
     */
    resetPassword: (id: string, data: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/reset-password/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UpdatePassword
     * @request PATCH:/api/user/password
     */
    updatePassword: (data: UserPasswordModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/password`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetLoginHistory
     * @request GET:/api/user/login-history/{userId}
     */
    getLoginHistory: (userId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/login-history/${userId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UnlockUser
     * @request POST:/api/user/unlock
     */
    unlockUser: (data: UserModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/user/unlock`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  webservicelog = {
    /**
     * No description
     *
     * @tags WebServiceLog
     * @name GetWebServiceRequestLogs
     * @request GET:/api/webservicelog
     */
    getWebServiceRequestLogs: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/webservicelog`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags WebServiceLog
     * @name DeleteLog
     * @request DELETE:/api/webservicelog/{id}
     */
    deleteLog: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/webservicelog/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags WebServiceLog
     * @name Preview
     * @request GET:/api/webservicelog/preview/{id}/{requestName}
     */
    preview: (id: string, requestName: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/webservicelog/preview/${id}/${requestName}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags WebServiceLog
     * @name Export
     * @request GET:/api/webservicelog/export/{id}
     */
    export: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/webservicelog/export/${id}`,
        method: 'GET',
        ...params,
      }),
  };
  webXmlDataSource = {
    /**
     * No description
     *
     * @tags XmlFile
     * @name ReloadSchemaColumns
     * @request POST:/api/web-xml-data-source/schema-columns/reload
     */
    reloadSchemaColumns: (data: XmlDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/web-xml-data-source/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFile
     * @name LoadXmlFile
     * @request POST:/api/web-xml-data-source/load-file/{type}/{fileName}/{fileHolderId}
     */
    loadXmlFile: (
      type: string,
      fileName: string,
      fileHolderId: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/web-xml-data-source/load-file/${type}/${fileName}/${fileHolderId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFile
     * @name RemoveTransformFile
     * @request POST:/api/web-xml-data-source/remove-file/transform/{fileHolderId}
     */
    removeTransformFile: (fileHolderId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/web-xml-data-source/remove-file/transform/${fileHolderId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFile
     * @name Save
     * @request POST:/api/web-xml-data-source/save
     */
    save: (data: XmlDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/web-xml-data-source/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFile
     * @name Validate
     * @request POST:/api/web-xml-data-source/validate
     */
    validate: (data: XmlDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/web-xml-data-source/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFile
     * @name GetPreview
     * @request POST:/api/web-xml-data-source/preview
     */
    getPreview: (data: XmlDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/web-xml-data-source/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFile
     * @name GetSchema
     * @request POST:/api/web-xml-data-source/schema
     */
    getSchema: (data: GetXmlSchemaRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/web-xml-data-source/schema`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  xmlFileDestination = {
    /**
     * No description
     *
     * @tags XmlFileDestination
     * @name GetXmlFormatFromFile
     * @request POST:/api/xml-file-destination/format
     */
    getXmlFormatFromFile: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/xml-file-destination/format`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFileDestination
     * @name GetDestinations
     * @request GET:/api/xml-file-destination/list
     */
    getDestinations: (params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/xml-file-destination/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFileDestination
     * @name GetDestinationData
     * @request POST:/api/xml-file-destination/get-destination-data
     */
    getDestinationData: (data: XmlFileDestinationModel, params: RequestParams = {}) =>
      this.request<SqlObjectListBaseResponse, any>({
        path: `/api/xml-file-destination/get-destination-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFileDestination
     * @name GetDestinationLines
     * @request POST:/api/xml-file-destination/get-destination-lines
     */
    getDestinationLines: (data: XmlFileDestinationModel, params: RequestParams = {}) =>
      this.request<MapLineDtoListBaseResponse, any>({
        path: `/api/xml-file-destination/get-destination-lines`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFileDestination
     * @name GetMapLineParameters
     * @request POST:/api/xml-file-destination/get-destination-line-parameters/{mapLineTechnicalName}/{mapLineTechnicalValue}
     */
    getMapLineParameters: (
      mapLineTechnicalName: string,
      mapLineTechnicalValue: string,
      data: XmlFileDestinationModel,
      params: RequestParams = {},
    ) =>
      this.request<MapLineParameterDtoListBaseResponse, any>({
        path: `/api/xml-file-destination/get-destination-line-parameters/${mapLineTechnicalName}/${mapLineTechnicalValue}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  xmlFolder = {
    /**
     * No description
     *
     * @tags XmlFolder
     * @name GetPreview
     * @request POST:/api/xml-folder/preview
     */
    getPreview: (data: XmlFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/xml-folder/preview`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFolder
     * @name ReloadSchemaColumns
     * @request POST:/api/xml-folder/schema-columns/reload
     */
    reloadSchemaColumns: (data: XmlFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/xml-folder/schema-columns/reload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFolder
     * @name Save
     * @request POST:/api/xml-folder/save
     */
    save: (data: XmlFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/xml-folder/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFolder
     * @name Validate
     * @request POST:/api/xml-folder/validate
     */
    validate: (data: XmlFolderDataSourceModel, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/xml-folder/validate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFolder
     * @name LoadXmlFile
     * @request POST:/api/xml-folder/load-file/{type}/{fileName}/{fileHolderId}
     */
    loadXmlFile: (
      type: string,
      fileName: string,
      fileHolderId: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/api/xml-folder/load-file/${type}/${fileName}/${fileHolderId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags XmlFolder
     * @name RemoveTransformFile
     * @request POST:/api/xml-folder/remove-file/transform/{fileHolderId}
     */
    removeTransformFile: (fileHolderId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/api/xml-folder/remove-file/transform/${fileHolderId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
}
